/*! side-cart v0.0.1 | (c) 2021 STUDIO ZERANCE | http://link-to-your-git-repo.com */
// doT.js
// 2011-2014, Laura Doktorova, https://github.com/olado/doT
// Licensed under the MIT license.

// http://olado.github.io/doT/
// https://github.com/olado/doT

(function () {
	"use strict";

	var doT = {
		name: "doT",
		version: "1.1.1",
		templateSettings: {
			evaluate:    /\{\$([\s\S]+?(\}?)+)\}\}/g,
			interpolate: /\{\$=([\s\S]+?)\}\}/g,
			encode:      /\{\$!([\s\S]+?)\}\}/g,
			use:         /\{\$#([\s\S]+?)\}\}/g,
			useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
			define:      /\{\$##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
			defineParams:/^\s*([\w$]+):([\s\S]+)/,
			conditional: /\{\$\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
			iterate:     /\{\$~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
			varname:	"zerance",
			strip:		true,
			append:		true,
			selfcontained: false,
			doNotSkipEncoded: false
		},
		template: undefined, //fn, compile template
		compile:  undefined, //fn, for express
		log: true
	}, _globals;

	doT.encodeHTMLSource = function(doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	};

	_globals = (function(){ return this || (0,eval)("this"); }());

	/* istanbul ignore else */
	if (typeof module !== "undefined" && module.exports) {
		module.exports = doT;
	} else if (typeof define === "function" && define.amd) {
		define(function(){return doT;});
	} else {
		_globals.doT = doT;
	}

	var startend = {
		append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
		split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
	}, skip = /$^/;

	function resolveDefs(c, block, def) {
		return ((typeof block === "string") ? block : block.toString())
		.replace(c.define || skip, function(m, code, assign, value) {
			if (code.indexOf("def.") === 0) {
				code = code.substring(4);
			}
			if (!(code in def)) {
				if (assign === ":") {
					if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
						def[code] = {arg: param, text: v};
					});
					if (!(code in def)) def[code]= value;
				} else {
					new Function("def", "def['"+code+"']=" + value)(def);
				}
			}
			return "";
		})
		.replace(c.use || skip, function(m, code) {
			if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
				if (def[d] && def[d].arg && param) {
					var rw = (d+":"+param).replace(/'|\\/g, "_");
					def.__exp = def.__exp || {};
					def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
					return s + "def.__exp['"+rw+"']";
				}
			});
			var v = new Function("def", "return " + code)(def);
			return v ? resolveDefs(c, v, def) : v;
		});
	}

	function unescape(code) {
		return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
	}

	doT.template = function(tmpl, c, def) {
		c = c || doT.templateSettings;
		var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
			str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;

		str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
					.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
			.replace(/'|\\/g, "\\$&")
			.replace(c.interpolate || skip, function(m, code) {
				try {
					var expressionParts = code.split(' | ');
					var value = expressionParts[0];

					for (var i=1; i<expressionParts.length; i++) {
						var functionExpression = expressionParts[i];
						var functionParts = functionExpression.split(':');
                      	// Buiuld function arguments
						var functionArgs = functionParts[1]?functionParts[1].split('&&'):[];
							functionArgs.map(arg => unescape(arg).trim());
                      	var functionArgumentsExpression = `(${value}`;
                        for (var j=0; j < functionArgs.length; j++) {
                          functionArgumentsExpression += ', ';
                          functionArgumentsExpression += functionArgs[j];
                        }
                        functionArgumentsExpression += `)`;

                      	// Build function name.
						var functionName = functionParts[0].trim();
                      	var functionNameParts = functionName.split('.');
                        var functionNameExpression = "";
                        for (var k=0; k < functionNameParts.length; k++) {
                            functionNameExpression += `['${functionNameParts[k].trim()}']`
                        }


                      	if (typeof eval(`window${functionNameExpression}`) === 'function')
                          value = `window${functionNameExpression}${functionArgumentsExpression}`;
					}

					return cse.start + unescape(value) + cse.end;
				} catch (e) {
					console.error("Couldn't transform value", e, {code, value});
				}

				return cse.start + unescape(code) + cse.end;
			})
			.replace(c.encode || skip, function(m, code) {
				needhtmlencode = true;
				return cse.startencode + unescape(code) + cse.end;
			})
			.replace(c.conditional || skip, function(m, elsecase, code) {
				return elsecase ?
					(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
					(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
			})
			.replace(c.iterate || skip, function(m, iterate, vname, iname) {
				if (!iterate) return "';} } out+='";
				sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
				return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
					+vname+"=arr"+sid+"["+indv+"+=1];out+='";
			})
			.replace(c.evaluate || skip, function(m, code) {
				return "';" + unescape(code) + "out+='";
			})
			+ "';return out;")
			.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
			.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
			//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

		if (needhtmlencode) {
			if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
			str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
				+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
				+ str;
		}
		try {
			return new Function(c.varname, str);
		} catch (e) {
			/* istanbul ignore else */
			if (typeof console !== "undefined") console.log("Could not create a template function: " + str, c.varname);
			throw e;
		}
	};

	doT.compile = function(tmpl, def) {
		return doT.template(tmpl, null, def);
	};
}());

/* @preserve
    _____ __ _     __                _
   / ___// /(_)___/ /___  ____      (_)___
  / (_ // // // _  // -_)/ __/_    / /(_-<
  \___//_//_/ \_,_/ \__//_/  (_)__/ //___/
                              |___/

  Version: 1.7.4
  Author: Nick Piscitelli (pickykneee)
  Website: https://nickpiscitelli.com
  Documentation: http://nickpiscitelli.github.io/Glider.js
  License: MIT License
  Release Date: October 25th, 2018

*/
!function(e){"function"==typeof define&&define.amd?define(e):"object"==typeof exports?module.exports=e():e()}(function(){var a="undefined"!=typeof window?window:this,e=a.Glider=function(e,t){var i=this;if(e._glider)return e._glider;if(i.ele=e,i.ele.classList.add("glider"),(i.ele._glider=i).opt=Object.assign({},{slidesToScroll:1,slidesToShow:1,resizeLock:!0,duration:.5,easing:function(e,t,i,o,r){return o*(t/=r)*t+i}},t),i.animate_id=i.page=i.slide=0,i.arrows={},i._opt=i.opt,i.opt.skipTrack)i.track=i.ele.children[0];else for(i.track=document.createElement("div"),i.ele.appendChild(i.track);1!==i.ele.children.length;)i.track.appendChild(i.ele.children[0]);i.track.classList.add("glider-track"),i.init(),i.resize=i.init.bind(i,!0),i.event(i.ele,"add",{scroll:i.updateControls.bind(i)}),i.event(a,"add",{resize:i.resize})},t=e.prototype;return t.init=function(e,t){var i=this,o=0,r=0;i.slides=i.track.children,[].forEach.call(i.slides,function(e,t){e.classList.add("glider-slide"),e.setAttribute("data-gslide",t)}),i.containerWidth=i.ele.clientWidth;var s,l=i.settingsBreakpoint();t=t||l,"auto"!==i.opt.slidesToShow&&void 0===i.opt._autoSlide||(s=i.containerWidth/i.opt.itemWidth,i.opt._autoSlide=i.opt.slidesToShow=i.opt.exactWidth?s:Math.floor(s)),"auto"===i.opt.slidesToScroll&&(i.opt.slidesToScroll=Math.floor(i.opt.slidesToShow)),i.itemWidth=i.opt.exactWidth?i.opt.itemWidth:i.containerWidth/i.opt.slidesToShow,[].forEach.call(i.slides,function(e){e.style.height="auto",e.style.width=i.itemWidth+"px",o+=i.itemWidth,r=Math.max(e.offsetHeight,r)}),i.track.style.width=o+"px",i.trackWidth=o,i.isDrag=!1,i.preventClick=!1,i.opt.resizeLock&&i.scrollTo(i.slide*i.itemWidth,0),(l||t)&&(i.bindArrows(),i.buildDots(),i.bindDrag()),i.updateControls(),i.emit(e?"refresh":"loaded")},t.bindDrag=function(){var t=this;t.mouse=t.mouse||t.handleMouse.bind(t);var e=function(){t.mouseDown=void 0,t.ele.classList.remove("drag"),t.isDrag&&(t.preventClick=!0),t.isDrag=!1},e={mouseup:e,mouseleave:e,mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.mouseDown=e.clientX,t.ele.classList.add("drag")},mousemove:t.mouse,click:function(e){t.preventClick&&(e.preventDefault(),e.stopPropagation()),t.preventClick=!1}};t.ele.classList.toggle("draggable",!0===t.opt.draggable),t.event(t.ele,"remove",e),t.opt.draggable&&t.event(t.ele,"add",e)},t.buildDots=function(){var e=this;if(e.opt.dots){if("string"==typeof e.opt.dots?e.dots=document.querySelector(e.opt.dots):e.dots=e.opt.dots,e.dots){e.dots.innerHTML="",e.dots.classList.add("glider-dots");for(var t=0;t<Math.ceil(e.slides.length/e.opt.slidesToShow);++t){var i=document.createElement("button");i.dataset.index=t,i.setAttribute("aria-label","Page "+(t+1)),i.className="glider-dot "+(t?"":"active"),e.event(i,"add",{click:e.scrollItem.bind(e,t,!0)}),e.dots.appendChild(i)}}}else e.dots&&(e.dots.innerHTML="")},t.bindArrows=function(){var i=this;i.opt.arrows?["prev","next"].forEach(function(e){var t=i.opt.arrows[e];t&&("string"==typeof t&&(t=document.querySelector(t)),t&&(t._func=t._func||i.scrollItem.bind(i,e),i.event(t,"remove",{click:t._func}),i.event(t,"add",{click:t._func}),i.arrows[e]=t))}):Object.keys(i.arrows).forEach(function(e){e=i.arrows[e];i.event(e,"remove",{click:e._func})})},t.updateControls=function(e){var n=this;e&&!n.opt.scrollPropagate&&e.stopPropagation();var t=n.containerWidth>=n.trackWidth;n.opt.rewind||(n.arrows.prev&&(n.arrows.prev.classList.toggle("disabled",n.ele.scrollLeft<=0||t),n.arrows.prev.classList.contains("disabled")?n.arrows.prev.setAttribute("aria-disabled",!0):n.arrows.prev.setAttribute("aria-disabled",!1)),n.arrows.next&&(n.arrows.next.classList.toggle("disabled",Math.ceil(n.ele.scrollLeft+n.containerWidth)>=Math.floor(n.trackWidth)||t),n.arrows.next.classList.contains("disabled")?n.arrows.next.setAttribute("aria-disabled",!0):n.arrows.next.setAttribute("aria-disabled",!1))),n.slide=Math.round(n.ele.scrollLeft/n.itemWidth),n.page=Math.round(n.ele.scrollLeft/n.containerWidth);var a=n.slide+Math.floor(Math.floor(n.opt.slidesToShow)/2),d=Math.floor(n.opt.slidesToShow)%2?0:a+1;1===Math.floor(n.opt.slidesToShow)&&(d=0),n.ele.scrollLeft+n.containerWidth>=Math.floor(n.trackWidth)&&(n.page=n.dots?n.dots.children.length-1:0),[].forEach.call(n.slides,function(e,t){var i=e.classList,o=i.contains("visible"),r=n.ele.scrollLeft,s=n.ele.scrollLeft+n.containerWidth,l=n.itemWidth*t,e=l+n.itemWidth;[].forEach.call(i,function(e){/^left|right/.test(e)&&i.remove(e)}),i.toggle("active",n.slide===t),a===t||d&&d===t?i.add("center"):(i.remove("center"),i.add([t<a?"left":"right",Math.abs(t-(!(t<a)&&d||a))].join("-")));s=Math.ceil(l)>=r&&Math.floor(e)<=s;i.toggle("visible",s),s!==o&&n.emit("slide-"+(s?"visible":"hidden"),{slide:t})}),n.dots&&[].forEach.call(n.dots.children,function(e,t){e.classList.toggle("active",n.page===t)}),e&&n.opt.scrollLock&&(clearTimeout(n.scrollLock),n.scrollLock=setTimeout(function(){clearTimeout(n.scrollLock),.02<Math.abs(n.ele.scrollLeft/n.itemWidth-n.slide)&&(n.mouseDown||n.trackWidth>n.containerWidth+n.ele.scrollLeft&&n.scrollItem(n.getCurrentSlide()))},n.opt.scrollLockDelay||250))},t.getCurrentSlide=function(){var e=this;return e.round(e.ele.scrollLeft/e.itemWidth)},t.scrollItem=function(e,t,i){i&&i.preventDefault();var o,r=this,s=e;return++r.animate_id,e=!0===t?(e*=r.containerWidth,Math.round(e/r.itemWidth)*r.itemWidth):("string"==typeof e&&(o="prev"===e,e=r.opt.slidesToScroll%1||r.opt.slidesToShow%1?r.getCurrentSlide():r.slide,o?e-=r.opt.slidesToScroll:e+=r.opt.slidesToScroll,r.opt.rewind&&(i=r.ele.scrollLeft,e=o&&!i?r.slides.length:!o&&i+r.containerWidth>=Math.floor(r.trackWidth)?0:e)),e=Math.max(Math.min(e,r.slides.length),0),r.slide=e,r.itemWidth*e),r.scrollTo(e,r.opt.duration*Math.abs(r.ele.scrollLeft-e),function(){r.updateControls(),r.emit("animated",{value:s,type:"string"==typeof s?"arrow":t?"dot":"slide"})}),!1},t.settingsBreakpoint=function(){var e=this,t=e._opt.responsive;if(t){t.sort(function(e,t){return t.breakpoint-e.breakpoint});for(var i=0;i<t.length;++i){var o=t[i];if(a.innerWidth>=o.breakpoint)return e.breakpoint!==o.breakpoint&&(e.opt=Object.assign({},e._opt,o.settings),e.breakpoint=o.breakpoint,!0)}}var r=0!==e.breakpoint;return e.opt=Object.assign({},e._opt),e.breakpoint=0,r},t.scrollTo=function(t,i,o){var r=this,s=(new Date).getTime(),l=r.animate_id,n=function(){var e=(new Date).getTime()-s;r.ele.scrollLeft=r.ele.scrollLeft+(t-r.ele.scrollLeft)*r.opt.easing(0,e,0,1,i),e<i&&l===r.animate_id?a.requestAnimationFrame(n):(r.ele.scrollLeft=t,o&&o.call(r))};a.requestAnimationFrame(n)},t.removeItem=function(e){var t=this;t.slides.length&&(t.track.removeChild(t.slides[e]),t.refresh(!0),t.emit("remove"))},t.addItem=function(e){this.track.appendChild(e),this.refresh(!0),this.emit("add")},t.handleMouse=function(e){var t=this;t.mouseDown&&(t.isDrag=!0,t.ele.scrollLeft+=(t.mouseDown-e.clientX)*(t.opt.dragVelocity||3.3),t.mouseDown=e.clientX)},t.round=function(e){var t=1/(this.opt.slidesToScroll%1||1);return Math.round(e*t)/t},t.refresh=function(e){this.init(!0,e)},t.setOption=function(t,e){var i=this;i.breakpoint&&!e?i._opt.responsive.forEach(function(e){e.breakpoint===i.breakpoint&&(e.settings=Object.assign({},e.settings,t))}):i._opt=Object.assign({},i._opt,t),i.breakpoint=0,i.settingsBreakpoint()},t.destroy=function(){function e(t){t.removeAttribute("style"),[].forEach.call(t.classList,function(e){/^glider/.test(e)&&t.classList.remove(e)})}var t=this,i=t.ele.cloneNode(!0);i.children[0].outerHTML=i.children[0].innerHTML,e(i),[].forEach.call(i.getElementsByTagName("*"),e),t.ele.parentNode.replaceChild(i,t.ele),t.event(a,"remove",{resize:t.resize}),t.emit("destroy")},t.emit=function(e,t){t=new a.CustomEvent("glider-"+e,{bubbles:!this.opt.eventPropagate,detail:t});this.ele.dispatchEvent(t)},t.event=function(e,t,i){var o=e[t+"EventListener"].bind(e);Object.keys(i).forEach(function(e){o(e,i[e])})},e});

/**
* Helpers
*/
var toolBox = {
  inheritPrototype: function (child, parent) {
    child.prototype = Object.create(parent.prototype);
    Object.defineProperty(child.prototype, "constructor", {
      value: child,
      enumerable: false, // so that it does not appear in 'for in' loop
      writable: true,
    });
  },

  /**
   * Gets the value at `path` of `object`.
   * @param {Object}       object
   * @param {string|Array} path
   * @returns {*} value if exists else undefined
   * ex: toolBox.getProp(options, "question.layout", false);
   */
  getProp: function (object, path, value) {
    const pathArray = Array.isArray(path) ? path : path.split('.').filter(key => key)
    const pathArrayFlat = pathArray.flatMap(part => typeof part === 'string' ? part.split('.') : part);
    const foundValue = pathArrayFlat.reduce((obj, key) => obj && obj[key], object);

    return foundValue || foundValue == false ? foundValue : value;
  },

  /**
   * Verifies if something is empty.
   * if 1 param => value.
   * if 2 params => first is object, second is key.
   */
  isEmpty: function (args) {
    var value = "";

    if (arguments.length == 1)
      value = arguments[0];
    else if (arguments.length == 2) {
      const obj = arguments[0];
      const key = arguments[1];

      value = toolBox.getProp(obj, key);
    }

    if (typeof value === 'undefined')
      return true;
    else if (value === null)
      return true;
    else if (typeof (value) === 'string' && !value.trim().length)
      return true;
    else if (Array.isArray(value) && !value.length)
      return true;
    else if (typeof (value) === 'object' && Object.keys(value).length === 0)
      return true;
    else if (typeof (value) == 'function' || typeof (value) == 'number' || typeof (value) == 'boolean' || Object.prototype.toString.call(value) === '[object Date]')
      return false;

    return false;
  },

  /** Extracts a query params from ur. */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  setCookie: (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },

  getCookie: (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  clearCookie: (name, path, domain) => {
    domain = domain || document.domain;
    path = path || "/";

    if (toolBox.getCookie(name)) {
      document.cookie = name + "=" +
        ((path) ? ";path=" + path : "") +
        ((domain) ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
  },

  /**
   * Recursively merge properties of two objects
   * @param {Object}   defaults default settings
   * @param {Object}   settings user settings that should override the defaults.
   * @param {bool}     isRecursiveCall this is an internal param - SHOULD NOT BE USED BY AN EXTERNAL CALLER.
   * @returns {Object} Merged settings.
   */
  merge: function (defaults, settings, isRecursiveCall) {
    var merged, clonedSettings;
    if (!isRecursiveCall) {
      // Attention, potential data loss with (undefined, new Date(), Infinity, reg expr)
      // => ref: https://stackoverflow.com/a/122704/2517028
      merged = JSON.parse(JSON.stringify(defaults));
      clonedSettings = JSON.parse(JSON.stringify(settings));
    } else {
      merged = defaults;
      clonedSettings = settings;
    }

    for (var p in clonedSettings) {
      try {
        // Property in destination object set; update its value.
        if (clonedSettings[p].constructor == Object)
          merged[p] = MergeRecursive(merged[p], clonedSettings[p], true);
        else
          merged[p] = clonedSettings[p];
      } catch (e) {
        // Property in destination object not set; create it and set its value.
        merged[p] = clonedSettings[p];
      }
    }
    return merged;
  },

  htmlToElement: function (html) {
    var template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
  },

  /**
   * Build template - using DOT.js
   * ref => https://olado.github.io/doT/
   *
   * @param {string}   id the id of the template
   * @param {Object}   config the template config
   * @returns {string} HTML rendered template.
   */
  renderTemplate: function (id, config, def) {
    var tempFn = doT.template(document.getElementById(id).innerHTML, undefined, def);
    return tempFn(config);
  },

  /**
   * Generate a random string.
   * ref => https://stackoverflow.com/a/1349426/2517028
   *
   * @param {int}     length The length of the generated string.
   * @param {Object}  settings
   * @param {string}  settings.prefix
   * @param {string}  settings.postfix
   * @return {string} The generated string.
   */
  makeId: function (length, settings) {
    var result = [];
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    while (result.length <= length)
      result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));

    return `${settings.prefix ? settings.prefix : ""}${result.join('')}${settings.postfix ? settings.postfix : ""}`;
  },

  /**
  * Creates style tag with the specified styles within.
  * The styles are either a string that gets attached directly or an object that gets parsed and then added one by one.
  *
  * @param {object} options        options for the import.
  * @param {String} options.url    styles to add from a URL.
  * @param {String} options.string styles to add directly as a string.
  * ex: options.string: "#root {color: white}"
  * @param {Object} options.object styles object
  * @param {Object} options.object.css_selector = css object.
  * @param {Object} options.object.min_width
  * @param {Object} options.object.max_width
  * ex. {"#xxx .button": "background-color: black; margin: 15px;"}

toolBox.loadStyles({max_width: "600px", object: {
     "#quiz"                       : toolBox.getProp(settings, "css_mobile.root", {}),
     "#quiz .quiz-question__title"  : toolBox.getProp(settings, "css_mobile.question", {}),
     "#quiz .quiz__answer__label"    : toolBox.getProp(settings, "css_mobile.answer", {}),
   }});
  */
  loadStyles: function (options) {
    const style = document.createElement('style');
    style.setAttribute("type", "text/css");
    if (options.id) {
      style.setAttribute("id", options.id);
    }

    if (options.url)
      style.setAttribute("href", options.url);
    else if (options.string)
      style.innerHTML = options.string;
    else if (options.object) {
      const styles = options.object;

      const minWidth = !isNaN(parseInt(options.min_width)) ? options.min_width : false;
      const maxWidth = !isNaN(parseInt(options.max_width)) ? options.max_width : false;
      const isMediaQuery = minWidth || maxWidth;

      style.innerHTML = !isMediaQuery ? "" : `@media screen ${minWidth ? ` and (min-width: ${minWidth}) ` : ``} ${maxWidth ? ` and (max-width: ${maxWidth}) ` : ``} {`;

      for (const selector in styles) {
        const stylesObject = styles[selector];

        // convert JSON styles into CSS string, ref: https://stackoverflow.com/a/45205645/2517028.
        var styleString = (
          Object.entries(stylesObject).map(([k, v]) => {
            var key = k.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);
            var val = key == "background-image" || (key == "background" && v.includes("http")) ? `url(${v})` : v;
            return v && typeof v === 'string' && v.trim() !== "" ? `${key}:${val}` : ""
          }).join(';')
        );

        style.innerHTML += `${selector} { ${styleString} }`
      }

      style.innerHTML += !isMediaQuery ? "" : `}`
    }

    document.getElementsByTagName('head')[0].appendChild(style);
  },

  /**
   * Loads multiple scripts async, by creating a script tag in the head.
   *
   * @param {array}    scripts links of the scripts to create.
   * @param {function} completedCallback a callback indicating all scripts are fully loaded.
   * @param {function} individualSuccessCallback a callback indicating a specific script is loaded, takes {string} param for the url of the script.
   */
  loadScript: function (scripts, completedCallback, individualSuccessCallback) {
    var prot = !document.location.protocol.includes('http') ? "" : ("https:" === document.location.protocol ? "https://" : "http://");

    function checkStateAndCall(path, callback) {
      var _success = false;
      return function () {
        if (!_success && (!this.readyState || (this.readyState == 'complete'))) {
          _success = true;
          individualSuccessCallback(path);
          callback();
        }
      };
    }

    function asyncLoadScripts(files) {
      function loadNext() { // chain element
        if (!files.length) return completedCallback();
        var path = files.shift();
        if (typeof path !== 'string' || path.trim() == "") return completedCallback();

        var scriptElm = document.createElement('script');
        scriptElm.type = 'text/javascript';
        scriptElm.async = true;
        scriptElm.src = prot + path;
        scriptElm.onload = scriptElm.onreadystatechange =
          checkStateAndCall(path, loadNext); // load next file in chain when
        // this one will be ready
        var headElm = document.head || document.getElementsByTagName('head')[0];
        headElm.appendChild(scriptElm);
      }
      loadNext(); // start a chain
    }

    asyncLoadScripts(scripts);
  },

  hasAttribute: function (item, attribute) {
    if (!item.properties)
        return false;

    let itemProperties = JSON.parse(JSON.stringify(item.properties));

    // if (!Array.isArray(itemProperties))
    //     itemProperties = [itemProperties];

    for (let property in itemProperties) {
        if (property == attribute.name && itemProperties[property] == attribute.value)
            return true;
    }

    return false;
  },
  hasTag: function (item, attribute) {
    if (!item.tags)
        return false;

    let itemTags = JSON.parse(JSON.stringify(item.tags));

    for (let tag in itemTags) {
        if (itemTags[tag].indexOf(attribute.value) !== -1)
            return true;
    }

    return false;
  },
  hasTag: function (item, attribute) {
    if (!item.tags)
        return false;

    let itemTags = JSON.parse(JSON.stringify(item.tags));

    for (let tag in itemTags) {
        if (itemTags[tag].indexOf(attribute.value) !== -1)
            return true;
    }

    return false;
  },
  debounce: function (func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
};

/*!
 * swiped-events.js - v@version@
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/swiped-events
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 * 
 * 
 * MODIFIED :
 * - Change defaults for data-swipe-threshold=80px & data-swipe-timeout=1000ms
 * - When swiping is cancelled, dispatch : swipe-canceled
 * - While swapping, dispatch : swiping, swiping-left, swiping-right
 */
(function (window, document) {

    'use strict';

    // patch CustomEvent to allow constructor creation (IE/Chrome)
    if (typeof window.CustomEvent !== 'function') {

        window.CustomEvent = function (event, params) {

            params = params || { bubbles: false, cancelable: false, detail: undefined };

            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };

        window.CustomEvent.prototype = window.Event.prototype;
    }

    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);
    document.addEventListener('touchend', handleTouchEnd, false);

    var xDown = null;
    var yDown = null;
    var xDiff = null;
    var yDiff = null;
    var timeDown = null;
    var startEl = null;

    function cancelSwipe() {
        if (!startEl)
            return;

        // dispatch event.
        startEl.dispatchEvent(new CustomEvent('swipe-canceled', { bubbles: true, cancelable: true, detail: {} }));

        // reset values
        xDown = null;
        yDown = null;
        timeDown = null;
        startEl = null;
    }  

    function getSwipeDirection() {
        var direction = '';

        var swipeThreshold = parseInt(getNearestAttribute(startEl, 'data-swipe-threshold', '80'), 10); // default 20px
        var swipeTimeout = parseInt(getNearestAttribute(startEl, 'data-swipe-timeout', '1000'), 10);    // default 500ms
        var timeDiff = Date.now() - timeDown;

        if (Math.abs(xDiff) > Math.abs(yDiff)) { // most significant
            if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                if (xDiff > 0) {
                    direction = 'left';
                }
                else {
                    direction = 'right';
                }
            }
        }
        else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
            if (yDiff > 0) {
                direction = 'up';
            }
            else {
                direction = 'down';
            }
        }

        return direction;
    }

    function dispatchEvents(e, direction, prefix) {
        if (startEl !== e.target)
            return;

        var changedTouches = e.changedTouches || e.touches || [];
        var eventType = prefix + '-' + direction;

        var eventData = {
            dir: direction,
            xStart: parseInt(xDown, 10),
            xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
            yStart: parseInt(yDown, 10),
            yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10)
        };

        // fire `swiped` event event on the element that started the swipe
        startEl.dispatchEvent(new CustomEvent(prefix, { bubbles: true, cancelable: true, detail: eventData }));

        // fire `swiped-dir` event on the element that started the swipe
        startEl.dispatchEvent(new CustomEvent(eventType, { bubbles: true, cancelable: true, detail: eventData }));
    }

    /**
     * Fires swiped event if swipe detected on touchend
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchEnd(e) {

        // if the user released on a different target, cancel!
        if (startEl !== e.target)
            return cancelSwipe();

        var direction = getSwipeDirection();

        if (direction !== '') {
            dispatchEvents(e, direction, 'swiped')
        } else
            cancelSwipe();
    }

    /**
     * Records current location on touchstart event
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchStart(e) {

        // if the element has data-swipe-ignore="true" we stop listening for swipe events
        if (e.target.getAttribute('data-swipe-ignore') === 'true') return;

        // cancel all ongoing swipes.
        if (startEl)
            cancelSwipe();

        startEl = e.target;

        timeDown = Date.now();
        xDown = e.touches[0].clientX;
        yDown = e.touches[0].clientY;
        xDiff = 0;
        yDiff = 0;
    }

    /**
     * Records location diff in px on touchmove event
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchMove(e) {

        if (!xDown || !yDown) return;

        var xUp = e.touches[0].clientX;
        var yUp = e.touches[0].clientY;

        xDiff = xDown - xUp;
        yDiff = yDown - yUp;

        var direction = getSwipeDirection();

        if (direction === '') return;
        
        dispatchEvents(e, direction, 'swiping')
    }

    /**
     * Gets attribute off HTML element or nearest parent
     * @param {object} el - HTML element to retrieve attribute from
     * @param {string} attributeName - name of the attribute
     * @param {any} defaultValue - default value to return if no match found
     * @returns {any} attribute value or defaultValue
     */
    function getNearestAttribute(el, attributeName, defaultValue) {

        // walk up the dom tree looking for data-action and data-trigger
        while (el && el !== document.documentElement) {

            var attributeValue = el.getAttribute(attributeName);

            if (attributeValue) {
                return attributeValue;
            }

            el = el.parentNode;
        }

        return defaultValue;
    }

}(window, document));
var ZDOM = (function () {

	'use strict';

	/**
	 * Create the constructor
	 * @param {String} selector The selector to use
	 */
	var Constructor = function (selector) {
		if (!selector) {
			this.elems = arrayToNodeList([]);
		} else if (selector === 'document') {
			this.elems = [document];
		} else if (selector === 'window') {
			this.elems = [window];
		} else if (typeof selector === 'string') {
			this.elems = document.querySelectorAll(selector);
		} else if (selector instanceof NodeList) {
			this.elems = selector
		} else if (selector instanceof Element) {
			this.elems = [selector]
		} else if (selector instanceof DocumentFragment) {
			this.elems = selector.querySelectorAll('*');
		} else this.elems = arrayToNodeList([])
	};

	/**
	 * Do ajax stuff
	 * @param  {String} url The URL to get
	 */
	Constructor.prototype.ajax = function (url) {
		// Do some XHR/Fetch thing here
		console.log(url);
	};

	/**
	 * Run a callback on each item
	 * @param  {Function} callback The callback function to run
	 */
	Constructor.prototype.each = function (callback) {
		if (!callback || typeof callback !== 'function') return;
		for (var i = 0; i < this.elems.length; i++) {
			callback(this.elems[i], i);
		}
		return this;
	};

	Constructor.prototype.find = function (selector) {
		var foundItems = [];

		// Find elements.
		this.each(item => {
			var temp = item.querySelectorAll(selector)
			// document.querySelectorAll() returns an "array-like" collection of elements
			// convert this "array-like" collection to an array
			temp = Array.prototype.slice.call(temp);
			foundItems = foundItems.concat(temp);
		});

		// Convert to nodelist
		var fragment = document.createDocumentFragment();
		foundItems.forEach(function(item){
			fragment.appendChild(item.cloneNode());
		});

		return instantiate(arrayToNodeList(foundItems));
	};

	// get dom element at index or null
	Constructor.prototype.get = function(index) {
		if (index > this.elems.length - 1 || index < 0)
			return null;
		return this.elems[index];
	}

	Constructor.prototype.isEmpty = function () {
		return !!!this.elems.length;
	}

	/**
	 * Add a class to elements
	 * @param {String} className The class name
	 */
	Constructor.prototype.addClass = function () {
		return this.each(item => item.classList.add(...arguments));
	};

	/**
	 * Remove a class to elements
	 * @param {String} className The class name
	 */
	Constructor.prototype.removeClass = function () {
		return this.each(item => item.classList.remove(...arguments));
	};

	Constructor.prototype.toggleClass = function (className) {
		return this.each(item => item.classList.toggle(className));
	};
	  
	Constructor.prototype.hasClass = function(className) {
		for (var i = 0; i < this.elems.length; i++) {
			if (!this.elems[i].classList.contains(className))
				return false;
		}
		return true;
	}

  	/**
	 * Attach event to an element.
	 * @param {String} className The class name
	 */
	Constructor.prototype.on = function (eventType, callback) {
		// Attach event listeners to each element. 
		this.each(item => item.addEventListener(eventType, callback));

		// Store event handler for future ref. (in off for example)
		this.events = this.events || {};
		this.events[eventType] = this.events[eventType] || [];
		this.events[eventType].push(callback);

		return this;
	};

	/**
	 * Detaches event from an element.
	 * @param {String} className The class name
	 */
	Constructor.prototype.off = function (eventType, callback) {
		let self = this;

		if (callback) {
			this.each(item => item.removeEventListener(eventType, callback));
		} else if (self.events[eventType]) {
			this.each(item => {
				const cbArray = self.events[eventType];
				for (let cb of cbArray) {
					item.removeEventListener(eventType, cb);
				}
			})
		}

		return self;
	};

	/**
	 * Deletes an element from the dom
	 * @param {String} className The class name
	 */
	Constructor.prototype.remove = function () {
		this.each(item => {
			// const parent = item.parentNode;
			// parent.remove(item);

			item.remove();
		});

		return this;
	};

	/**
	 * Detaches event from an element.
	 * @param {String} className The class name
	 */
	Constructor.prototype.off = function (eventType, callback) {
		return this.each(item => item.removeEventListener(eventType, callback));
	};

	var arrayToNodeList = (items) => {
		// Convert to nodelist
		var fragment = document.createDocumentFragment();
		items.forEach(function(item){
			fragment.appendChild(item.cloneNode());
		});

		return fragment.querySelectorAll('*');;
	}

	/**
	 * Instantiate a new constructor
	 */
	var instantiate = function (selector) {
		return new Constructor(selector);
	};

	/**
	 * Return the constructor instantiation
	 */
	return instantiate;
})();
window.__ascf = {
  capitalize(value) {
    if (!value) return ''
    value = value.charAt(0).toUpperCase() + value.slice(1);
    return value
  },

  priceFormatter(value) {
    if (!value) return ''
    value = value / 100
    value = parseFloat(value).toFixed(2).toString().replace('.', ',') + ' €'
    return value
  },

  cleanJson(value) {
    if (!value) return ''
    value = value.replace(/\n/g, " ")
    return value
  },

  priceFormatterWithDiscount(value, discount) {
    if (!value) return ''
    discount = (100 - discount) * 0.01;
    value = value * discount;
    value = Math.round((value + Number.EPSILON) * 100) / 100;
    value = parseFloat(value).toFixed(2).toString().replace('.', ',') + ' €'
    return value
  },

  currencyFormatter(currency) {
    if (!currency) return ''
    if (currency === 'eur') { currency = '€' }
    if (currency === 'usd') { currency = '$' }
    if (currency === 'cad') { currency = '$CAD' }
    if (currency === 'chf') { currency = 'CHF' }
    return currency
  },

  dateUnitFormatter(unit) {
    if (!unit) return ''
    if (unit.toLowerCase() === 'day') { unit = 'jours' }
    if (unit.toLowerCase() === 'days') { unit = 'jours' }
    if (unit.toLowerCase() === 'week') { unit = 'semaines' }
    if (unit.toLowerCase() === 'weeks') { unit = 'semaines' }
    if (unit.toLowerCase() === 'month') { unit = 'mois' }
    if (unit.toLowerCase() === 'months') { unit = 'mois' }
    if (unit.toLowerCase() === 'year') { unit = 'années' }
    if (unit.toLowerCase() === 'years') { unit = 'années' }
    return unit
  },

  toSingular(unit) {
    if (!unit) return ''
    unit = unit.substring(0, unit.length - +(unit.lastIndexOf('s') == unit.length - 1));
    return unit
  },

  dateFormatterLong(date) {
    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    var d = new Date(date),
      month = monthNames[d.getMonth()],
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (day.length < 2)
      day = '0' + day;
    date = day + ' ' + month + ' ' + year
    return date
  },

  dateTimeFormatter(date) {
    var output = "";

    var d = new Date(date),
      sec = '' + d.getSeconds(),
      min = '' + (d.getMinutes()),
      day = '' + d.getDate(),
      hour = '' + (d.getHours()),
      month = '' + (d.getMonth() + 1),
      year = '' + d.getFullYear();

    month = (month.length < 2 ? '0' : '') + month;
    day = (day.length < 2 ? '0' : '') + day;

    //  if (general_config.date_format === "yyyy-mm-dd") { date = [year, month, day].join('-') }
    //  else if (general_config.date_format === "dd-mm-yyyy") { date = [day, month, year].join('-') }
    //  else if (general_config.date_format === "dd/mm/yyyy") { date = [day, month, year].join('/') }
    //  else if (general_config.date_time_format === "yyyy-mm-dd hh:mm") { date = [year, month, day].join('-') + ' ' + [hour, min].join(':') }
    //  else 
    if (general_config.date_format)
      date = general_config.date_format
        .replace('yyyy', year)
        .replace('dd', day)
        .replace('mm', month) // first mm should be replaced by month.
        .replace('hh', hour)
        .replace('mm', min) // second mm should be replaced by minute.
        .replace('ss', sec) // second mm should be replaced by minute.
    else
      output = d.toISOString();

    return output
  },
  // Ref: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
  formatMoney : function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_formats);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'default':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'without_trailing_zeros':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'without_trailing_zeros_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  },
  replace : function (str, toReplace, replaceWith) {
    return str.replace(toReplace, replaceWith);
  }
}

var shopifyProduct = new (function () {

    var productsList = {};

    /**
     * Init a new product object
     *
     * @param {string} handle              The handle of the product.
     * @param {object} options             The metafields that shouold be attached to the product.
     * @param {object} options.metafields  The metafields objects.
     */
    function Product(handle, options) {
        // Input is the handle.
        if (typeof handle === 'string')
            this.handle = handle;
        else
            return console.error("Product input should be either the handle of the product");

        this.metafields = (options && typeof options.metafields === 'object') ? options.metafields :{};

        this.product = new Promise(async function(resolve, reject) {
          let product = productsList[this.handle];

          if(!product) {
            product = await this.fetch(this.handle);
            productsList[this.handle] = product;
          }

          product = this.prepProduct(product);
          resolve(product);
        }.bind(this));
    }

    Product.prototype.getProduct = async function () {
      return await this.product;
    }


    Product.prototype.findVariantIdFromOptions = async function (selectionOptionsArray) {
        for (let variant of this.product.variants) {
            let selectionOptionsStr = selectionOptionsArray.join(',').toLowerCase();
            let variantOptionsStr = variant.options.join(',').toLowerCase();
            if (selectionOptionsStr == variantOptionsStr)
              return variant.id;
        }

        return null;
    }

    Product.prototype.findVariantFromOptions = async function (selectionOptionsArray) {
        if (this.product instanceof Promise)
          this.product = await this.product;

        for (let variant of this.product.variants) {
            let selectionOptionsStr = selectionOptionsArray.join(',').toLowerCase();
            let variantOptionsStr = variant.options.join(',').toLowerCase();
            if (selectionOptionsStr == variantOptionsStr)
              return variant;
        }

        return null;
    }

    Product.prototype.findVariantIdFromForm = async function (form) {
        var options = [];
        for (var i=0; i <3; i++) {
            var input = form.querySelector(`[name='option-${i}']`);
            var value = null;
            if (!input) continue;

            if (input.type && (input.type.toLowerCase() == 'radio' || input.type.toLowerCase() == 'checkbox'))
                value = form.querySelector(`[name='option-${i}']:checked`).value;
            else value = input.value;

            options.push(value);
        }

        return this.findVariantIdFromOptions(options);
    }

    Product.prototype.prepProduct = function (product) {
        for (let i=0; i< product.options.length ; i++) {
            let option = product.options[i];
            option.values = [];
            // option = {name: 'size', position: 1}

            let positionIndex0 = option.position - 1;

            for (let variant of product.variants) {
              let variantOption = variant.options[positionIndex0];
              if (!option.values.includes(variantOption))
                option.values.push(variantOption);
            }
        }

        // Add metafields.
        product.metafields = this.metafields;

        return product;
    }

    Product.prototype.fetch = async function (handle) {
      var result = await fetch(`/products/${this.handle}.js`);
      return await result.json();
    }

    return Product;
})();


/**
 * Pourquoi utiliser cette utilité :
 * Car il permet de
 * - Recup le produit
 * - Agencer la proprité "options" pour facilité l'utilisation en JS.
 * - Extraire l'iD de la variante avac les options selectionées.
 *
 *
 * Ex sans :
 * va myProduct = await (await fetch(`/products/${this.handle}.js`)).json();
 * console.log(myProduct.options);
 *
 * utilisation basic :
 * Aller sur : https://balzac-paris.fr/products/robe-zina-bleu-midi
 * Dans le console :
 *
 * var myProduct1 = new shopifyProduct('robe-zina-bleu-midi') // 'robe-zina-bleu-midi' = le handle du produit.
 * // Attendre un peu que le produit soit chargé puis :
 * console.log("My product :", myProduct1.product)
 * myProduct1.findVariantIdFromOptions(["40", "blue"]) // => 36468235501718
 * // Pour recup l'id directement depuis un form, il faut que les input (text, radio, checkbox) soit nommés : option-0 | option-1 | option-2
 * // Donc cet exemple ne marchera pas sur balzac car leur formulaire manque un input pour l'option 2 (option-2)
 * myProduct1.findVariantIdFromForm(document.querySelector('[data-product-form]')) // => null
 * // Mais idealement (si on construit le form en bonne structure):
 * myProduct1.findVariantIdFromForm(document.querySelector('[data-product-form]')) // => 36468235501718
 *
 *
 * utilisation Options :
 *
 * Options :
 * var options = {
 *      "metafields": {
 *          "namespace1": {
 *              "key1": "value",
 *              "key2": "value"
 *          },
 *          "namespace2": {
 *              "key1": "value",
 *              "key2": "value"
 *          }
 *      }
 *      "callback" : function (product) {
 *          console.log("Here is my product", product);
 *      }
 * }
 *
 * var myProduct1 = new shopifyProduct('robe-zina-bleu-midi', options)
 * // Dans le console, le produit sera logged depuis callback
 * // et donc : product.metafields dois correspondre à options.metafields.
 *
 */

//blocks
var generic_cart_block = new (function () {

    /**
     * ...
     * cartManager   {obj}        ref to the cart manager.
     * eventhandlers {array<obj>} ref les events a set/destroy
     * eventhandlers[n].handler {function} the event handler.
     * eventhandlers[n].event {string} the dom event
     * eventhandlers[n].$ele {string} ZDOM elements.
     */
    function GCB (cartManager, blockSettings, eventHandlers, isCartDependant) {
      // Indicates whether the block should be pinned (top or bottom) or not.
      var pinLocation = (toolBox.getProp(blockSettings, "pin_location", "") + "").toLowerCase();
      if (pinLocation === 'top')
        this.pin_top = true;
      else if (pinLocation === 'bottom')
        this.pin_bottom = true;

      // Block type
      this.type = blockSettings.block_type;

      // Will be set by the cart manager.
      this.money_formats = cartManager.money_formats;

      // Specify if it should be updated when cart is updated.
      this.cart_dependant = isCartDependant;

      // Reference to the cart manager.
      this.cartManager = cartManager;

      // Save settings locally.
      this.settings = blockSettings;

      // Generate the block ID.
      this.block_id = toolBox.makeId(10, {prefix:"block_"});

      // A reference to indicate whether the block is rendered.
      this.is_rendered = false;

      // A reference to all events handlers.
      this.events_handlers = eventHandlers;
    }

    GCB.prototype.getHtml = function () {
      console.log("Each block will have its own implementation of this function");
    }

    GCB.prototype.eventsHandler = function (status) {
      let verb = status?'on':'off';
      for (const eh of this.events_handlers) {
        ZDOM(eh.$ele?eh.$ele:`#${this.block_id}`)[verb](eh.event, eh.handler.bind(this));
      }
    }

    GCB.prototype.destroy = function () {
      // Execute custom destroyer if found.
      if (this.on_destroy && typeof this.on_destroy === "function")
        this.on_destroy();

      this.is_rendered = false;

      // Unlink event listners
      this.eventsHandler(false);

      // Remove block from the dom.
      if (this.is_rendered)
        ZDOM('#' + this.block_id).remove();

      this.is_rendered = false;
      this.block_id    = undefined;
    }

    GCB.prototype.markAsRendered = async function () {
      if (this.on_rendered && typeof this.on_rendered === "function")
        await this.on_rendered();

      this.eventsHandler(true);
      this.is_rendered = true;
    }

    GCB.prototype.updateBlock = async function () {
      if (!this.is_rendered) return;

      // Unlink event listners
      this.eventsHandler(false);

      if (typeof this.on_updated === 'function')
        await this.on_updated();
      else {
        var html = await this.getHtml();
        var oldBlock = document.getElementById(this.block_id);
        var newBlock = toolBox.htmlToElement(html);
        // update dom.
        oldBlock.parentNode.replaceChild(newBlock, oldBlock);
      }

      // Relink event listners
      this.eventsHandler(true);
    }

    return GCB;
})();

// Generic controller.
const ItemManager = new (function () {
  /**
   *
   * @param {string} key     Cart line item as is.
   * @param {object} options Options as provided in the JSON config
   * @param {*} cart         The entire cart object
   */
  function Item(key, options, itemsManager, injections, eventHandlers) {
    // Will be set by the cart manager.
    this.money_formats = itemsManager.cartManager.money_formats;

    this.itemsManager = itemsManager;

    // Reference to the cart manager.
    this.cartManager = itemsManager.cartManager;

    // Save options locally.
    this.options = options;

    // Save item key to be able to fetch it later.
    this.key = key;

    // Build product
    let lineItem = itemsManager.getItemByKey(this.key);
    // this.productHandler = new shopifyProduct(lineItem.handle);

    // Generate the block ID.
    this.block_id = toolBox.makeId(10, { prefix: "line-item_" });

    // Injections templates
    this.block_attributes = injections.block_attributes.template;
    this.quantity_template = injections.quantity.template;
    this.remove_template = injections.remove.template;
    this.remove_label = injections.remove_label;

    // Injections data
    this.injections_data = {};
    for (let key in injections) {
      let injection = injections[key]
      this.injections_data = {
        ...injection.template_data,
        ...this.injections_data
      }
    }

    // A reference to all events handlers.
    let defaultEventHandlers = [
      {
        event: "swiping-left",
        handler: swipingLeft.bind(this)
      },
      {
        event: "swiping-right",
        handler: swipingRight.bind(this)
      },
      {
        event: "swiped-left",
        handler: swipingLeft.bind(this)
      },
      {
        event: "swiped-right",
        handler: swipingRight.bind(this)
      },
      {
        event: "swipe-canceled",
        handler: cancelSwiping.bind(this)
      }
    ];

    this.events_handlers = Array.isArray(eventHandlers) ? eventHandlers.concat(defaultEventHandlers) : defaultEventHandlers;
  }

  Item.prototype.eventsHandler = function (status) {
    var verb = status === true ? 'on' : 'off';
    for (const eh of this.events_handlers) {
      ZDOM(eh.$ele ? eh.$ele : `#${this.block_id}`)[verb](eh.event, eh.handler.bind(this))
    }
  }

  Item.prototype.getGroupHeadingHtml = function () {
    console.log("item.getTitleHtml should be implemented by each extender");
  }

  Item.prototype.getItemHtml = function () {
    console.log("item.getItemHtml should be implemented by each extender");
  }

  Item.prototype.markAsRendered = function () {
    this.eventsHandler(true);
    this.is_rendered = true;
  }

  Item.prototype.destroy = function () {
    if (!this.is_rendered)
      return;

    // Execute custom destroyer if found.
    if (this.on_destroy && typeof this.on_destroy === "function")
      this.on_destroy();

    // Unlink event listners
    this.eventsHandler(false);

    // Remove block from the dom.
    ZDOM('#' + this.block_id).remove();

    this.block_id = undefined;
  }

  // Display error message on item
  Item.prototype.handleError = function (message) {
    // TODO
  }

  /*********************************/
  /* PUBLIC STATIC FUNCTIONS       */
  /*********************************/

  // Check if a line_item is eligible to be of this type.
  // @returns a priority indicator.
  // if -1, the item is not of this type.
  // else if > -1 it should assigned the type of the highest priority
  Item.is = function (line_item, line_items) {
    console.log("item.is should be implemented by each extender");
    return -1;
  }

  /*********************************/
  /* PRIVATE FUNCTIONS       */
  /*********************************/
  function swiping(e, removeClass, addClass) {
    if (!e.target)
      return;

    let xStart = e.detail.xStart;
    let xEnd   = e.detail.xEnd;

    let diff = Math.abs(xEnd - xStart);
    var distance = Math.min(Math.round(diff/40), 4);

    var $item = ZDOM(`#${this.block_id}`);

    if ($item.hasClass('swiping-distance-4') && $item.hasClass(addClass))
      return;

    $item.removeClass(removeClass, 'swiping-distance-1', 'swiping-distance-2', 'swiping-distance-3', 'swiping-distance-4' )
    $item.addClass('swiping', addClass, `swiping-distance-${distance}`);

    cleanSwipingClasses.bind(this)();
  }

  function swipingRight (e) {
    swiping.bind(this)(e, 'swiping--left', 'swiping--right')
  }

  function swipingLeft (e) {
    swiping.bind(this)(e, 'swiping--right', 'swiping--left')
  }

  function cancelSwiping (e) {
    var $item = ZDOM(`#${this.block_id}`);
    if ($item.hasClass('swiping-distance-4'))
      return;

    $item.removeClass('swiping', 'swiping--left', 'swiping--right', 'swiping-distance-1', 'swiping-distance-2', 'swiping-distance-3', 'swiping-distance-4' )
  }

  function cleanSwipingClasses () {
    if (this.cleanSwipingID)
      clearTimeout(this.cleanSwipingID);

    this.cleanSwipingID = setTimeout(cancelSwiping.bind(this), 400);
  }

  return Item;
})();

var item_types = item_types || {};

item_types.basic = new (function () {

    var selectors = {
      "subscription_popup_trigger"   : "[scz-cart-popup-trigger-subscription]",
      "update_popup_trigger"    : "[scz-cart-popup-trigger-update]",
      "popup_product_handle"    : "scz-cart-popup-product-handle"
    }

    function Item(key, options, itemsManager, injections) {
      ItemManager.call(this, key, options, itemsManager, injections, [
        {
          event: "click",
          handler: this.buildSubscriptionPopup.bind(this)
        },
        {
          event: "click",
          handler: this.buildUpdatePopup.bind(this)
        }
      ]);
    }

    toolBox.inheritPrototype(Item, ItemManager);

    Item.prototype.getHtml = function () {
      let lineItem = this.itemsManager.getItemByKey(this.key);

      let data = {
        id        : this.block_id,
        money_formats : this.money_formats,
        options   : this.options,
        line_item : lineItem,
        ...this.injections_data
      };

      return toolBox.renderTemplate(
        this.cartManager.templatesSelectors.basic_item
        , data
        , {
          block_attributes: this.block_attributes ,
          quantity_template: this.quantity_template,
          remove_template: this.remove_template,
          remove_label: this.remove_label
        }
      );
    }

    Item.prototype.buildSubscriptionPopup = function (e) {
      if (!e.target || !e.target.matches(selectors.subscription_popup_trigger)) return;

      let conversionOptions = toolBox.getProp(this.options, "popupActions.convertSubscription", {});
      if (!conversionOptions.enabled)
        throw new Error("Popup action is not available for this line item");

      var type = 'replace';

      var product_handle = e.target.getAttribute(selectors.popup_product_handle);

      var line_item = this.itemsManager.getItemByKey(this.key);

      var options = {
        enable_quantity: conversionOptions.enable_quantity,
        enable_variants: conversionOptions.enable_variants,
        frequency: conversionOptions.frequency,
        popup_submit_label: conversionOptions.popup_submit_label
      }

      const productPopup = new ProductPopupManager(type, product_handle, line_item, options);
    }

    Item.prototype.buildUpdatePopup = function (e) {

      if (!e.target || !e.target.matches(selectors.update_popup_trigger)) return;

      let updateProductOptions = toolBox.getProp(this.options, "popupActions.update", {});
      if (!updateProductOptions.enabled)
        throw new Error("Popup action is not available for this line item");

      var type = 'update';

      var product_handle = e.target.getAttribute(selectors.popup_product_handle);

      var line_item = this.itemsManager.getItemByKey(this.key);

      var options = {
        enable_quantity: updateProductOptions.enable_quantity,
        enable_variants: updateProductOptions.enable_variants,
        popup_submit_label: updateProductOptions.popup_submit_label
      }

      const productPopup = new ProductPopupManager(type, product_handle, line_item, options);
    }


    /*********************************/
    /* PUBLIC STATIC FUNCTIONS       */
    /*********************************/
    // Every item can be considered a basic item, either because it is or as a fallback in case no other classes match.
    Item.is = function (line_item, cart) {
      return 1;
    }

    return Item;
})();

var item_types = item_types || {};

item_types.native_subscription = new (function () {
 
    function Item(line_item, options, cartManager, blockAttributes) {
      ItemManager.call(this, line_item, options, cartManager, blockAttributes, []);
    } 
  
    toolBox.inheritPrototype(Item, ItemManager);  

    Item.prototype.getHtml = function () {
    //   let itemSettings = {  
    //     id: this.block_id,
    //     block_attributes: this.block_attributes,
    //     item_data: this.line_item,
    //     item_options: this.options 
    //   };
  
    //   return toolBox.renderTemplate(
    //     this.cartManager.templatesSelectors.item
    //     , itemSettings
    //     , { block_attributes: this.block_attributes }
    //   );

        return "Native subscription Item"
    }

    // Every item can be considered to be a classic item. (the most basic form of items)
    Item.is = function (line_item, cart) {
      return -1;
    }
  
    return Item;
})();
var item_types = item_types || {};

item_types.native_recharge = new (function () {
 
    function Item(line_item, options, cartManager, blockAttributes) {
      ItemManager.call(this, line_item, options, cartManager, blockAttributes, []);
    } 
  
    toolBox.inheritPrototype(Item, ItemManager);  

    Item.prototype.getHtml = function () {
    //   let itemSettings = {  
    //     id: this.block_id,
    //     block_attributes: this.block_attributes,
    //     item_data: this.line_item,
    //     item_options: this.options 
    //   };
  
    //   return toolBox.renderTemplate(
    //     this.cartManager.templatesSelectors.item
    //     , itemSettings
    //     , { block_attributes: this.block_attributes }
    //   );

        return "Native recharge Item"
    }

    // Every item can be considered to be a classic item. (the most basic form of items)
    Item.is = function (line_item, cart) {
      return -1;
    }
  
    return Item;
})();
var item_types = item_types || {};

item_types.non_native_recharge = new (function () {

  var selectors = {
    "subscription_remove_trigger"   : "[scz-cart-remove-subscription]",
    "update_popup_trigger"    : "[scz-cart-popup-trigger-update]",
    "popup_product_handle"    : "scz-cart-popup-product-handle"
  }

  function Item(key, options, itemsManager, injections) {
    ItemManager.call(this, key, options, itemsManager, injections, [
      {
        event: "click",
        handler: this.removeSubscription.bind(this)
      },
      {
        event: "click",
        handler: this.buildUpdatePopup.bind(this)
      }
  ]);

    let lineItem = this.itemsManager.getItemByKey(this.key);
    let originalProductHandle = toolBox.getProp(lineItem, "metafields.original_handle", false);
    this.removeSubscriptionEnable = toolBox.getProp(options, "removeSubscription.enabled", false);

    if (!originalProductHandle || !this.removeSubscriptionEnable) return;

    this.vaultKey = 'product_handle-' + originalProductHandle;
    var originalProduct = this.cartManager.getFromVault(this.vaultKey)

    if (originalProduct)
      this.handleProduct(originalProduct);
    else
      fetch(`/products/${originalProductHandle}.js`)
        .then(raw => raw.json())
        .then(this.handleProduct.bind(this));
  }

  toolBox.inheritPrototype(Item, ItemManager);

  Item.prototype.getHtml = function () {
    let lineItem = this.itemsManager.getItemByKey(this.key);

    // TODO: Corriger pour les cas ou il faut pouvoir convertir en abonnement.
    if (!this.original_product && this.removeSubscriptionEnable) {
      this.should_rebuild = true;
      return `<div id="${this.block_id}"><div style="text-align: center;">loading</div></div>`;
    }

    let data = {
      id               : this.block_id,
      money_formats    : this.money_formats,
      options          : this.options,
      line_item        : lineItem,
      original_product : this.original_product,
      original_variant : this.original_variant,
      ...this.injections_data
    };

    return toolBox.renderTemplate(
      this.cartManager.templatesSelectors.non_native_recharge
      , data
      , {
        block_attributes: this.block_attributes ,
        quantity_template: this.quantity_template,
        remove_template: this.remove_template,
        remove_label: this.remove_label
      }
    );
  }

  Item.prototype.removeSubscription = function (e) {
    if (!e.target || !e.target.matches(selectors.subscription_remove_trigger)) return;
    var line_item = this.itemsManager.getItemByKey(this.key);

    this.cartManager.updateItems([
      {
        type: this.cartManager.CART_REQUEST_TYPES.REMOVE,
        items: [{key: this.key}]
      },
      {
        type: this.cartManager.CART_REQUEST_TYPES.ADD,
        items: [{
          id: this.original_variant.id,
          quantity: line_item.quantity
        }]
      }
    ])
  }

  Item.prototype.buildUpdatePopup = function (e) {
    if (!e.target || !e.target.matches(selectors.update_popup_trigger)) return;

    let conversionOptions = toolBox.getProp(this.options, "popupActions.update", {});
    if (!conversionOptions.enabled)
      throw new Error("Popup action is not available for this line item");

    var type = 'updateNonNativeRecharge';

    var product_handle = e.target.getAttribute(selectors.popup_product_handle);

    var line_item = this.itemsManager.getItemByKey(this.key);

    var options = {
      enable_quantity: conversionOptions.enable_quantity,
      enable_variants: conversionOptions.enable_variants,
      frequency: conversionOptions.frequency,
      popup_submit_label: conversionOptions.popup_submit_label
    }

    const productPopup = new ProductPopupManager(type, product_handle, line_item, options);
}

  Item.prototype.handleProduct = function (product) {
    // Save product in the vault.
    this.cartManager.addToVault(this.vaultKey, product);

    // Save product & variant in the instance.
    let lineItem = this.itemsManager.getItemByKey(this.key);

    this.original_product = product;
    this.original_variant = this.original_product.variants.find(variant => JSON.stringify(variant.options).toLowerCase() == JSON.stringify(lineItem.variant_options).toLowerCase());

    // If the cart is already displayed without this item ... rebuild the item line.
    if (this.should_rebuild) {
      if (!document.getElementById(this.block_id)) return;

      // Unlink event listners
      this.eventsHandler(false);

      var html = this.getHtml();
      var oldBlock = document.getElementById(this.block_id);
      var newBlock = toolBox.htmlToElement(html);
      // update dom.
      oldBlock.parentNode.replaceChild(newBlock, oldBlock);

      // Relink event listners
      this.eventsHandler(true);

      this.should_rebuild = false;
    }
  }

  // Every item can be considered to be a classic item. (the most basic form of items)
  Item.is = function (line_item, cart) {
    if(line_item.properties && "subscription_id" in line_item.properties) {
      return 10;
    } else {
      return -1;
    }
  }

  return Item;

})();

var item_types = item_types || {};

item_types.item_adder = new (function () {

  var selectors = {
    "item_adder_trigger"   : "[scz-cart-item-adder]",
    "item_adder_input"   : "[scz-cart-item-adder-input]",
    "item_adder_product_variant"    : "scz-cart-item-adder-product-variant",
    "item_adder_product_price"    : "scz-cart-item-adder-price"
  }

    function Item(key, options, itemsManager, injections) {
      ItemManager.call(this, key, options, itemsManager, injections, [
        {
          event: "change",
          handler: this.addItemAdder.bind(this)
        }
      ]);

      let lineItem = this.itemsManager.getItemByKey(this.key);
      let variantItemAdder = null;
      let variantItemAdderId = null;
      let variantItemAdderPrice = null;
      if (lineItem.tags) {
        for (let tag in lineItem.tags) {
          let _tag = lineItem.tags[tag];
          if (_tag.indexOf(this.options.item_adder.selector) !== -1) {
            variantItemAdder = _tag.replace(this.options.item_adder.selector, '');
            variantItemAdderId = variantItemAdder.split('-')[0];
            variantItemAdderPrice = variantItemAdder.split('-')[1].replace('.', ',');
          }
        }
      }
      this.itemAdderEnable = toolBox.getProp(options, "item_adder.enabled", false);
      if (!variantItemAdder || !this.itemAdderEnable) return;

      this.variantItemAdder = variantItemAdder;
      if (variantItemAdderId)
        this.variantItemAdderId = variantItemAdderId;
      if (variantItemAdderPrice)
        this.variantItemAdderPrice = variantItemAdderPrice;
    }



    toolBox.inheritPrototype(Item, ItemManager);

    Item.prototype.getHtml = function () {
      let lineItem = this.itemsManager.getItemByKey(this.key);

      let data = {
        id        : this.block_id,
        money_formats : this.money_formats,
        options   : this.options,
        line_item : lineItem,
        ...this.injections_data
      };

      if (this.options.item_adder && this.options.item_adder.enabled) {
        data.variantItemAdder = {
          id: this.variantItemAdderId,
          price: this.variantItemAdderPrice
        };
      }

      return toolBox.renderTemplate(
        this.cartManager.templatesSelectors.item_adder_item
        , data
        , {
          block_attributes: this.block_attributes ,
          quantity_template: this.quantity_template,
          remove_template: this.remove_template,
          remove_label: this.remove_label
        }
      );
    }

    Item.prototype.addItemAdder = async function (e) {

      let input = e.target;
      let root = null;

      if (!input || !input.matches(selectors.item_adder_trigger)) return;

      root = input.closest("#" + this.block_id);
      if (!root) return;

      let itemAdderOptions = toolBox.getProp(this.options, "item_adder", {});
      if (!itemAdderOptions.enabled)
        throw new Error("Item adder is not available for this line item");

      var product_variant = input.getAttribute(selectors.item_adder_product_variant);

      var line_item = this.itemsManager.getItemByKey(this.key);

      var cart       = this.cartManager.getCopyOfCart();
      var attribute  = getItemProperty(product_variant);
      var product = cart.items.find(item => toolBox.hasAttribute(item, attribute));

      console.log(line_item);
      console.log(product_variant);

      if (input.checked) {

        let rewardProperty = getItemProperty(product_variant);
        let properties = {};
        properties[rewardProperty.name] = rewardProperty.value;

        let formData = {
          'items': [
            {
              'id': product_variant,
              'quantity': 1,
              'properties': properties
            }
          ]
        };

        let {cart, err} = await this.cartManager.postShopify(formData, this.cartManager.CART_REQUEST_TYPES.ADD);
        if (err) {
          console.log(err);
          updateCheckboxItemAdder();
        }
        else {
          let propertiesLineItem = line_item.properties;
          propertiesLineItem.has_item_adder = true;
          propertiesLineItem.item_adder_variant_id = product_variant;

          let formDataLineItem = {
              key: line_item.key,
              quantity: line_item.quantity,
              properties: propertiesLineItem
          };

          this.cartManager.updateItems([
            {
              type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
              items: [formDataLineItem]
            }
          ])
        }

        function updateCheckboxItemAdder() {
          console.log(input.checked);
          input.checked = false;
          console.log(input.checked);
          console.log('le produit n\'est plus en stock !');
        }

      } else if (!input.checked) {

        let propertiesLineItem = line_item.properties;
        propertiesLineItem.has_item_adder = false;
        propertiesLineItem.item_adder_variant_id = null;

          let formDataLineItem = {
              key: line_item.key,
              quantity: line_item.quantity,
              properties: propertiesLineItem
          };

          let formData = {
              key: product.key,
              quantity: product.quantity - 1
          }

          this.cartManager.updateItems([
            {
              type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
              items: [formDataLineItem]
            },
            {
              type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
              items: [formData]
            }
          ]
        )
      }
    }


    /*********************************/
    /* PUBLIC STATIC FUNCTIONS       */
    /*********************************/
    Item.is = function (line_item, cart) {
      if (isItemAdder(line_item))
        return 100000;
      return -1;
    }

    function isItemAdder(item) {
      let attribute = getItemTag();
      return toolBox.hasTag(item, attribute);
    }

    function getItemTag() {
        return {
            value: `sidecart_item_adder--`
        }
    }

    function getItemProperty(variantId) {
        return {
            name: `__item_added_${variantId}`,
            value: `unlocked`
        }
    }

    return Item;
})();

var item_types = item_types || {};

item_types.item_added = new (function () {

  const domAttributes = {
    item_root: 'data-item-root',
    item_remove_item_added_action: 'scz-cart-remove-item_added-item'
  };

  const selectors = {
    item_root: `[${domAttributes.item_root}]`,
    item_remove_item_added_action: `[${domAttributes.item_remove_item_added_action}]`
  };

    function Item(key, options, itemsManager, injections) {
      ItemManager.call(this, key, options, itemsManager, injections, [
        {
          event: 'click',
          handler: this.removeItemAdded.bind(this)
        }
      ]);
    }

    toolBox.inheritPrototype(Item, ItemManager);

    Item.prototype.getHtml = function () {
      let lineItem = this.itemsManager.getItemByKey(this.key);

      let data = {
        id        : this.block_id,
        money_formats : this.money_formats,
        options   : this.options,
        line_item : lineItem,
        ...this.injections_data
      };

      return toolBox.renderTemplate(
        this.cartManager.templatesSelectors.item_added_item
        , data
        , {
          block_attributes: this.block_attributes ,
          quantity_template: this.quantity_template,
          remove_template: this.remove_template,
          remove_label: this.remove_label
        }
      );
    }

    Item.prototype.removeItemAdded = function (e) {

      if (!e.target || !e.target.matches(selectors.item_remove_item_added_action)) return;

      var actionRemoveReward = e.target.closest(selectors.item_remove_item_added_action);
      var root = actionRemoveReward.closest(selectors.item_root);

      if (!root)
        return;

      var itemAttributes = {};
      try {
        itemAttributes = JSON.parse(root.getAttribute(domAttributes.item_root))
      } catch (e) {
        return;
      }

      var key = itemAttributes.key;

      this.itemsManager.removeItem(key);

      e.stopPropagation();
    }


    /*********************************/
    /* PUBLIC STATIC FUNCTIONS       */
    /*********************************/
    Item.is = function (line_item, cart) {
      if (isItemAdded(line_item, line_item.variant_id))
        return 100000;
      return -1;
    }

    function isItemAdded(item, variantId) {
        let attribute = getItemProperty(variantId);
        return toolBox.hasAttribute(item, attribute);
    }

    function getItemProperty(variantId) {
        return {
            name: `__item_added_${variantId}`,
            value: `unlocked`
        }
    }

    return Item;
})();

// TODO: CAREFUL ... calling a static function from rewards will

var item_types = item_types || {};

item_types.reward = new (function () {

  const domAttributes = {
    item_root: 'data-item-root',
    item_remove_reward_action: 'scz-cart-remove-reward-item'
  };

  const selectors = {
    item_root: `[${domAttributes.item_root}]`,
    item_remove_reward_action: `[${domAttributes.item_remove_reward_action}]`
  };

    function Item(key, options, itemsManager, injections) {
      ItemManager.call(this, key, options, itemsManager, injections, [
        {
          event: 'click',
          handler: this.removeReward.bind(this)
        }
      ]);
    }

    toolBox.inheritPrototype(Item, ItemManager);

    Item.prototype.getHtml = function () {
      let lineItem = this.itemsManager.getItemByKey(this.key);

      let data = {
        id        : this.block_id,
        money_formats : this.money_formats,
        options   : this.options,
        line_item : lineItem,
        ...this.injections_data
      };

      return toolBox.renderTemplate(
        this.cartManager.templatesSelectors.reward_item
        , data
        , {
          block_attributes: this.block_attributes ,
          quantity_template: this.quantity_template,
          remove_template: this.remove_template,
          remove_label: this.remove_label
        }
      );
    }

    Item.prototype.removeReward = function (e) {

      if (!e.target || !e.target.matches(selectors.item_remove_reward_action)) return;

      var actionRemoveReward = e.target.closest(selectors.item_remove_reward_action);
      var root = actionRemoveReward.closest(selectors.item_root);

      if (!root)
        return;

      var itemAttributes = {};
      try {
        itemAttributes = JSON.parse(root.getAttribute(domAttributes.item_root))
      } catch (e) {
        return;
      }

      var key = itemAttributes.key;

      let refusedRewards = this.cartManager.getFromVault('refused_rewards');
      if (!refusedRewards && !Array.isArray(refusedRewards)) {
        this.cartManager.addToVault('refused_rewards', [], true);
        refusedRewards = [];
      }

      var item = this.itemsManager.getItemByKey(key);
      var variant_id = item.variant_id.toString();
      if (!refusedRewards.includes(variant_id)) {
        refusedRewards.push(variant_id);
        this.cartManager.addToVault('refused_rewards', refusedRewards, true);
        this.itemsManager.removeItem(key);
      }

      e.stopPropagation();
    }


    /*********************************/
    /* PUBLIC STATIC FUNCTIONS       */
    /*********************************/
    // A reward item can be detected by checking against the rewards class.
    Item.is = function (line_item, cart) {
      if (block_type && block_type.rewards && block_type.rewards.isRewardItem(line_item, line_item.variant_id))
        return 100000;
      return -1;
    }

    return Item;
})();

var item_types = item_types || {};

item_types.featured_upsell = new (function () {

    function Item(key, options, itemsManager, injections) {
      ItemManager.call(this, key, options, itemsManager, injections, []);
    }

    toolBox.inheritPrototype(Item, ItemManager);

    Item.prototype.getHtml = function () {
      let lineItem = this.itemsManager.getItemByKey(this.key);

      let data = {
        id        : this.block_id,
        money_formats : this.money_formats,
        options   : this.options,
        line_item : lineItem,
        ...this.injections_data
      };

      return toolBox.renderTemplate(
        this.cartManager.templatesSelectors.featured_upsell_item
        , data
        , {
          block_attributes: this.block_attributes ,
          quantity_template: this.quantity_template,
          remove_template: this.remove_template,
          remove_label: this.remove_label
        }
      );
    }


    /*********************************/
    /* PUBLIC STATIC FUNCTIONS       */
    /*********************************/
    // Every item can be considered a basic item, either because it is or as a fallback in case no other classes match.
    Item.is = function (line_item, cart) {
      if(line_item.properties && `_featured_upsell_${line_item.variant_id}` in line_item.properties) {
        return 100000;
      } else {
        return -1;
      }
    }

    return Item;
})();

var block_type = block_type || {};

block_type.header = new (function () {

    var self;

    var domAttributes = {
      open_menu: 'scz-cart-menu-open',
      close_menu: 'scz-cart-menu-close',
      menu: 'scz-cart-menu',
      menu_share: 'scz-cart-menu-share',
      menu_save: 'scz-cart-menu-save'
    }
  
    var domClasses = {
      active_menu: 'scz-cart-header__menu-active'
    };
  
    var selectors = {
      open_menu: `[${domAttributes.open_menu}]`,
      close_menu: `[${domAttributes.close_menu}]`,
      menu: `[${domAttributes.menu}]`,
      menu_share: `[${domAttributes.menu_share}]`,
      menu_save: `[${domAttributes.menu_save}]`
    };

    //Manage Header
    function HeaderManager (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [
        {
          event: 'click',
          handler: toggleMenuHandler
        }
      ], true);
      self = this;
    }

    toolBox.inheritPrototype(HeaderManager, generic_cart_block);


    //TODO détail chaque settings pour template
    HeaderManager.prototype.getHtml = function () {
      let cart = self.cartManager.getCopyOfCart();

      let headerSettings = {
        id: self.block_id,
        money_formats: self.money_formats,
        cart_count: cart.item_count,
        display_cart_count: self.settings.configurations.display_cart_count,
        header_fixed: self.settings.configurations.header_fixed,
        title_position: self.settings.configurations.title_position,
        title: self.settings.configurations.title,
        button_close_display: self.settings.configurations.button_close_display,
        icon_button_close_display: self.settings.configurations.icon_button_close_display,
        display_menu: self.settings.configurations.display_menu,
        menu_share: self.settings.configurations.menu_share,
        menu_save: self.settings.configurations.menu_save,
        menu_contact: self.settings.configurations.menu_contact,
        menu_contact_link: self.settings.configurations.menu_contact_link,
        cartShopify: cart
      };

      return toolBox.renderTemplate(self.cartManager.templatesSelectors.header, headerSettings);
    }

    var toggleMenuHandler = e => {
      var $target = ZDOM(e.target);
      if ($target.isEmpty()) return;
  
      var $menu = ZDOM($target.elems[0].closest(selectors.menu));
      if ($menu.isEmpty()) return;
    
      var shouldOpen = $menu.hasClass(domClasses.active_menu) ? false : true;
  
      if (shouldOpen) {
        $menu.addClass(domClasses.active_menu);
      } else {
        $menu.removeClass(domClasses.active_menu);
      }
  
      e.preventDefault();
      e.stopPropagation();
    }

    return HeaderManager;
  })();

var block_type = block_type || {};

block_type.footer = new (function () {

    var self;

    const selectors = {
      // The slider selectors.
      checkbox                 : '[scz-cart__footer-checkbox]',
      checkboxErrorMessage     : '[scz-cart__footer-checkbox-error]',
      checkout                 : '[scz-cart__footer-checkout]',
    };

    const classes = {
      active   : 'scz-cart-footer-checkbox-error--active'
    };

    //Manage Footer
    function FooterManager (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [
        {
            $ele: selectors.checkout,
            event: 'click',
            handler: checkCheckbox.bind(this)
        }
      ], true);
      self = this;
    }

    toolBox.inheritPrototype(FooterManager, generic_cart_block);

    FooterManager.prototype.getHtml = function () {
      let cart = this.cartManager.getCopyOfCart();
      let data = generateRenderOptions(this.settings, cart);
      console.log("data");
      console.log(data);
      // commonsFilters.priceFormatter(total)

      // Build summary block.
      let summaryHTML = "";
      if (data.summary) {
        let summary = new block_type.summary(this.cartManager, data.summary);
        summaryHTML = summary.getHtml();
        // summary.destroy();
      }

      // Build template
      return toolBox.renderTemplate(this.cartManager.templatesSelectors.footer, data, {
        summary_template: summaryHTML
      });
      // return toolBox.renderTemplate(this.cartManager.templatesSelectors.footer, data);
    }

    const generateRenderOptions = function (block, cart) {
      var options = {
        id: self.block_id,
        money_formats: self.money_formats,
        isFixed: block.configurations.footer_fixed,
        isOnlyDesktop: block.configurations.display_only_desktop,
        isOnlyMobile: block.configurations.display_only_mobile,
        cartIsEmpty: cart.item_count == 0,
        cartShopify: cart,

        // options
        cart: false,
        checkout: false,
        summary: false,
        cgv: false,
        tos: false
      };

      for (let blockOption of block.block_level_options) {
        const optionSettings = toolBox.getProp(blockOption, "settings", {});
        const shouldDisplay  = toolBox.getProp(optionSettings, "enabled", false);
        const optionType     = blockOption.option;

        if (!shouldDisplay || !optionType) continue;

        switch (optionType) {
          case "cart":
            if (!optionSettings.label)
              break;

            var settings = {
              label: optionSettings.label
            };

            if (optionSettings.display_total)
              settings.display_total = optionSettings.display_total
              settings.total = cart.total_price

            options.cart = settings;

            break;
          case "checkout":
            if (!optionSettings.label)
              break;

            var settings = {
              label: optionSettings.label
            };

            if (optionSettings.display_total)
              settings.display_total = optionSettings.display_total
              settings.total = cart.total_price

            options.checkout = settings;
            break;
          case "additional_checkout":
            if (!optionSettings.label)
              break;

            var settings = {
              label: optionSettings.label,
              buttons: content_for_additional_checkout_buttons
            };

            options.additional_checkout = settings;
            break;
          case "checkbox":
            if (!optionSettings.label)
              break;

            var settings = {
              label: optionSettings.label
            };

            if (optionSettings.error)
              settings.error = optionSettings.error

            options.checkbox = settings;
            break;
          case "tos":
            var settings = {
              title: optionSettings.title,
              content: optionSettings.content
            };

            if (optionSettings.number_of_visible_lines > 0)
              settings.number_of_visible_lines = optionSettings.number_of_visible_lines;

            options.tos = settings;
            break;
          case "ps":
              var settings = {
                content: optionSettings.content
              };

              options.ps = settings;
              break;
          default:
            break;
        }
      }

      return options;
    }

    function checkCheckbox(e) {
      let $root = document.querySelector(`#${this.block_id}`);
      if (!$root)
        return;

      let $checkbox = $root.querySelector(selectors.checkbox);

      if ($checkbox) {
        if ($checkbox.checked) {
          return;
        } else {
          $root.querySelector(selectors.checkboxErrorMessage).classList.add(classes.active);
          e.preventDefault();
        }
      } else {
        return;
      }
    }

    return FooterManager;
  })();

var block_type = block_type || {};

block_type.items = new (function () {

  var self;
  var cart_lines = [];
  var itemGroups = {};

  const domAttributes = {
    item_root: 'data-item-root',
    item_quantity_action: 'scz-cart-item-quantity-action'
  };

  const selectors = {
    item_root: `[${domAttributes.item_root}]`,
    item_quantity_action: `[${domAttributes.item_quantity_action}]`
  };

  //Manage Items
  function Items(cartManager, block) {

    const eventHandlers = [
      {
        event: 'click',
        handler: clickEventHandler
      },
      {
        event: 'input',
        handler: changeEventHandler
      }
    ];

    generic_cart_block.call(this, cartManager, block, eventHandlers, true);
    self = this;

    // Identify which types should be grouped.
    for (let itemOptions of self.settings.item_level_options) {
      let itemType = itemOptions.type;
      let isItemHidden = itemOptions.hidden;

      let groupingOptions = toolBox.getProp(itemOptions, "settings.grouping", {});
      if (isItemHidden === true || groupingOptions.enabled !== true || !itemType) continue;

      itemGroups[itemType] = groupingOptions;
    }

    // Dry runs items.
    this.dryItemsInit();
  }

  toolBox.inheritPrototype(Items, generic_cart_block);

  Items.prototype.getHtml = async function () {
    let cart = self.cartManager.getCopyOfCart();

    // Init individual items
    cart_lines = self.initCartItems();

    // Sort items into groups if applicable.
    let itemsByGroups = cart_lines.reduce((result, item) => {
      // Check if there are any group options for this item type.
      let groupOptions = itemGroups[item.type];
      // Add a default value to the group order if not defined.
      if (groupOptions)
        groupOptions.order = isNaN(groupOptions.order)? 1000 : groupOptions.order;

      // The group is either the sorted one based on the item.type or all other groups.
      let groupName = groupOptions?item.type:'default_group';

      // Attach the item to the selected group
      if (!result[groupName])
        result[groupName] = { options: groupOptions, items: [] }
      result[groupName].items.push(item);
      return result;
    }, {});

    // Sort groups according to the group order.
    var sortedGroups = Object
      .keys(itemsByGroups)
      .sort((a,b) => itemsByGroups[a].options.order - itemsByGroups[b].options.order)
      .reduce((result, groupName) => {
        result[groupName] = itemsByGroups[groupName];
        return result;
      }, {})


    let itemsHTML = "";
    // Build Grouped Items First
    for (let groupName in sortedGroups) {
      let groupOptions = sortedGroups[groupName].options;
      let lines = sortedGroups[groupName].items;

      let data = {
        group_name: groupName,
        title : groupOptions? groupOptions.title: undefined,
        subtitle : groupOptions? groupOptions.subtitle: undefined,
        content: "",
        footer: undefined
      }

      for (let line of lines) {
          try {
            data.content += line.getHtml();
          } catch (e) {
            let lineItem = self.getItemByKey(line.key);
            console.error("Couldn't render item", line, e);
            data.content += `<div><center>${lineItem.title} failed to display correctly</center></div>`
          }
      }

      // fallback .. if the group template doesn't exist, only add items.
      if (document.getElementById(this.cartManager.templatesSelectors.items_group))
        itemsHTML += toolBox.renderTemplate(
          this.cartManager.templatesSelectors.items_group
          , data
          , {}
        );
      else
        itemsHTML += data.content;
    }

    // TODO - build html based on groups.
    // for (let line of cart_lines) {
    //   try {
    //     itemsHTML += line.getHtml();
    //   } catch (e) {
    //     let lineItem = self.getItemByKey(line.key);
    //     console.error("Couldn't render item", line, e);
    //     itemsHTML += `<div><center>${lineItem.title} failed to display correctly</center></div>`
    //   }
    // }

    let itemsSettings = {
      id: self.block_id,
      item_count: cart.item_count,
      items_html: itemsHTML,
      remove_template: self.settings.configurations.remove.style,
      cartShopify: cart
    };

    return toolBox.renderTemplate(self.cartManager.templatesSelectors.items, itemsSettings);
  }

  // TODO - destroy each item.
  Items.prototype.on_destroy = function () {
    // TODO - complete
    // reset values etc...

    // Destroy each item individually
    for (let line of cart_lines) {
      line.destroy();
    }
  }

  Items.prototype.on_rendered = function () {
    for (let line of cart_lines) {
      line.markAsRendered();
    }
  }

  Items.prototype.on_updated = async function () {
    // Remove current event listeners
    for (let line of cart_lines) {
      line.eventsHandler(false);
    }

    // Update block's HTML
    var html = await this.getHtml();
    var oldBlock = document.getElementById(this.block_id);
    var newBlock = toolBox.htmlToElement(html);
    // update dom.
    oldBlock.parentNode.replaceChild(newBlock, oldBlock);

    // Reattache event listners.
    for (let line of cart_lines) {
      line.eventsHandler(true);
    }
  }

  Items.prototype.dryItemsInit = async function () {
    this.initCartItems();
    cart_lines = [];
  }

  /***************************/
  /* TEMPLATING HELPERS      */
  /***************************/
  Items.prototype.getQuantityTemplate = function (line_options, line_item) {
    try {
      let isUpdatable = toolBox.getProp(line_options, "quantity.updatable", false);

      // if (!isUpdatable)
      //   throw new Error("Quantity is not updatable for this line item");

      const QUANTITY_STYLES = {
        ACTIONS  : {
          LABEL: 'actions',
          TEMPLATE_ID: '#scz-cart-item-quantity-actions'
        },
        DROPDOWN : {
          LABEL: 'dropdown',
          TEMPLATE_ID: '#scz-cart-item-quantity-dropdown'
        },
        // BOTH : {
        //   LABEL: 'both',
        //   TEMPLATE_ID: '#scz-cart-item-quantity-both'
        // },
        NONE     : {
          LABEL: 'none',
          TEMPLATE_ID: ''
        },
      };

      let options = toolBox.getProp(this.settings, "configurations.quantity", {
        "style"   : "actions",
        "limit_max": 10
      });

      for (const STYLE in QUANTITY_STYLES) {
        let STYLE_OPTIONS = QUANTITY_STYLES[STYLE];
        if (STYLE_OPTIONS.LABEL != options.style)
          continue;

        var $templates = ZDOM(STYLE_OPTIONS.TEMPLATE_ID);
        if ($templates.isEmpty())
          throw new Error ("Template is empty")

        var template_data = { ...options.metadata };
        template_data.quantity_values = (function() {
          let arr = []
          let max = Math.max(options.limit_max, line_item.quantity);
          for (let i = 0; i <= max; i++)
            arr.push(i)
          return arr;
        })()

        return {
          template: $templates.get(0).innerHTML,
          template_data
        }
      }
    } catch (e) {
      console.error("Couldn't find a template for quantity", e);
    }

    return {
      template: "",
      template_data: {}
    };
  }

  Items.prototype.getRemoveTemplate = function (line_options, line_item) {
    try {
      let isEnabled = toolBox.getProp(line_options, "remove.enabled", false);
      if (!isEnabled)
        throw new Error("Remove action is not available for this line item");

      const REMOVE_STYLES = {
        ONLY_TEXT  : {
          LABEL: 'only_text',
          TEMPLATE_ID: '#scz-cart-remove-item-only-text'
        },
        ONLY_ICON : {
          LABEL: 'only_icon',
          TEMPLATE_ID: '#scz-cart-remove-item-only-icon'
        },
        BOTH     : {
          LABEL: 'both',
          TEMPLATE_ID: '#scz-cart-remove-item-both'
        },
        NONE     : {
          LABEL: 'none',
          TEMPLATE_ID: ''
        }
      };

      let options = toolBox.getProp(this.settings, "configurations.remove", {
        "layout"  : "both",
        "label"   : "remove",
        "icon"    : ""
      });

      for (const STYLE in REMOVE_STYLES) {
        let STYLE_OPTIONS = REMOVE_STYLES[STYLE];
        if (STYLE_OPTIONS.LABEL != options.style)
          continue;

        var $templates = ZDOM(STYLE_OPTIONS.TEMPLATE_ID);
        var template_data = {
          remove_label: options.label,
          remove_icon: options.icon
        };

        if ($templates.isEmpty())
          throw new Error("Template is empty or not found", STYLE_OPTIONS);
        return {
          template: $templates.get(0).innerHTML,
          template_data
        };
      }
    } catch (e) {
      console.error("Couldn't fetch remove item template", e)
    }

    return {
      template: "",
      template_data: {}
    }
  }

  Items.prototype.initCartItems = function () {
    let cart = self.cartManager.getCopyOfCart();
    let options = self.settings;

    var lines = [];

    // Init the proper class for each item.
    for (let line_item of cart.items) {
      // List of all candidate classes for the item.
      let candidates = [];

      // Loop over item implementers to add all matching classes.
      for (let itemType in item_types) {
        let pertinenceScore = -1;
        try {
          pertinenceScore = item_types[itemType].is(line_item);
        } catch (e) {console.error(`Couldn't verify if line item is an itemType`, e, {line_item, itemType})}
        if (pertinenceScore < 0) continue;

        let matchingConfig = options.item_level_options.find(ilo => ilo.type == itemType);

        candidates.push({
          type    : itemType,
          score   : pertinenceScore,
          class   : item_types[itemType],
          options : matchingConfig.settings,
          hidden  : matchingConfig.hidden
        })
      }


      // Sort candidates according to pertinence score by descending order.
      // candidates.sort((a,b)=> {
      //   if (a.score > b.score) return -1
      //   if (b.score < a.score) return 1;
      //   return 0;
      // })

			//Fix Mozilla
			candidates.sort((a, b) => b.score - a.score);

      // This condition should never be met, because at least the basic class should always be available.
      if (!candidates.length)
        return;

      // The elected class is the one with the highest score (at position 0 after sorting)
      let elected = candidates.shift();

      // Predefined templates that we pass as is to the item.
      let injections = {
        block_attributes: {
          template : `
            ${domAttributes.item_root}='{
              "type"     : "${elected.type}",
              "key"      : "${line_item.key}",
              "quantity" : ${line_item.quantity}
            }'
          `,
          template_data: {}
        },
        quantity: this.getQuantityTemplate(elected.options, line_item),
        remove: this.getRemoveTemplate(elected.options, line_item),
        remove_label: options.configurations.remove.label
      }

      // Merge global item settings.
      let removeOptions = elected.options.remove || {};
          removeOptions.enable_swiping_on_mobile = toolBox.getProp(options, "configurations.remove.enable_swiping_on_mobile", false);
      elected.options.remove = removeOptions;

      elected.options.link_product = toolBox.getProp(options, "configurations.link_product", {});

      if (elected.hidden)
        continue;

      // Build line instance & add it to the array.
      let lineInstance = new elected.class(line_item.key, elected.options, this, injections);
      // Add type to enable grouping
      lineInstance.type = elected.type;

      lines.push(lineInstance);
    }

    return lines;
  }

  /***************************/
  /* CART HELPERS            */
  /***************************/
  Items.prototype.increaseQuantity = function (key) {
    const item = this.getItemByKey(key);
    if (!item || isNaN(item.quantity))
      return console.error(`Couldn't find a matching item for key: ${key}`);

    return this.cartManager.updateItems([{
      type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
      items: [{key, quantity: ++item.quantity}]
    }]);
  }

  Items.prototype.decreaseQuantity = function (key) {
    const item = this.getItemByKey(key);

    if (!item || isNaN(item.quantity))
      return console.error(`Couldn't find a matching item for key: ${key}`);

    return this.cartManager.updateItems([{
      type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
      items: [{key, quantity: --item.quantity}]
    }]);
  }

  // remove item
  Items.prototype.removeItem = function (key) {
    return this.cartManager.updateItems([{
      type: cartManager.CART_REQUEST_TYPES.REMOVE,
      items: [{key, quantity: 0}]
    }]);
  }

  Items.prototype.updateProperties = function (key, properties) {
    return this.cartManager.updateItems([{
      type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
      items: [{key, properties}]
    }]);
  }
  
   Items.prototype.updateAttributes = function (attributes) {
    return this.cartManager.updateItems([{
      type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
      attributes: [{attributes}]
    }]);
  }

  // Find an item by key
  Items.prototype.getItemByKey = function (key) {
    let cart = this.cartManager.getCopyOfCart();
    return cart.items.find(item => item.key == key)
  }

  // Find an item by variant id
  Items.prototype.getItemById = function (id) {
    let cart = this.cartManager.getCopyOfCart();
    return cart.items.find(item => item.id == id)
  }

  /***************************/
  /* PRIVATE FUNCTIONS       */
  /***************************/
  function getQuantityInstructions (target) {

  }

  function clickEventHandler(e) {
    var target = e.target;
    if (!target)
      return;

    var actionEle = target.closest(selectors.item_quantity_action);

    if (!actionEle)
      return;

    if (actionEle) {
      var root = actionEle.closest(selectors.item_root);
    }


    if (!root)
      return;

    var itemAttributes = {};
    try {
      itemAttributes = JSON.parse(root.getAttribute(domAttributes.item_root))
    } catch (e) {
      return;
    }

    var key = itemAttributes.key;

      var action = actionEle.getAttribute(domAttributes.item_quantity_action);

      if (!action || !key)
        return;

      if (action == '-') {
        this.decreaseQuantity(key);
      } else if (action == '+') {
        this.increaseQuantity(key);
      } else if (action == '0') {
        var item = self.getItemByKey(key);
        if (item.properties && item.properties.has_item_adder && item.properties.item_adder_variant_id) {
          var item_adder = self.getItemById(item.properties.item_adder_variant_id);
          this.decreaseQuantity(item_adder.key);
        }
        this.removeItem(key);
      } else {
        return;
      }

    e.stopPropagation();
  }

  function changeEventHandler(e) {
    var target = e.target;
    if (!target)
      return;

    var actionEle = target.closest(selectors.item_quantity_action);
    if (!actionEle)
      return;

    var root = actionEle.closest(selectors.item_root);
    if (!root)
      return;

    var itemAttributes = {};
    try {
      itemAttributes = JSON.parse(root.getAttribute(domAttributes.item_root))
    } catch (e) {
      return;
    }

    var action = actionEle.getAttribute(domAttributes.item_quantity_action);
    var key = itemAttributes.key;

    if (!action || !key)
      return;

    if (actionEle.tagName.toLowerCase() == 'select' || actionEle.tagName.toLowerCase() == 'input')
      this.cartManager.updateItems([{
        type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
        items: [{key, quantity: actionEle.value}]
      }]);
    else
      return;

    e.stopPropagation();
  }

  return Items;
})();

var block_type = block_type || {};

block_type.richtext = new (function () {

    //Manage Richtext
    function RichtextManager (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [], true);
    }

    toolBox.inheritPrototype(RichtextManager, generic_cart_block);

    RichtextManager.prototype.getHtml = function () {
      let cart = this.cartManager.getCopyOfCart();
      
      let richtextSettings = {
        id: this.block_id,
        settings: this.settings,
        money_formats: self.money_formats,
        cartShopify: cart
      };

      return toolBox.renderTemplate(this.cartManager.templatesSelectors.richtext, richtextSettings);
    }

    return RichtextManager;
  })();

var block_type = block_type || {};

block_type.accordion = new (function () {

  var self;

  var domAttributes = {
    title_tab: 'scz-accordion-title-tab',
    content_tab: 'scz-accordion-content'
  }

  var domClasses = {
    active_title: 'scz-cart-accordion-title--active',
    open_content: 'scz-cart-accordion-content--open',
    closed_content: 'scz-cart-accordion-content--closed'
  };

  var selectors = {
    title_tab: `[${domAttributes.title_tab}]`,
    content_tab: `[${domAttributes.content_tab}]`,
    active_title: `.${domClasses.active_title}`,
    open_content: `.${domClasses.open_content}`,
    closed_content: `.${domClasses.closed_content}`
  };

  var defaultSettings = {
    panels: [
      {
        title: "Tab1 title",
        description: "Tab1 content"
      },
      {
        title: "Tab2 title",
        description: "Tab2 content"
      }
    ],
    configurations: {
      allow_multiple_active_tabs: true,
      display_icon: true,
      icon: "plus"
    }
  }

  //Manage Accordion
  function AccordionManager(cartManager, settings) {
    self = this;

    var eventListeners = [
      {
        event: 'click',
        handler: toggleTabHandler
      }
    ]

    generic_cart_block.call(this, cartManager, settings, eventListeners, false);
    self.settings = toolBox.merge(defaultSettings, settings, true);
  }

  toolBox.inheritPrototype(AccordionManager, generic_cart_block);

  AccordionManager.prototype.getHtml = function () {
    let cart = this.cartManager.getCopyOfCart();

    let accordionSettings = {
      id: this.block_id,
      money_formats: this.money_formats,
      panels: this.settings.configurations.panels,
      display_icon: this.settings.configurations.display_icon,
      icon: this.settings.configurations.icon,
      cartShopify: cart
    };

    return toolBox.renderTemplate(self.cartManager.templatesSelectors.accordion, accordionSettings);
  }

  var toggleTabHandler = e => {
    var $target = ZDOM(e.target);
    if ($target.isEmpty()) return;

    var $tabTitle = ZDOM($target.get(0).closest(selectors.title_tab));
    if ($tabTitle.isEmpty()) return;

    var contentId = $tabTitle.get(0).getAttribute(domAttributes.title_tab);
    var $tabContent = ZDOM('#' + contentId);
    if ($tabContent.isEmpty()) return;

    var $root = ZDOM('#' + self.block_id)
    var shouldOpen = $tabTitle.hasClass(domClasses.active_title) ? false : true;

    // 300ms buffer to prevent unexpected behaviour
    let now = Date.now();
    this.lockTimestamp = this.lockTimestamp || now;
    if (now - this.lockTimestamp > 0 && now - this.lockTimestamp < 300)
      return;
    else if (now - this.lockTimestamp > 300)
      this.lockTimestamp = null;

    if (shouldOpen) {
      var title_tabs = $root.find(selectors.title_tab);
      var content_tabs = $root.find(selectors.content_tab);
      // animate tab
      if (!self.settings.configurations.allow_multiple_active_tabs)
        for (let index = 0; index < title_tabs.elems.length; index++) {
          ZDOM(title_tabs.elems[index]).removeClass(domClasses.active_title);
        }
      $tabTitle.addClass(domClasses.active_title);

      // animate content
      if (!self.settings.configurations.allow_multiple_active_tabs)
        content_tabs.elems.forEach(function (tab, index) {
          tab.classList.remove(domClasses.open_content);
          tab.classList.add(domClasses.closed_content);
        });
        $root.find(selectors.content_tab).removeClass(domClasses.open_content).addClass(domClasses.closed_content);
      $tabContent.removeClass(domClasses.closed_content).addClass(domClasses.open_content);
    } else {
      $tabTitle.removeClass(domClasses.active_title);
      $tabContent.removeClass(domClasses.open_content).addClass(domClasses.closed_content);
    }

    e.preventDefault();
    e.stopPropagation();
  }

  return AccordionManager;
})();

var block_type = block_type || {};

block_type.rewards = new (function () {

    const REWARD_TYPES = {
        FREE_SHIPPING: "free_shipping",
        PRODUCT: "product",
        DISCOUNT_CODE: "code"
    }

    const PROGRESS_STYLES = {
        // When all rewards are visible on the same progress bar, and the progress is a % of their exact value (starting from 0 & 100% is the most expensive reward & the most expensive reward is placed at the end of the progress)
        EXACT: "exact",
        // When all rewards are visible on the same progress bar & and the progress is a % of a beautified distribution (starting from 0 & 100% is the most expensive reward ... but the most expensive reward is not placed at the end of the progress)
        BALANCED: "balanced",
        BALANCED_WITH_CENTER_PROGRESS_BAR: "balanced_with_center_progress_bar",
        BALANCED_WITHOUT_PROGRESS_BAR: "balanced_without_progress_bar",
        // With only one progress bar & each reward resets the progress to start from 0.
        // ex: 2 rewards avlb, first 50 second 100. when total is 60 => the progress bar is at 20%;
        SEPARATE_FROM_ZERO: "separate_from_zero",
        // With only one progress bar & each reward resets the progress to start from the current total.
        // ex: 2 rewards avlb, first 50 second 100. when total is 60 => the progress bar is at 60%;
        SEPARATE_FROM_LAST_REWARD: "separate_from_last_reward"
    };

    const selectors = {
        // The direct placeholder of the current message - used to update the message.
        current_message : "[scz-cart-rewards--current-message]",
        // The direct placeholder of the next message - used to update the message.
        next_message    : "[scz-cart-rewards--next-message]",
        // The direct placeholder of the progress bar - used to update the progress (via style.width)
        progress_bar    : "[scz-cart-rewards--progress-bar]",
    }

    let rewards = [];

    let currentAward = null;
    let nextReward    = null;

    //Manage Footer
    function Block(cartManager, block) {
        generic_cart_block.call(this, cartManager, block, [], true);

        // used to make sure not to update multiple times at the same time.
        this.locked = false;
        this.requests_queue = 0;

        this.enabled = toolBox.getProp(block, "configurations.enabled", false);
        this.rewards = toolBox.getProp(block, "configurations.steps", []);

        var progress_style = toolBox.getProp(block, "configurations.progress_style");
        this.progress_style = Object.keys(PROGRESS_STYLES).find(key => PROGRESS_STYLES[key] === progress_style)?progress_style:PROGRESS_STYLES.EXACT;

        // Sort rewards based on "threshold" by ascending order
        this.rewards.sort((a, b) => {
            if ((isNaN(a.threshold) && isNaN(b.threshold)) || (a.threshold == b.threshold))
                return 0;
            else if ((!isNaN(a.threshold) && isNaN(b.threshold)) || (a.threshold > b.threshold))
                return 1
            else if ((!isNaN(b.threshold) && isNaN(a.threshold)) || (b.threshold > a.threshold))
                return -1
            return 0
        });

        // Calculate min/max threshold values
        this.min_threshold = Infinity;
        this.max_threshold = -Infinity;

        for (var i=0; i< this.rewards.length; i++) {
            let reward = this.rewards[i];

            if (reward.threshold >= this.max_threshold)
                this.max_threshold = reward.threshold;
            if (reward.threshold <= this.min_threshold)
                this.min_threshold = reward.threshold;
        }

        // Enrich reward objects with more data.
        for (var i=0; i< this.rewards.length; i++) {
            let reward = this.rewards[i];

            reward.unlocked = false;
            reward.last_unlocked = false;
            reward.next_to_unlock = i===0;

            // The position of the reward on the progress bar
            // Ex : if there are 2 rewards & min = 50 & max = 100 =>
            // Exact offset for first = 50% (middle of the progress bar) & exact pointer offset for the second reward = 100% (the end of the progress bar)
            reward.exact_offset_percentage = (reward.threshold * 100)/this.max_threshold;
            // Balanced offset for first = 33.3%  & as for the second reward = 66.6%
            reward.balanced_offset_percentage = (reward.threshold * 100)/(this.max_threshold + this.min_threshold);

            // Ex : if cart's subtotal = 50$ & first reward threshold = 40$ & second reward threshold = 60$
            // completion from 0 for the first reward = 100% as for the second = 83.3%
            reward.exact_completion_percentage_from_0 = 0;
            // completion from last reward for the first reward = 100% as for the second = 50%
            reward.exact_completion_percentage_from_last_reward = 0;

            var position = 0;
            switch (this.progress_style) {
                case PROGRESS_STYLES.EXACT:
                    position = reward.exact_offset_percentage;
                    break;
                case PROGRESS_STYLES.BALANCED:
                case PROGRESS_STYLES.BALANCED_WITHOUT_PROGRESS_BAR:
                case PROGRESS_STYLES.BALANCED_WITH_CENTER_PROGRESS_BAR:
                    position = reward.balanced_offset_percentage;
                    break;
                default:
                    position = 0;
                    break;
            }

            reward.position_percentage = position;
        }

        let cart = this.cartManager.getCopyOfCart();
        this.updateReward(cart);
    }

    toolBox.inheritPrototype(Block, generic_cart_block);

    Block.prototype.getHtml = function () {
        if (!this.enabled)
            return "";

        let cart = this.cartManager.getCopyOfCart();
        this.updateReward(cart);

        let data = this.generateRenderOptions(cart);

        return toolBox.renderTemplate(this.cartManager.templatesSelectors.rewards, data);
    }

    Block.prototype.on_updated = function () {
        if (!this.enabled)
            return;

        let cart = this.cartManager.getCopyOfCart();

        // Apply reward (add/remove awarded product - auto apply discount code - or should it be done after clicking on the button ?)
        this.updateReward(cart);

        // Get block data
        var options = this.generateRenderOptions(cart);

        // Update
        var currentMessageEle = document.getElementById(this.block_id).querySelector(selectors.current_message);
        var nextMessageEle    = document.getElementById(this.block_id).querySelector(selectors.next_message);
        var progressBarEle    = document.getElementById(this.block_id).querySelector(selectors.progress_bar);


        if (currentAward && currentMessageEle) {
          currentMessageEle.innerHTML = options.current_message;
        } else if (currentMessageEle)
            currentMessageEle.innerHTML = "";

        if (nextReward && nextMessageEle) {
            nextMessageEle.innerHTML =  options.next_message;
        } else if (nextMessageEle)
            nextMessageEle.innerHTML = "";

        if (progressBarEle)
            progressBarEle.style.width = options.progress_percentage +'%';
    }

    /*********************************/
    /* PRIVATE FUNCTIONS       */
    /*********************************/

    Block.prototype.generateRenderOptions = function (cart) {
        var subtotal = this.calculateRealSubtotal(cart);
        var nextMessage = "";

        if (nextReward) {
            var left = nextReward.threshold - subtotal;
            var leftMoney = window.__ascf.formatMoney(left, this.money_formats.with_comma_separator)
            nextMessage = nextReward.before_message.replace("##left##", leftMoney);
        }

        var options = {
            id: this.block_id,
            money_formats: this.money_formats,
            rewards: this.rewards,
            current_message: currentAward?currentAward.after_message: "",
            next_message: nextMessage,

            // Progress % values :
            progress_percentage : 0,
            // used with reward.exact_offset_percentage
            progress_percentage: Math.min(Math.max(0, subtotal * 100 / (this.max_threshold - 0)), 100),
            // used with reward.balanced_offset_percentage
            balanced_progress_percentage: subtotal > this.max_threshold ? 100 : Math.min(Math.max(0, subtotal * 100 / (this.max_threshold + this.min_threshold)), 100),
            // used with exact_completion_percentage_from_last_reward
            separate_from_zero_progress_percentage : nextReward? nextReward.exact_completion_percentage_from_0:100,
            // used with exact_completion_percentage_from_last_reward
            separate_from_last_reward_progress_percentage : nextReward? nextReward.exact_completion_percentage_from_last_reward:100,
            cart
        };

        var progressValue = 0;
        switch (this.progress_style) {
            case PROGRESS_STYLES.EXACT:
                progressValue = options.progress_percentage;
                break;
            case PROGRESS_STYLES.BALANCED:
            case PROGRESS_STYLES.BALANCED_WITH_CENTER_PROGRESS_BAR:
            case PROGRESS_STYLES.BALANCED_WITHOUT_PROGRESS_BAR:
                progressValue = options.balanced_progress_percentage;
                break;
            case PROGRESS_STYLES.SEPARATE_FROM_ZERO:
                progressValue = options.separate_from_zero_progress_percentage;
                break;
            case PROGRESS_STYLES.SEPARATE_FROM_LAST_REWARD:
                progressValue = options.separate_from_last_reward_progress_percentage;
                break;
            default:
                break;
        }

        options.progress_percentage = progressValue;
        options.progress_style = this.progress_style;

        return options;
    }

    Block.prototype.updateReward = function (cart) {
        var subtotal = this.calculateRealSubtotal(cart);

        let newCurrentReward = null;
        let newNextReward = null;

        /** Get current & next actions **/
        /********************************/
        for (let reward of this.rewards) {
            if (!toolBox.isEmpty(reward) && subtotal >= reward.threshold) {
                newCurrentReward      = reward;

                reward.unlocked       = true;
                reward.last_unlocked  = false;
                reward.next_to_unlock = false;

                reward.exact_completion_percentage_from_0 = 100;
                reward.exact_completion_percentage_from_last_reward = 100;
            } else {
                reward.unlocked       = false;
                reward.last_unlocked  = false;

                var isNextToUnlock = !newNextReward && !toolBox.isEmpty(reward) && subtotal < reward.threshold;
                reward.next_to_unlock = isNextToUnlock;
                if (isNextToUnlock)
                    newNextReward = reward;

                var zeroFromLastReward = newCurrentReward && newCurrentReward.threshold?newCurrentReward.threshold:0
                reward.exact_completion_percentage_from_0 = Math.min(Math.max(0, subtotal * 100 / reward.threshold), 100);
                reward.exact_completion_percentage_from_last_reward = Math.min(Math.max(0, (subtotal - zeroFromLastReward) * 100 / (reward.threshold - zeroFromLastReward)), 100);
            }
        }

        if (newCurrentReward)
            newCurrentReward.last_unlocked = true;


        /** Update rewards **/
        /***********************************/
        this.updateProductRewards(cart, this.rewards, newCurrentReward, newNextReward);

        /** Update local rewards references **/
        /*************************************/
        currentAward = newCurrentReward;
        nextReward = newNextReward;
    }

    Block.prototype.calculateRealSubtotal = function (cart) {
        let subtotal = cart.items_subtotal_price;

        // Exclude rewarded products form the cart.
        for (let item of cart.items) {
            // Exclude Gift.
            let attribute = getItemProperty(item.variant_id);
            if (!toolBox.hasAttribute(item, attribute))
                continue;
            // We assume that the deduced price should exclude applied discounts for the reward
            // & the quantity is 1. The client may have successed at adding the same item multiple times, only the first one is gifted
            subtotal -= item.final_price;
        }

        // Exclude the difference between cart price & subscription price. (mainly for recharge products)
        for (let item of cart.items) {
            // Only look for subscription items.
            if (!item.properties || !item.properties.subscription_id) continue;
            // Only for those for which we have the data.
            let originalToHiddenVariantMap = toolBox.getProp(item, "metafields.original_to_hidden_variant_map", false);
            if (!originalToHiddenVariantMap || !originalToHiddenVariantMap[item.variant_id]) continue;

            // Get unit price.
            let subscriptionVariantPrice = parseFloat(originalToHiddenVariantMap[item.variant_id].discount_variant_price) * 100;

            subtotal -= (item.final_line_price - subscriptionVariantPrice * item.quantity);
        }

          // Exclude gift cards
          for (let item of cart.items) {
            // Only look for subscription items.
            if (item.gift_card == true){
              subtotal -= (item.final_line_price * item.quantity);
            }
            
        }

        // Check if to exclude rewarded discount codes.
        // ...

        return subtotal;
    }

    /********************************************/
    /* PRODUCT REWARD       */
    /********************************************/
    Block.prototype.updateProductRewards = function (cart, rewards, currentAward, nextReward) {
        if (this.isLocked() && (currentAward == null && nextReward == null))
            return this.addToQueue();
        this.lockRewards();

        // List of rewards already added to the cart.
        const addedRewardItems = getAllRewardedLineItems(cart.items);
        // List of earned rewards.
        const earnedProductRewards = rewards.filter(reward => reward.unlocked && reward.type == REWARD_TYPES.PRODUCT && reward.variant_id)
        // List of earned rewards not yet added to the cart => Should be added.
        let missingRewards = [];
        // List of lost rewards that are still present in the cart => Should be removed.
        let lostRewards = [];
        //List of reward quantity more 1
        let updateRewards = [];

        // Get refused rewards
        let refusedRewards = this.cartManager.getFromVault('refused_rewards');
        if (!refusedRewards && !Array.isArray(refusedRewards)) {
          this.cartManager.addToVault('refused_rewards', [], true);
          refusedRewards = [];
        }

        // // If reward is refused in refusedRewards and cart total is under this reward threshold (is nextReward) we remove this rewards from refusedRewards
        // if (nextReward != null && nextReward.type == "product" && refusedRewards && refusedRewards.includes(nextReward.variant_id)) {
        //   const index = refusedRewards.indexOf(nextReward.variant_id);
        //   if (index > -1) {
        //     refusedRewards.splice(index, 1);
        //   }
        //   this.cartManager.addToVault('refused_rewards', refusedRewards, true);
        // }
        
        // if(cart.items.length == 0) {
        //   this.cartManager.addToVault('refused_rewards', [], true);
        // }


        // Find  missing rewards by checking which rewards are not yet added to the cart.
        for (let reward of earnedProductRewards) {
            // Check if this reward was already refused to avoid adding it.
            if (refusedRewards.includes(reward.variant_id))
              continue;

            let found = false;
            for (let item of addedRewardItems) {
                let attribute = getItemProperty(reward.variant_id);
                if (!toolBox.hasAttribute(item, attribute))
                    continue;
                found = true;
                break;
            }

            if (!found)
                missingRewards.push(reward);
        }

        // Find lost / unearned rewards by checking which of the already added items doesn't match the list of earned rewards
        for (let rewardedItem of addedRewardItems) {
            let found = false;

            for (let reward of earnedProductRewards) {
                let attribute = getItemProperty(reward.variant_id);
                if (!toolBox.hasAttribute(rewardedItem, attribute))
                    continue;
                found = true;
                break;
            }

            if (!found) {
							lostRewards.push(rewardedItem);
						} else if (rewardedItem.quantity > 1) {
							updateRewards.push(rewardedItem);
						}
        }

        // Build requests
        let itemsToAdd = [];
        let itemsToDelete = [];
        let itemsToUpdate = [];
        for (let missingReward of missingRewards) {
          let rewardProperty = getItemProperty(missingReward.variant_id);
          let properties = {};
          properties[rewardProperty.name] = rewardProperty.value;

            itemsToAdd.push({
                id: missingReward.variant_id,
                quantity: 1,
                properties: properties
            })
        }

        for (let lostReward of lostRewards) {
            itemsToDelete.push({
                key: lostReward.key
            })
        }

        for (let updateReward of updateRewards) {
            itemsToUpdate.push({
                key: updateReward.key,
								quantity: 1
            })
        }

        let requests = [];
        if (itemsToAdd.length)
            requests.push({
                type: this.cartManager.CART_REQUEST_TYPES.ADD,
                items: itemsToAdd
            })

        if (itemsToDelete.length)
            requests.push({
                type: this.cartManager.CART_REQUEST_TYPES.REMOVE,
                items: itemsToDelete
            })

        if (itemsToUpdate.length)
            requests.push({
                type: this.cartManager.CART_REQUEST_TYPES.UPDATE,
                items: itemsToUpdate
            })

        if (requests.length) {
            this.locked = true;
            this.requests_queue = 0;
            this.cartManager.updateItems(requests, this.unlockRewards.bind(this));
        } else
            this.unlockRewards();
    }

    Block.prototype.isLocked = function () {
        return !!this.locked;
    }

    Block.prototype.addToQueue = function () {
        ++this.requests_queue;
    }

    Block.prototype.lockRewards = function () {
        this.locked = true;
        this.addToQueue();
    }

    Block.prototype.removeRewardVariantId = function (arr, variant_id) {
      for( var i = 0; i < arr.length; i++) {
        if ( arr[i] === variant_id) {
            arr.splice(i, 1);
            i--;
        }
      }
      return arr;
    }

    Block.prototype.unlockRewards = function () {
        this.locked = false;
        this.requests_queue = Math.max(--this.requests_queue, 0);
        if (this.requests_queue) {
					let cart = this.cartManager.getCopyOfCart();
					this.updateReward(cart);
				}
    }

    function getItemProperty(variantId) {
        return {
            name: `__reward_${variantId}`,
            value: `unlocked`
        }
    }

    function getAllRewardedLineItems(line_items) {
        return line_items.filter(item => {
            let rewardItemProperty = getItemProperty(item.variant_id);

            return toolBox.hasAttribute(item, rewardItemProperty);
        })
    }

    /*********************************/
    /* PUBLIC STATIC FUNCTIONS       */
    /*********************************/
    Block.isRewardItem = function (item, variantId) {
        let attribute = getItemProperty(variantId);
        return toolBox.hasAttribute(item, attribute);
    }

    return Block;
})();

var block_type = block_type || {};

block_type.upsell = new (function () {

    const selectors = {
      // The slider selectors.
      slider_root : '[scz-cart-upsell__slider]',
      slider_dots : '[scz-cart-upsell__slider__dots]',
      slider_next : '[scz-cart-upsell__slider__next]',
      slider_prev : '[scz-cart-upsell__slider__prev]',

      // Popup add
      popup_trigger           : "[scz-cart-popup-trigger-add]",
      popup_product_handle    : "scz-cart-popup-product-handle"
    }

    //Manage upsell
    function Block (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [
        {
            $ele: selectors.popup_trigger,
            event: 'click',
            handler: this.buildAddPopup.bind(this)
        }
      ], true);

      this.options = block.configurations;

      this.title                 = toolBox.getProp(block, "configurations.title", "");
      this.collection_handle     = toolBox.getProp(block, "configurations.collection_handle", "");
      this.style                 = toolBox.getProp(block, "configurations.style", "slider");
      this.products_per_row      = Math.max(toolBox.getProp(block, "configurations.products_per_row", 0), 1);
      this.max_rows              = Math.max(toolBox.getProp(block, "configurations.max_rows", 0), 1);
      this.max_products          = Math.max(toolBox.getProp(block, "configurations.max_products", 0), 1);
      this.hide_products_in_cart = toolBox.getProp(block, "configurations.hide_products_in_cart", true);

      this.slider_options        = toolBox.getProp(block, "configurations.slider_options", {});
      this.slider_options        = typeof this.slider_options === "object"? this.slider_options:{};

      this.vaultKey              = 'collection-handle_' + this.collection_handle;
      this.products              = this.cartManager.getFromVault(this.vaultKey)

      if (!this.products)
        fetch(`/collections/${this.collection_handle}/products.json`)
        .then(raw => raw.json())
        .then(this.handleProducts.bind(this));
    }

    toolBox.inheritPrototype(Block, generic_cart_block);

    Block.prototype.getHtml = async function () {
      let cart = self.cartManager.getCopyOfCart();

      let validProducts = [];

      await fetch(`/collections/${this.collection_handle}/products.json`)
        .then(raw => raw.json())
        .then(this.handleProducts.bind(this));

      for (var product of this.products) {
        if (product != undefined) {
          console.log(product);
          let found = !!cart.items.find(item => item.product_id == product.id);
          if ((!found || !this.hide_products_in_cart) && this.max_products > validProducts.length) validProducts.push(product); 
        }
      }

      let isSlider = this.style == 'slider' && validProducts.length > 1
      var data = {
        id               : this.block_id,
        money_formats    : this.money_formats,
        is_slider        : isSlider,
        title            : this.title,
        style            : this.style,
        max_rows         : isSlider? 1 : this.max_rows,
        products_per_row : isSlider ? this.max_rows * this.products_per_row : this.products_per_row,
        products         : validProducts,
        popupActions     : this.options.popupActions
      };

      // Build template
      return toolBox.renderTemplate(self.cartManager.templatesSelectors.upsell, data, {});
    }

    Block.prototype.on_rendered = async function () {
      await fetch(`/collections/${this.collection_handle}/products.json`)
        .then(raw => raw.json())
        .then(this.handleProducts.bind(this));

      this.initGlider();
    }

    Block.prototype.on_updated = async function () {

      await fetch(`/collections/${this.collection_handle}/products.json`)
        .then(raw => raw.json())
        .then(this.handleProducts.bind(this));
      
      
      var html = await this.getHtml();
      var oldBlock = document.getElementById(this.block_id);
      var newBlock = toolBox.htmlToElement(html);
      // update dom.
      if (oldBlock != null) {
        oldBlock.parentNode.replaceChild(newBlock, oldBlock);
        this.initGlider();
      }
    }

    Block.prototype.initGlider = function () {
      var slider = document.getElementById( this.block_id ).querySelector(selectors.slider_root);
      if (!slider || this.style != 'slider') return;

      new Glider(slider, {
        ...this.slider_options,
        dots: selectors.slider_dots,
        arrows: {
          prev: selectors.slider_prev,
          next: selectors.slider_next
        }
      });
    }

    Block.prototype.cleanUpsell = function (product) {
      if(product != null) {
        var productCleaned = {};
        productCleaned.created_at = product.createdAt;
        productCleaned.handle = product.handle;
        productCleaned.id = atob(product.id).replace('gid://shopify/Product/', '');
        productCleaned.images = [];
        for (let index = 0; index < product.images.edges.length; index++) {
          productCleaned.images.push(product.images.edges[index].node)
        }
        productCleaned.published_at = product.publishedAt;
        productCleaned.tags = product.tags;
        productCleaned.title = product.title;
        productCleaned.updated_at = product.updatedAt;
        productCleaned.variants = [];
        for (let index = 0; index < product.variants.edges.length; index++) {
          productCleaned.variants.push({
            id: atob(product.variants.edges[index].node.id).replace('gid://shopify/ProductVariant/', ''),
            price: product.variants.edges[index].node.price
          })
        }
        productCleaned.vendor = product.vendor;
        return productCleaned;
      }
    }

    // get collection or each product
    Block.prototype.handleProducts = async function (res) {

      // get products collection default
      let products = toolBox.getProp(res, "products", []);
      if (!products)
        products = [];

      //get dynamics products
      let cart = self.cartManager.getCopyOfCart();

      // let products_handles = [];
      // for (let index = 0; index < cart.items.length; index++) {
      //   if (!products_handles.includes(cart.items[index].handle)) {
      //     products_handles.push(cart.items[index].handle);
      //   }
      // }

      // let products_linked_products = [];
      // for (let index = 0; index < products_handles.length; index++) {
      //   var metafields = await this.getlinkedMetafieldsProduct(products_handles[index]);
      //   if (metafields != null) {
      //     if (metafields.metafields.edges.length > 0) {
      //       products_linked_products.push(JSON.parse(metafields.metafields.edges[0].node.value));
      //     }
      //   }
      // }
      // let products_linked_products_clean = [];
      // for (let index = 0; index < products_linked_products.length; index++) {
      //   if (!products_linked_products_clean.includes(products_linked_products[index].product1) && !products_handles.includes(products_linked_products[index].product1)) {
      //     products_linked_products_clean.push(products_linked_products[index].product1);
      //   }
      //   if (!products_linked_products_clean.includes(products_linked_products[index].product2) && !products_handles.includes(products_linked_products[index].product2)) {
      //     products_linked_products_clean.push(products_linked_products[index].product2);
      //   }
      //   if (!products_linked_products_clean.includes(products_linked_products[index].product3) && !products_handles.includes(products_linked_products[index].product3)) {
      //     products_linked_products_clean.push(products_linked_products[index].product3);
      //   }
      // }
      // let productsDynamics = [];
      // for (let index = 0; index < products_linked_products_clean.length; index++) {
      //   var tempProduct = await this.getDynamicsProduct(products_linked_products_clean[index]);
      //   productsDynamics.push(this.cleanUpsell(tempProduct));
      // }
      // if (productsDynamics) {
      //   products = [...productsDynamics, ...products];
      // }

      if (cart.relatedProducts != undefined && cart.relatedProducts.length > 0) {
        products = cart.relatedProducts;
      }


      this.cartManager.addToVault(this.vaultKey, products);
      this.products = products;
    }


    Block.prototype.getlinkedMetafieldsProduct = async function (handle) {
      const params = {
        query :  `query {
          productByHandle(handle: "` + handle + `") {
            metafields(namespace: "upsell_checkout", first: 10) {
              edges {
                node {
                  value
                }
              }
            }
          }
        }`
      };
      const optionsQuery = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Shopify-Storefront-Access-Token": 'be67c40c306e0136d6833b1e9e50de0f'
        },
        body: JSON.stringify(params)
      };
      return fetch("https://franginfrangine.myshopify.com/api/graphql", optionsQuery)
        .then(res => res.json())
        .then(response => {
          return response.data.productByHandle;
      });
    }

    Block.prototype.getDynamicsProduct = function (handle) {
      const params = {
        query :  `query {
          productByHandle(handle: "` + handle + `") {
            createdAt
            id
            handle
            images(first: 10) {
              edges {
                node {
                  src
                }
              }
            }
            options(first: 10) {
              id
              name
              values
            }
            productType
            publishedAt
            tags
            title
            updatedAt
            vendor
            variants(first: 20) {
              edges {
                node {
                  id
                  price
                }
              }
            }
          }
        }`
      };
      const optionsQuery = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Shopify-Storefront-Access-Token": 'be67c40c306e0136d6833b1e9e50de0f'
        },
        body: JSON.stringify(params)
      };
      return fetch("https://franginfrangine.myshopify.com/api/graphql", optionsQuery)
        .then(res => res.json())
        .then(response => {
          return response.data.productByHandle;
      });
    }


    Block.prototype.buildAddPopup = function (e) {

      if (!e.target || !e.target.matches(selectors.popup_trigger)) return;

      let conversionOptions = toolBox.getProp(this.options, "popupActions.addProduct", {});
      if (!conversionOptions.enabled)
        throw new Error("Popup action is not available for this line item");

      var type = 'add';

      var product_handle = e.target.getAttribute(selectors.popup_product_handle);

      var line_item = null;

      var options = {
        enable_quantity: conversionOptions.enable_quantity,
        enable_variants: conversionOptions.enable_variants,
        popup_submit_label: conversionOptions.popup_submit_label
      }

      const productPopup = new ProductPopupManager(type, product_handle, line_item, options);
    }

    return Block;

  })();

var block_type = block_type || {};

block_type.spacer = new (function () {

    function SpacerManager (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [], false);
    }

    toolBox.inheritPrototype(SpacerManager, generic_cart_block);

    SpacerManager.prototype.getHtml = function () {
      let cart = this.cartManager.getCopyOfCart();

      let data = {
        id: this.block_id,
        money_formats: this.money_format,
        spacing: this.settings.configurations.spacing,
        enabled_footer_bottom: this.settings.configurations.enabled_footer_bottom,
        cartShopify: cart
      };

      return toolBox.renderTemplate(this.cartManager.templatesSelectors.spacer, data);
    }

    return SpacerManager;
  })();

var block_type = block_type || {};

block_type.image = new (function () {

    function Block (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [], false);
    }

    toolBox.inheritPrototype(Block, generic_cart_block);

    Block.prototype.getHtml = function () {
      let cart = self.cartManager.getCopyOfCart();
      let data = {
        id: this.block_id,
        money_formats: this.money_formats,
        src: this.settings.configurations.src,
        width: this.settings.configurations.width,
        crop : this.settings.configurations.crop,
        cartShopify: cart
      };
  
      return toolBox.renderTemplate(this.cartManager.templatesSelectors.image, data);
    }

    return Block;
  })();

var block_type = block_type || {};

block_type.summary = new (function () {

  var domAttributes = {
      inputAddAddress: 'scz-add-address',
      estimateShippingUpdate: 'scz-estimate-shipping-update',
      estimateShippingConfirm: 'scz-estimate-shipping-confirm',
      estimateShippingPrice: 'scz-estimate-shipping-price',
      estimateShippingPriceCountry: 'scz-estimate-shipping-price-country',
      estimateShippingCountries: 'scz-estimate-shipping-countries-list',
      estimateShippingProvinces: 'scz-estimate-shipping-province-list',
      estimateShippingZip: 'scz-estimate-shipping-zip',
      estimateShippingContainer: 'scz-estimate-shipping-container',
      estimateShippingCountrySelected: 'scz-estimate-shipping-country-selected',
      estimateShippingSelectsContainer: 'scz-estimate-shipping-selects-container',
  }

  var selectors = {
      inputAddAddress: `[${domAttributes.inputAddAddress}]`,
      estimateShippingUpdate: `[${domAttributes.estimateShippingUpdate}]`,
      estimateShippingConfirm: `[${domAttributes.estimateShippingConfirm}]`,
      estimateShippingPrice: `[${domAttributes.estimateShippingPrice}]`,
      estimateShippingPriceCountry: `[${domAttributes.estimateShippingPriceCountry}]`,
      estimateShippingProvinces: `[${domAttributes.estimateShippingProvinces}]`,
      estimateShippingZip: `[${domAttributes.estimateShippingZip}]`,
      estimateShippingCountries: `[${domAttributes.estimateShippingCountries}]`,
      estimateShippingContainer: `[${domAttributes.estimateShippingContainer}]`,
      estimateShippingCountrySelected: `[${domAttributes.estimateShippingCountrySelected}]`,
      estimateShippingSelectsContainer: `[${domAttributes.estimateShippingSelectsContainer}]`
  };

  var classes = {
    active   : 'scz-cart-summary__shipping_estimate-active'
  };

  var shopifyCountries = null;

    //Manage Summary
    function SummaryManager (cartManager, block) {

      var eventListeners = [
          {
              event: 'click',
              handler: updateShipping.bind(this)
          },
          {
              event: 'click',
              handler: confirmShipping.bind(this)
          },
          {
              event: 'change',
              handler: selectCountry.bind(this)
          }
      ]

      this.popupSettings = null;

      generic_cart_block.call(this, cartManager, block, eventListeners,  true);
    }

    toolBox.inheritPrototype(SummaryManager, generic_cart_block);

    SummaryManager.prototype.getHtml = function () {
      let cart = this.cartManager.getCopyOfCart();
      let data = generateRenderOptions.bind(this)(this.settings, cart);
      // commonsFilters.priceFormatter(total)

      this.address = this.cartManager.getFromVault('adress')

      return toolBox.renderTemplate(this.cartManager.templatesSelectors.summary, data);
    }

    const generateRenderOptions = function (block, cart) {
      var configurations = block.configurations;
      var options = {
        id: this.block_id,
        money_formats: this.money_formats,
        cartIsEmpty: cart.item_count == 0,
        cartShopify: cart
      };

      var settings = {};

      if (configurations.title_line && configurations.title_line.enabled)
      settings.title = {
        label: configurations.title_line.label,
        isCollapsible: configurations.collapsible == true ? true : false,
        isOpenDefault: configurations.collapsible && configurations.open_default == false ? false : true
      }

      if (configurations.subtotal_line && configurations.subtotal_line.enabled)
        settings.subtotal = {
          label: configurations.subtotal_line.label,
          value: cart.items_subtotal_price
        }

      if (configurations.discounts_line && configurations.discounts_line.enabled)
        settings.discounts = {
          label: configurations.discounts_line.label,
          value: cart.total_discount
        }

      if (configurations.shipping_line && configurations.shipping_line.enabled) {
        settings.shipping = {
          label: configurations.shipping_line.label,
          hint: configurations.shipping_line.hint,
          value: configurations.shipping_line.value,
          enabled_estimate_shipping: configurations.shipping_line.enabled_estimate_shipping,
          enabled_estimate_shipping_label_country: configurations.shipping_line.enabled_estimate_shipping_label_country,
          enabled_estimate_shipping_label_province: configurations.shipping_line.enabled_estimate_shipping_label_province,
          enabled_estimate_shipping_label_button: configurations.shipping_line.enabled_estimate_shipping_label_button,
          enabled_estimate_shipping_label: configurations.shipping_line.enabled_estimate_shipping_label,
          shipping_countries: configurations.shipping_line.shipping_countries,
          shipping_countries_filtered: null
        }

        if (configurations.shipping_line.enabled_estimate_shipping) {
          fetch(`/admin/countries.json`)
            .then(raw => raw.json())
            .then(function (data) {
              shopifyCountries = data.countries.filter(country => {
                return configurations.shipping_line.shipping_countries.includes(country.code);
              });

              if(shopifyCountries.length > 1) {
                generateSelects(shopifyCountries, options.id, "countries");

                var root = document.getElementById(options.id);
                if (!root) return;
                root.querySelector(selectors.estimateShippingUpdate).classList.remove('hide');
              }
              getRates(shopifyCountries);
            });


        }
      }

      if (configurations.total_line && configurations.total_line.enabled) {
        if (configurations.total_line.display_cart_count) {

          var total_label = configurations.total_line.label + ' (' + cart.item_count + ' ' + configurations.total_line.cart_count_prefix + ')';

        } else {
          var total_label = configurations.total_line.label
        }
        settings.total = {
          label: total_label,
          value: cart.total_price
        }
      }

      if (configurations.weight_line && configurations.weight_line.enabled)
        settings.weight = {
          label: configurations.weight_line.label,
          value: cart.total_weight
        }

      if (configurations.description && configurations.description.enabled)
        settings.description = {
          label: configurations.description.label
        }

      if (block.block_level_options != undefined) {
        for (let blockOption of block.block_level_options) {
            const optionSettings = toolBox.getProp(blockOption, "settings", {});
            const shouldDisplay  = toolBox.getProp(optionSettings, "enabled", false);
            const optionType     = blockOption.option;

            if (!shouldDisplay || !optionType) continue;

            switch (optionType) {
              case "add_address":

              var popupSettings = {};

                if (optionSettings.title_line && optionSettings.title_line.enabled)
                  popupSettings.title = {
                    label: optionSettings.title_line.label
                  }

                if (optionSettings.subtotal_line && optionSettings.subtotal_line.enabled)
                  popupSettings.subtotal = {
                    label: optionSettings.subtotal_line.label
                  }

                if (optionSettings.inputs && optionSettings.inputs.enabled)
                  popupSettings.form = optionSettings.inputs;

                this.popupSettings = popupSettings;
                break;
              default:
                break;
            }
          }
      }

      options.summary = settings;

      return options;
    }

    /*================ CART SHIPPING CALCULATOR ================*/

    function getCountryCode() {
      var getCountryCode = new XMLHttpRequest();
      getCountryCode.open( "GET", '//www.cloudflare.com/cdn-cgi/trace', false );
      getCountryCode.send( null );
      var countryCode = getCountryCode.responseText;

      countryCode = countryCode.replace(/(\r\n|\n|\r)/gm,"").split('loc=');
      countryCode = countryCode[1].split('tls=');
      countryCode = countryCode[0];
      return countryCode;
    }

    function getRates(countries) {
      var sz_cart_address = this.cartManager.getFromVault('sz_cart_address');
      if((!countries && !Array.isArray(countries)) || countries != "" && countries.length == 1) {
        var address = {};
        (countries[0].code.length > 0) ? address.country = countries[0].code : address.country = getCountryCode();
        if (countries[0].provinces.length > 0) { address.province = countries[0].provinces[0].code };
      } else {
        if ((!sz_cart_address && !Array.isArray(sz_cart_address)) || sz_cart_address == "" || sz_cart_address.country.length == 0) {
          var address = {
            country: getCountryCode()
          };
        } else {
          var address = sz_cart_address;
        }
      }
      console.log(address);

      this.cartManager.calculateShipping(address, true, populateResult);
    }

    function generateSelects(shopifyCountries, block_id, type) {
      var select = document.createElement("select");
      if (type == "countries") {
        select.setAttribute("class", "scz-cart-summary__shipping_estimate--countries-list");
        select.setAttribute("scz-estimate-shipping-countries-list", "");
      } else if (type == "provinces") {
        select.setAttribute("class", "scz-cart-summary__shipping_estimate--countries-list");
        select.setAttribute("scz-estimate-shipping-province-list", "");
      }

      var optionDefault = document.createElement("option");
      optionDefault.value = "";
      optionDefault.text = (type == "countries") ? "Sélectionnez un pays" : "Sélectionnez une province";
      optionDefault.setAttribute("selected", "");
      optionDefault.setAttribute("disabled", "");
      select.appendChild(optionDefault);

      for (var i = 0; i < shopifyCountries.length; i++) {
        var option = document.createElement("option");
        option.value = shopifyCountries[i].code;
        option.text = shopifyCountries[i].name;
        select.appendChild(option);
      }

      var root = document.getElementById(block_id);
      if (!root) return;


      var container = root.querySelector(selectors.estimateShippingSelectsContainer);

      if (type == "provinces") {
        if (container.querySelector(selectors.estimateShippingProvinces)) {
          container.removeChild(container.querySelector(selectors.estimateShippingProvinces));
        }
      }
      container.appendChild(select);
    }

    function updateShipping(e) {

        // Get dom input.
        var root = document.getElementById(this.block_id);
        if (!root) return;

        if (!e.target || !e.target.matches(selectors.estimateShippingUpdate)) return;

        var container = root.querySelector(selectors.estimateShippingContainer);

        container.classList.add(classes.active);
    }

    function confirmShipping(e) {

        // Get dom input.
        var root = document.getElementById(this.block_id);
        if (!root) return;

        if (!e.target || !e.target.matches(selectors.estimateShippingConfirm)) return;

        var container = root.querySelector(selectors.estimateShippingContainer);
        var countrySelected = root.querySelector(selectors.estimateShippingCountries).value;

        console.log(countrySelected);

        var countrySelectedHasProvinces = false;
        for (var i = 0; i < shopifyCountries.length; i++) {
          if (shopifyCountries[i].code == countrySelected) {
            if (shopifyCountries[i].provinces.length > 0) {
              countrySelectedHasProvinces = true;
            }
          }
        }

        var zipSelected = root.querySelector(selectors.estimateShippingZip).value;
        if(zipSelected.length == 0) {
          root.querySelector(selectors.estimateShippingZip).style.borderColor = "red";
          return;
        } else {
          root.querySelector(selectors.estimateShippingZip).style.borderColor = "#cccccc";
        }

        if (countrySelectedHasProvinces) {
          var provinceSelected = root.querySelector(selectors.estimateShippingProvinces).value;
          

          var address = {
            country: countrySelected,
            province: provinceSelected,
            zip: zipSelected
          };
        } else {
          var address = {
            country: countrySelected,
            zip: zipSelected
          };
        }

        this.cartManager.calculateShipping(address, true, populateResult);
        container.classList.remove(classes.active);
    }

    function selectCountry(e) {

        // Get dom input.
        var root = document.getElementById(this.block_id);
        if (!root) return;

        if (!e.target || !e.target.matches(selectors.estimateShippingCountries)) return;

        var container = root.querySelector(selectors.estimateShippingContainer);
        var countrySelected = root.querySelector(selectors.estimateShippingCountries).value;

        var countrySelectedHasProvinces = false;
        var countrySelectedProvinces = null;
        for (var i = 0; i < shopifyCountries.length; i++) {
          if (shopifyCountries[i].code == countrySelected) {
            if (shopifyCountries[i].provinces.length > 0) {
              countrySelectedHasProvinces = true;
              countrySelectedProvinces = shopifyCountries[i].provinces;
            }
          }
        }

        if (countrySelectedHasProvinces) {
          generateSelects(countrySelectedProvinces, this.block_id, "provinces");
        } else {
          var container = root.querySelector(selectors.estimateShippingSelectsContainer);
          if (container.querySelector(selectors.estimateShippingProvinces)) {
            container.removeChild(container.querySelector(selectors.estimateShippingProvinces));
          }
        }

        var container = root.querySelector(selectors.estimateShippingSelectsContainer);
        var zip = document.createElement("input");
        zip.setAttribute("class", "scz-cart-summary__shipping_estimate--zip");
        zip.setAttribute("scz-estimate-shipping-zip", "");
        zip.setAttribute("type", "text");
        zip.setAttribute("placeholder", "Votre code postal");
        zip.value = null;

        if (container.querySelector(selectors.estimateShippingZip) == null) {
          container.appendChild(zip);
        }
    }

    function populateResult (rates, address) {
        var price = rates[0].price;
        if (!rates.length || isNaN(price)) return;
        price = parseFloat(price) == 0? "Gratuit": parseFloat(price).toString() + '€';

        var countryCode = address.country;
        var countryElement = document.querySelector(selectors.estimateShippingPriceCountry);
        countryElement.innerHTML = countryCode;

        var priceElement = document.querySelector(selectors.estimateShippingPrice);
        priceElement.innerHTML = price;

        var root = document.getElementById(this.block_id);
        if (!root) return;

        var update = root.querySelector(selectors.estimateShippingConfirm);
        var listCountries = root.querySelector(selectors.estimateShippingCountries);
        var confirm = root.querySelector(selectors.estimateShippingConfirm);

        update.classList.remove(classes.active);
        listCountries.classList.remove(classes.active);
        confirm.classList.remove(classes.active);
    }

    return SummaryManager;
  })();

var block_type = block_type || {};

block_type.button = new (function () {

    var self;

    //Manage Button
    function ButtonManager (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [],  true);
      self = this;
    }

    toolBox.inheritPrototype(ButtonManager, generic_cart_block);

    ButtonManager.prototype.getHtml = function () {
      let data = this.generateRenderOptions();
      // commonsFilters.priceFormatter(total)

      return toolBox.renderTemplate(self.cartManager.templatesSelectors.button, data);
    }

    ButtonManager.prototype.generateRenderOptions = () => {
      let block = self.settings;
      let cart = self.cartManager.getCopyOfCart();

      var options = {
        id: self.block_id,
        money_formats: self.money_formats,
        cartIsEmpty: cart.item_count == 0,
        title: block.configurations.title,
        url: block.configurations.url,
        width: block.configurations.width,
        button_align: block.configurations.button_align,
        active_hover: block.configurations.active_hover,
        text_align: block.configurations.text_align,
        cartShopify: cart
      };

      return options;
    }

    return ButtonManager;
  })();

var block_type = block_type || {};

block_type.icons = new (function () {

    var self;

    //Manage Icons
    function IconsManager (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [],  true);
      self = this;
    }

    toolBox.inheritPrototype(IconsManager, generic_cart_block);

    IconsManager.prototype.getHtml = function () {
      let cart = self.cartManager.getCopyOfCart();
      let data = generateRenderOptions(self.settings, cart);
      // commonsFilters.priceFormatter(total)

      return toolBox.renderTemplate(self.cartManager.templatesSelectors.icons, data);
    }

    const generateRenderOptions = (block, cart) => {
      var options = {
        id: self.block_id,
        money_formats: self.money_formats,
        cartIsEmpty: cart.item_count == 0,
        numberPerRow: block.configurations.number_per_row,
        align: block.configurations.align,
        cartShopify: cart,
        icons: self.settings.icons
      };

      return options;
    }

    return IconsManager;
  })();

var block_type = block_type || {};

block_type.featured_upsell  = new (function () {

    var domAttributes = {
        input: 'scz-featured-upsell-input'
    }

    var domClasses = {
        hide_input: 'scz-featured-upsell--hide',
        loading   : 'scz-featured-upsell--loading'
    };

    var selectors = {
        input: `[${domAttributes.input}]`,
        hide_input: `.${domClasses.hide_input}`,
        loading: `.${domClasses.loading}`
    };

    function Block(cartManager, block) {

        var eventListeners = [
            {
                event: 'change',
                handler: changeInput.bind(this)
            }
        ]

        // Indicates whether there is an active cart request with Shopify
        this.blocked = false;

        // Add event listener.
        generic_cart_block.call(this, cartManager, block, eventListeners, true);

        this.title            = toolBox.getProp(block, "configurations.title", "");
        this.description      = toolBox.getProp(block, "configurations.description", "");
        this.input_label      = toolBox.getProp(block, "configurations.input_label", "");
        this.hide_if_selected = toolBox.getProp(block, "configurations.hide_if_selected", false);
        this.variant_id       = toolBox.getProp(block, "configurations.variant_id", "");
        this.style            = toolBox.getProp(block, "configurations.style", "");
        this.image            = toolBox.getProp(block, "configurations.image", "");
        this.product_price    = toolBox.getProp(block, "configurations.product_price", "");
    }

    toolBox.inheritPrototype(Block, generic_cart_block);

    Block.prototype.getHtml = function () {

        var cart       = this.cartManager.getCopyOfCart();
        var attribute  = getItemProperty(this.variant_id);
        var product = cart.items.find(item => toolBox.hasAttribute(item, attribute));

        let data = {
            id          : this.block_id,
            money_formats: this.money_formats,
            title       : this.title,
            description : this.description,
            style : this.style,
            description : this.description,
            image : this.image,
            input_label : this.input_label,
            product_price : this.product_price,
            input_attr  : domAttributes.input,
            is_checked  : !!product,
            cartShopify: cart
        };

        return toolBox.renderTemplate(this.cartManager.templatesSelectors.featured_upsell, data);
    }

    Block.prototype.on_updated = function () {
        this.toggleHideClass();

        // Add hide class
        changeInput.bind(this)();
    }

    Block.prototype.on_rendered = function () {
        changeInput.bind(this)();
    }

    /********************************************/
    /* PRIVATE FUNCTIONS       */
    /********************************************/
    function getItemProperty(variantId) {
        return {
            name: `_featured_upsell_${variantId}`,
            value: `unlocked`
        }
    }

    function changeInput(e) {
        if (this.blocked)
            return;

        // Get dom input.
        var root = document.getElementById(this.block_id);
        if (!root) return;

        var input = root.querySelector(selectors.input);
        // Check if featured upsell is already added.
        var cart       = this.cartManager.getCopyOfCart();
        var attribute  = getItemProperty(this.variant_id);
        var product = cart.items.find(item => toolBox.hasAttribute(item, attribute));
        var hasProduct = !!product;

        if (input.checked && !hasProduct) {
            this.toggleLoadingClass();

            root.classList.remove(domClasses.hide_input);

            let rewardProperty = getItemProperty(this.variant_id);
            let properties = {};
            properties[rewardProperty.name] = rewardProperty.value;

            let formData = {
                id: this.variant_id,
                quantity: 1,
                properties: properties
            };

            this.cartManager.postShopify(formData, this.cartManager.CART_REQUEST_TYPES.ADD, {
                onSuccess: itemAdded.bind(this),
                onFailure: itemAdded.bind(this),
                always   : unblock.bind(this)
            })
        } else if (!input.checked && hasProduct) {
            this.toggleLoadingClass();

            if (this.hide_if_selected)
                root.classList.add(domClasses.hide_input);

            let formData = {
                id: product.key,
                quantity: 0
            }
            this.cartManager.postShopify(formData, this.cartManager.CART_REQUEST_TYPES.CHANGE, {
                onSuccess: itemRemoved.bind(this),
                onFailure: itemAdded.bind(this),
                always   : unblock.bind(this)
            })
        }
    }

    function itemAdded() {}

    function itemRemoved () {}

    function unblock () {
        this.toggleLoadingClass();
    }

    Block.prototype.toggleHideClass = function () {
        var cart       = this.cartManager.getCopyOfCart();
        var attribute  = getItemProperty(this.variant_id);
        var product = cart.items.find(item => toolBox.hasAttribute(item, attribute));
        document.getElementById(this.block_id).classList[this.hide_if_selected && !!product?'add':'remove'](domClasses.hide_input);
    }

    Block.prototype.toggleLoadingClass = function () {
        // Add loading class;
        let hasClass = document.getElementById(this.block_id).classList.contains(domClasses.loading);
        document.getElementById(this.block_id).classList[hasClass?'remove':'add'](domClasses.loading);
        // Block
        this.blocked = !hasClass;
    }

    /*********************************/
    /* PUBLIC STATIC FUNCTIONS       */
    /*********************************/
    Block.isFeaturedUpsell = function (item) {
        let attribute = getItemProperty(item.variant_id);
        return toolBox.hasAttribute(item, attribute);
    }

    return Block;
})();

var block_type = block_type || {};

block_type.slider = new (function () {

    const selectors = {
      // The slider selectors.
      slider_root : '[scz-cart__slider]',
      slider_dots : '[scz-cart__slider__dots]',
      slider_next : '[scz-cart__slider__next]',
      slider_prev : '[scz-cart__slider__prev]'
    }

    //Manage slider
    function Block (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [], true);

      this.title                 = toolBox.getProp(block, "configurations.title", "");
      this.active_dots           = toolBox.getProp(block, "configurations.slider_options.active_dots", false);
      this.active_arrows         = toolBox.getProp(block, "configurations.slider_options.active_arrows", false);

      this.slides                 = toolBox.getProp(block, "configurations.slides", []);
      this.slides                 = typeof this.slides === "object"? this.slides:{};

      this.slider_options        = toolBox.getProp(block, "configurations.slider_options", {});
      this.slider_options        = typeof this.slider_options === "object"? this.slider_options:{};
    }

    toolBox.inheritPrototype(Block, generic_cart_block);

    Block.prototype.getHtml = function () {
      let cart = self.cartManager.getCopyOfCart();

      var data = {
        id               : this.block_id,
        money_formats    : this.money_formats,
        title            : this.title,
        active_dots      : this.active_dots,
        active_arrows    : this.active_arrows,
        slides           : this.slides
      };

      // Build template
      return toolBox.renderTemplate(self.cartManager.templatesSelectors.slider, data, {});
    }

    Block.prototype.on_rendered = function () {
      this.initGlider();
    }

    Block.prototype.on_updated = async function () {
      var html = await this.getHtml();
      var oldBlock = document.getElementById(this.block_id);
      var newBlock = toolBox.htmlToElement(html);
      // update dom.
      oldBlock.parentNode.replaceChild(newBlock, oldBlock);
      this.initGlider();
    }

    Block.prototype.initGlider = function () {
      var slider = document.getElementById( this.block_id ).querySelector(selectors.slider_root);
      if (!slider) return;

      new Glider(slider, {
        ...this.slider_options,
        dots: selectors.slider_dots,
        arrows: {
          prev: selectors.slider_prev,
          next: selectors.slider_next
        }
      });
    }

    return Block;

  })();

var block_type = block_type || {};

block_type.note = new (function () {

    const selectors = {
      // The slider selectors.
      input                 : '[scz-cart__note-input]',
      toggle_collapse_note   : '[scz-cart__note-collapse-toggle]',
      open_slide_note      : '[scz-cart__note-slide-open]',
      close_slide_note      : '[scz-cart__note-slide-close]',
      toggle_slide_note      : '[scz-cart__note-slide-toggle]',
      container_collapse_note : '[scz-cart__note-collapse-container]',
      container_slide_note  : '[scz-cart__note-slide-container]',
      chars_count           : '[scz-cart__note-chars-count]',
      remaining_chars_count : '[scz-cart__note-remaining-chars-count]',
      max_chars_count       : '[scz-cart__note-max-chars]'
    }

    const classes = {
      active   : 'scz-cart-note--active',
      updating : 'scz-cart-note--updating',
      updated  : 'scz-cart-note--updated'
    };

    //Manage slider
    function Block (cartManager, block) {
      generic_cart_block.call(this, cartManager, block, [
        {
            $ele: selectors.input,
            event: 'input',
            handler: toolBox.debounce(async function () {
              await this.noteChangedHandler();
            }.bind(this), 1000)
        },
        {
            $ele: selectors.toggle_collapse_note,
            event: 'click',
            handler: noteCollapseToggle.bind(this)
        },
        {
            $ele: selectors.toggle_slide_note,
            event: 'click',
            handler: noteSlideToggle.bind(this, selectors.toggle_slide_note)
        },
        {
            $ele: selectors.close_slide_note,
            event: 'click',
            handler: noteSlideToggle.bind(this, selectors.close_slide_note)
        },
        {
            $ele: selectors.open_slide_note,
            event: 'click',
            handler: noteSlideToggle.bind(this, selectors.open_slide_note)
        }
      ], false);

      this.title      = toolBox.getProp(block, "configurations.title", "");
      this.subtitle   = toolBox.getProp(block, "configurations.subtitle", []);
      this.style   = toolBox.getProp(block, "configurations.style", "block");
      this.placeholder   = toolBox.getProp(block, "configurations.placeholder", "block");
      this.image_slide   = toolBox.getProp(block, "configurations.image_slide", "block");
      this.title_slide   = toolBox.getProp(block, "configurations.title_slide", "block");
      this.subtitle_slide   = toolBox.getProp(block, "configurations.subtitle_slide", "block");
      this.buton_slide   = toolBox.getProp(block, "configurations.buton_slide", "block");
      this.max_chars  = toolBox.getProp(block, "configurations.max_chars", {});
    }

    toolBox.inheritPrototype(Block, generic_cart_block);

    Block.prototype.getHtml = function () {
      let cart = self.cartManager.getCopyOfCart();

      var data = {
        id             : this.block_id,
        money_formats  : this.money_formats,
        cart,
        title          : this.title,
        subtitle       : this.subtitle,
        placeholder    : this.placeholder,
        style          : this.style,
        image_slide    : (this.style == 'slide') ? this.image_slide : null,
        title_slide    : (this.style == 'slide') ? this.title_slide : null,
        subtitle_slide : (this.style == 'slide') ? this.subtitle_slide : null,
        buton_slide    : (this.style == 'slide') ? this.buton_slide : null,
        note           : cart.note,
        chars_count    : cart.note? cart.note.length:0,
        remaining_chars_count : cart.note? this.max_chars - cart.note.length:0,
        max_chars      : this.max_chars
      };

      // Build template
      return toolBox.renderTemplate(self.cartManager.templatesSelectors.note, data, {});
    }

    Block.prototype.on_updated = function () {
        /* keep this function to prevent reloading the input ... but do nothing */
    }

    Block.prototype.reset = function () {

    }

    Block.prototype.noteChangedHandler = async function () {
        let $root = document.querySelector(`#${this.block_id}`);
        if (!$root)
          return;

        let $input = $root.querySelector(selectors.input);
        let note = $input.value;

        // Truncate input value.
        if (note.length > this.max_chars) {
            $input.value = note.slice(0, this.max_chars);
            note = $input.value;
        }

        // Update count indicator
        let $counter = $root.querySelector(selectors.chars_count);
        if ($counter)
          $counter.textContent = note.length

        // Update remaining chars indicator
        let $remainingCounter = $root.querySelector(selectors.remaining_chars_count);
        if ($remainingCounter)
          $remainingCounter.textContent = this.max_chars - note.length

        // Update note.
        $root.classList.remove(classes.updated);
        $root.classList.add(classes.updating);
      
      	console.log(' update attribute ' , note);
//       await this.cartManager.updateNote(note, {disable_loader: true});
      
     	await this.cartManager.updateAttribute({'MessagePerso' : note}, {disable_loader: true});

        $root.classList.remove(classes.updating);
        $root.classList.add(classes.updated);
    }

    async function noteCollapseToggle() {
      let $root = document.querySelector(`#${this.block_id}`);
      if (!$root)
        return;

      let $note_collapse = $root.querySelector(selectors.toggle_collapse_note);

      if ($note_collapse.checked) {
        $root.querySelector(selectors.container_collapse_note).classList.add(classes.active);
      } else {
        $root.querySelector(selectors.input).value = '';
        await this.cartManager.updateNote('');
        $root.querySelector(selectors.container_collapse_note).classList.remove(classes.active);
      }
    }

    async function noteSlideToggle(selector) {
      let $root = document.querySelector(`#${this.block_id}`);
      if (!$root)
        return;

      let $note_slide = $root.querySelector(selectors.toggle_slide_note);

      if (selector == selectors.toggle_slide_note) {
        if ($note_slide.checked) {
          $root.querySelector(selectors.container_slide_note).classList.add(classes.active);
          $root.querySelector(selectors.open_slide_note).classList.add(classes.active);
        } else {
          $root.querySelector(selectors.input).value = '';
          await this.cartManager.updateNote('');
          $root.querySelector(selectors.container_slide_note).classList.remove(classes.active);
          $root.querySelector(selectors.open_slide_note).classList.remove(classes.active);
        }
      } else if (selector == selectors.close_slide_note) {
        if ($note_slide.checked) {
          $root.querySelector(selectors.container_slide_note).classList.remove(classes.active);
        }
      } else if (selector == selectors.open_slide_note) {
        if ($note_slide.checked) {
          $root.querySelector(selectors.container_slide_note).classList.add(classes.active);
        }
      }

      if ($root.querySelector(selectors.container_slide_note).classList.contains(classes.active)) {
        document.getElementById(cartManager.section_id).querySelector('#scz-cart-container__js').style.overflowY = "hidden";
        var top = document.getElementById(cartManager.section_id).querySelector('#scz-cart-container__js').scrollTop + "px";
        $root.querySelector(selectors.container_slide_note).style.top = top;
      } else {
        document.getElementById(cartManager.section_id).querySelector('#scz-cart-container__js').style.overflowY = "auto";
      }

    }

    return Block;

  })();

const PopupManager = new (function () {

  var self;

  const selectors = {};

  function Popup () {
    self = this;
    self.section_id = cartManager.section_id;
    self.templatesSelectors = cartManager.templatesSelectors;
    self.selectors = cartManager.selectors;
    self.classes = cartManager.classes;
  }

  /*********************************/
  /* PUBLIC STATIC FUNCTIONS       */
  /*********************************/

  /**
   *
   * @param {HTML}     template            the template of the popup content.
   * @param {Object}   data
   */
  Popup.prototype.initPopup = function (template, data) {
      self.openPopup(template, data.options);
  }


  /**
   *
   * @param {HTML}     template            the template of the popup content.
   * @param {Object}   options
   * @param {Function} options.onSubmit    called on submit.
   * @param {Function} options.onCancel    called on cancel.
   */
  Popup.prototype.openPopup = function (template, options) {
    if (!template) return;

    if (document.getElementById(self.section_id).querySelector('.'+self.templatesSelectors.popup) == null) {
      // Add template to DOM
      document.getElementById(self.section_id).appendChild(template);
      // Add class active
      setTimeout(() => document.querySelector(self.selectors.popup).classList.add(self.classes.popupActive), 0);
      // Add submit event
      document.querySelector(self.selectors.popupSubmit).addEventListener("click", function (e) {
        self.submitPopup(options);
      }.bind(self))
    }
  }

  Popup.prototype.closePopup = async function () {
    if (document.querySelector(self.selectors.popup) != null) {
      document.querySelector(self.selectors.popup).classList.remove(self.classes.popupActive);
    }
    if (document.querySelector('[' + self.templatesSelectors.popup + ']') != null) {
      setTimeout(() => document.querySelector('[' + self.templatesSelectors.popup + ']').remove(), 600);
    }
  }

  /**
   *
   * @param {Object}   options
   * @param {Function} options.onSubmit    called on submit.
   * @param {Function} options.onCancel    called on cancel.
   */
  Popup.prototype.submitPopup = async function (options) {

    if (self.isPopupUpdating)
      return;

    if (!options.onSubmit || typeof options.onSubmit !== 'function')
      options.onSubmit = function () {};

    // Activate loader.
    self.updateLoaderVisibilityStatePopup(true);

    options.onSubmit();
  }


  /**
   *
   * @param {Boolean}   isUpdating
   */
  Popup.prototype.updateLoaderVisibilityStatePopup = function (isUpdating) {
    if (self.isPopupUpdating == isUpdating) {
      return;
    } else if (isUpdating) {
      document.querySelector(self.selectors.popupSubmitLoader).classList.add(self.classes.loaderActive);
      document.querySelector(self.selectors.popupSubmitLabel).classList.add(self.classes.loaderActive);
    } else {
      document.querySelector(self.selectors.popupSubmitLoader).classList.remove(self.classes.loaderActive);
      document.querySelector(self.selectors.popupSubmitLabel).classList.remove(self.classes.loaderActive);
      self.closePopup();
    }
    self.isPopupUpdating = isUpdating;
  }



  /*********************************/
  /* PRIVATE FUNCTIONS       */
  /*********************************/

  return Popup;

})();

const ProductPopupManager = new (function (type, product_handle, line_item, options) {

  var self;

  const selectors = {

    //Price subscription
    'priceSubscription'  : '[szc-popup-subscription-price]',
    'priceNoSubscription'  : '[szc-popup-no-subscription-price]',
    'priceOriginal'  : '[szc-popup-original-price]',
    'discountPercentage'  : '[szc-popup-discount-percentage]',

    //Price one-shot
    'priceUnit'  : '[szc-popup-unit-price]',
    'priceCompare'  : '[szc-popup-compare-price]',

    //Variants
    'singleOption'  : '[scz-cart-popup-product-single-option]',
    'masterVariantSelector'  : '[scz-cart-popup-product-variant]',

    //Quantity
    'quantityContainer'  : '[scz-cart-popup-item-quantity-container]',
    'quantityInput'  : '[scz-cart-popup-item-quantity]',
    'quantityIncrease'  : '[scz-cart-popup-item-quantity-increase]',
    'quantityDecrease'  : '[scz-cart-popup-item-quantity-decrease]',

    "subscriptionFrequency" : "[scz-cart-popup-subscription-frequency]",

  };

  const classes = {
    'priceCompareActive'  : 'scz-cart-popup-content-product-compare-price--active',
  };

  function ProductPopup (type, product_handle, line_item, options) {
    self = this;
    self.section_id = cartManager.section_id;
    self.templatesSelectors = cartManager.templatesSelectors;
    self.selectors = cartManager.selectors;
    self.classes = cartManager.classes;

    if (options.enable_variants) {
      self.singleOptions = null;
    }

    if (options.enable_quantity) {
      self.quantity = null;
    }

    if (!product_handle) return;

    self.productHandler = new shopifyProduct(product_handle, {
      "metafields": {}
    });

    self.initPopup(type, product_handle, line_item, options);

  }

  /*********************************/
  /* PUBLIC STATIC FUNCTIONS       */
  /*********************************/

  /**
   *
   * @param {HTML}     template            the template of the popup content.
   * @param {Object}   data
   */
  ProductPopup.prototype.initPopup = async function (type, product_handle, line_item, settings) {

      var product = await self.productHandler.getProduct();

      if (!product) return;

      var options = {
        onSubmit: function () {
          var popup = cartManager.root.querySelector(self.selectors.popup);
          // Get quantity.
          var quantity = popup.querySelector(selectors.quantityInput).value;
              quantity = Math.max(parseInt(quantity), 0);

          // Get variant
          var variant_id = popup.querySelector(selectors.masterVariantSelector).value;

          if (type == 'add') {
            cartManager.addItem(variant_id, quantity, {}, {
              always : popupManager.updateLoaderVisibilityStatePopup(false)
            });
          } else if (type == 'update' || type == 'updateNonNativeRecharge') {

            if (type == 'updateNonNativeRecharge') {
              if (settings.frequency) {
                var properties = popup.querySelector(selectors.subscriptionFrequency).value;
              } else {
                var properties = {
                  "shipping_interval_frequency": line_item.metafields.shipping_interval_frequency[0],
                  "shipping_interval_unit_type": line_item.metafields.shipping_interval_unit_type,
                  "subscription_id": line_item.metafields.shipping_subscription_id
                };
              }
            } else {
              var properties = {origin: "side_cart"};
            }

            let formData = {
                quantity,
                properties
            };

            try { formData.properties = JSON.parse(formData.properties); } catch (e) {console.error("Error parsing item's properties =>", formData);}

            cartManager.replaceItem(line_item.key, variant_id, formData, popupManager.updateLoaderVisibilityStatePopup(false));
          } else if (type == 'replace') {

            if (settings.frequency) {
              var properties = popup.querySelector(selectors.subscriptionFrequency).value;
            } else {
              var properties = {
                "shipping_interval_frequency": line_item.metafields.shipping_interval_frequency[0],
                "shipping_interval_unit_type": line_item.metafields.shipping_interval_unit_type,
                "subscription_id": line_item.metafields.shipping_subscription_id
              };
            }

            // TODO: Get subscription type from parent (cartManager) & decide the appropriate way to get the target variant id.
            var rechargeVariantId = toolBox.getProp(line_item, `metafields.original_to_hidden_variant_map.${line_item.variant_id}.discount_variant_id`, line_item.variant_id);

            let formData = {
                quantity,
                properties
            };

            try { formData.properties = JSON.parse(formData.properties); } catch (e) {console.error("Error parsing item's properties =>", formData);}

            console.log(line_item.metafields.original_to_hidden_variant_map);
            console.log(line_item.variant_id);
            console.log(line_item.key);
            console.log(rechargeVariantId);
            console.log(formData);
            cartManager.replaceItem(line_item.key, rechargeVariantId, formData, popupManager.updateLoaderVisibilityStatePopup(false));
          }
        }.bind(this),
        onCancel: function () {}
      };

      if (line_item) {
        var variant_id = line_item.variant_id;
      } else {
        var variant_id = product.variants[0].id;
      }

      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id == variant_id) {
          var original_line_price = product.variants[i].price;
          var compare_at_price = product.variants[i].compare_at_price;
        }
      }


      var data = {
        item: {
          featured_image: product.featured_image,
          title: product.title,
          variant_title: (line_item) ? line_item.variant_title : product.variants[0].title,
          variants: product.variants,
          variants_options: product.options,
          original_line_price: original_line_price,
          compare_at_price: compare_at_price,
          metafields: (line_item) ? line_item.metafields : {},
          properties: (line_item) ? line_item.properties : {},
          quantity: {
            min: 1,
            max: 200,
            value: (line_item) ? line_item.quantity : 1
          }
        },
        settings: settings,
        money_formats : cartManager.money_formats,
        form_type: type,
        selected_variant_options : (line_item) ? line_item.variant_options : product.variants[0].title.split(" / "),
        selected_variant : (line_item) ? line_item.variant_id : product.variants[0].id,
        options: options
      };


      // Build popupTemplate
      var popupTemplate = toolBox.renderTemplate(self.templatesSelectors.popup, data);
      var newPopupTemplate = toolBox.htmlToElement(popupTemplate);

      // Open popup
      const popupManager = new PopupManager(data);
      popupManager.openPopup(newPopupTemplate, data.options);


      // event select variants
      self.singleOptions = document.querySelectorAll(selectors.singleOption);
      if (self.singleOptions) {
        self.singleOptions.forEach(
          function(option) {
            option.addEventListener('change', self.popupSelectVariantChange.bind(self));
          }.bind(self)
        );

        self.popupSelectVariantChange();
      }

      // init quantity Input
      self.quantityInputPopup({
        min: 1,
        max: 200,
        value: (line_item) ? line_item.quantity : 1
      });
  }


  ProductPopup.prototype.popupSelectVariantChange = async function () {
    var selectedVariantOptions = [];
    if (self.singleOptions) {
      self.singleOptions.forEach(
        function(option) {
          selectedVariantOptions.push(option.value);
        }.bind(self)
      );
    }

    var variant = await self.productHandler.findVariantFromOptions(selectedVariantOptions);
    self.currentVariant = variant;

    console.log(variant);

    if (!variant) {
      return;
    }

    self.updatePopupMasterSelect(variant);
    updatePrices();
  }

  /**
   *
   * @param {Object}   variant
   */
  ProductPopup.prototype.updatePopupMasterSelect = function (variant) {
    var masterVariantSelector = document.querySelector(selectors.masterVariantSelector);
    if (!masterVariantSelector) return;
    masterVariantSelector.value = variant.id;
  }

  /**
   *
   * @param {object}   options
   */
  ProductPopup.prototype.quantityInputPopup = function (options) {
    const spinner = document.querySelector(selectors.quantityContainer);

    const defaultOptions = {
      min: 1,
      max: 250,
      value: 1,
    };

    options = Object.assign({}, defaultOptions, options);

    const obj = {

      input: spinner.querySelector(selectors.quantityInput),
      init() {
        this.setup();
        this.events();
        return this;
      },
      setup() {

        this.input.value = options.value;
        this.max = options.max;
        this.min = options.min;

        this.btnUp = spinner.querySelector(selectors.quantityIncrease);
        this.btnDown = spinner.querySelector(selectors.quantityDecrease);
      },
      trigger() {
        const event = document.createEvent('HTMLEvents');
        event.initEvent('change', true, false);
        return event;
      },
      events() {
        this.btnUp.addEventListener('click', () => {
          const oldValue = parseFloat(this.input.value);
          let newVal;
          if (oldValue >= this.max) {
            newVal = oldValue;
          } else {
            newVal = oldValue + 1;
          }
          this.input.value = newVal;
          updatePrices();
          this.input.dispatchEvent(this.trigger());
        });

        this.btnDown.addEventListener('click', () => {
          const oldValue = parseFloat(this.input.value);
          let newVal;
          if (oldValue <= this.min) {
            newVal = oldValue;
          } else {
            newVal = oldValue - 1;
          }
          this.input.value = newVal;
          updatePrices();
          this.input.dispatchEvent(this.trigger());
        });
        this.input.addEventListener('change', () => {
          if (parseInt(this.input.value, 16) < this.min) {
            this.input.value = this.min;
          }
          if (parseInt(this.input.value, 16) > this.max) {
            this.input.value = this.max;
          }
          updatePrices();
        });
      },
    }
    return obj.init();
  }

  /*********************************/
  /* PRIVATE FUNCTIONS       */
  /*********************************/

  function updatePrices() {

    self.quantity = document.querySelector(selectors.quantityInput).value;

    //subscription price
    var priceSubscription = document.querySelector(selectors.priceSubscription);
    if (priceSubscription) {
      var priceNoSubscription = document.querySelector(selectors.priceNoSubscription);
      var priceUnit = parseInt(document.querySelector(selectors.priceOriginal).getAttribute('szc-popup-original-price'));
      var discountPercentage = document.querySelector(selectors.discountPercentage).getAttribute('szc-popup-discount-percentage');

      var newSubscriptionPrice = (priceUnit * ((100 - discountPercentage) / 100)) * self.quantity;
      var newNoSubscriptionPrice = priceUnit * self.quantity;

      priceSubscription.textContent = window.__ascf.formatMoney(newSubscriptionPrice, "{{with_comma_separator}}€");
      priceNoSubscription.textContent = window.__ascf.formatMoney(newNoSubscriptionPrice, "{{with_comma_separator}}€");
    }

    //one shot priceUnit
    var priceUnit = document.querySelector(selectors.priceUnit);
    if (priceUnit) {
      var newPriceUnit = self.currentVariant.price * self.quantity;
      document.querySelector(selectors.priceUnit).textContent = window.__ascf.formatMoney(newPriceUnit, "{{with_comma_separator}}€");

      if (self.currentVariant.compare_at_price) {
        var newPriceCompare = self.currentVariant.compare_at_price * self.quantity;
        document.querySelector(selectors.priceCompare).textContent = window.__ascf.formatMoney(newPriceCompare, "{{with_comma_separator}}€");
        document.querySelector(selectors.priceCompare).classList.add(classes.priceCompareActive);
      } else {
        document.querySelector(selectors.priceCompare).classList.remove(classes.priceCompareActive);
      }
    }
  }

  return ProductPopup;

})();

var block_type = block_type || {};

const CartManager = new (function () {

  let self = undefined;
  let $ = ZDOM;

  var blocks_list = [];
  var shopifyCart = undefined;

  const selectors = {
    /////
    'cartTrigger'  : '[scz-cart-trigger]',
    'cartClose'    : '[scz-cart-close]',
    'itemsCounter' : '[scz-cart-items-counter]',

    ///// ...
    'loader'      : '[scz-loader]',

    ///// parts

    // Wrapper.
    'cart': '[scz-cart]',

    // Content wrappers (blocks are distributed in 3 sections : top - middle or bottom)
    'cart_top_items_container'   : '[data-cart-top]',
    'cart_middle_items_container': '[data-cart-middle]',
    'cart_bottom_items_container': '[data-cart-bottom]',

    // Overlay if activated.
    'cartOverlay': '[scz-cart-overlay]',

    // Generic popup utility selectors.
    'popup'             : '[scz-cart-popup]',
    'popupSubmit'       : '[scz-cart-popup-submit]',
    'popupClose'        : '[scz-cart-popup-close]',
    'popupContent'      : '[scz-cart-popup-content]',
    'popupSubmitLabel'  : '[scz-cart-popup-submit-label]',
    'popupSubmitLoader' : '[scz-cart-popup-submit-loader]',

    // 'cartHeader': '[scz-cart-header]',
    // 'cartItems': '[scz-cart-items]',
    // 'cartItem': '[scz-cart-item]',
    // 'cartItemRemove': '[scz-cart-item-remove]',
    // 'cartItemQuantityDecrement': '[scz-cart-item-quantity-decrement]',
    // 'cartItemQuantityIncrement': '[scz-cart-item-quantity-increment]',
    // 'cartFooter': '[scz-cart-footer]',
  };

  const classes = {
    'cartOpen'     : 'scz-cart-open',
    'cartTranslate': 'scz-animate-translate',
    'overlayActive': 'scz-overlay-active',
    'loaderActive' : 'scz-loader-active',
    'popupActive'  : 'scz-cart-popup-active',
  };

  const templatesSelectors = {
    // Global
    ///////////////////
    'container': 'scz-cart-container',
    'overlay': 'scz-cart-overlay',

    // Blocks
    ///////////////////
    'header': 'scz-cart-header',
    'footer': 'scz-cart-footer',
    'content': 'scz-cart-content',
    'items': 'scz-cart-items',
    'items_group': 'scz-cart-items_group',

    'richtext': 'scz-cart-richtext',
    'accordion': 'scz-cart-accordion',
    'rewards': 'scz-cart-rewards',
    'featured_upsell': 'scz-cart-featured_upsell',
    'spacer': 'scz-cart-spacer',
    'image': 'scz-cart-image',
    'summary': 'scz-cart-summary',
    'button': 'scz-cart-button',
    'spacer': 'scz-cart-spacer',
    'icons': 'scz-cart-icons',
    'upsell': 'scz-cart-upsell',
    'slider': 'scz-cart-slider',
    'note': 'scz-cart-note',

    // Items
    ///////////////////
    'basic_item': 'scz-cart-basic_item',
    'reward_item': 'scz-cart-reward_item',
    'item_adder_item': 'scz-cart-item_adder_item',
    'item_added_item': 'scz-cart-item_added_item',
    'featured_upsell_item': 'scz-cart-featured_upsell_item',
    'non_native_recharge': 'scz-cart-non_native_recharge_item',


    // Popups
    //////////////////
    'popup': 'scz-cart-popup'
  };

  const EVENTS = {
    CART_AFTER_INIT                   : "cart:init",
    CART_UPDATE                       : "cart:update",
    CART_UPDATE_ADD                   : "cart:update:add",
    CART_UPDATE_CLEAR                 : "cart:update:clear",
    CART_UPDATE_MODIFY                : "cart:update:update_content",

    SIDE_CART_BEFORE_OPEN             : "side_cart:before_open",
    SIDE_CART_OPENED                  : "side_cart:opened",
    SIDE_CART_BEFORE_CLOSE            : "side_cart:before_close",
    SIDE_CART_CLOSED                  : "side_cart:closed",
    SIDE_CART_BLOCK_BEFORE_MOUNTED    : "side_cart:block:before_mounted",
    SIDE_CART_BLOCK_MOUNTED           : "side_cart:block:mounted",
    SIDE_CART_BLOCK_UPDATED           : "side_cart:block:updated",
    SIDE_CART_BEFORE_RENDERING_BLOCKS : "side_cart:before_rendering_blocks",
    SIDE_CART_AFTER_RENDERING_BLOCKS  : "side_cart:after_rendering_blocks",

  }

  const CSS_DOM_CONTAINERS = {
    DESKTOP: "my_desktop_styles_id",
    MOBILE: "my_mobile_styles_id"
  };

  let shipping_data = {
    enabled     : true,
    storage_key : 'sz_cart_address',
    rates       : null,
    address     : null
  }

  let __shop = '';
  let __cart_proxy = '/cart.js';
  let __configuration_url = null;

  // Information that should be kept persistent even when the cart is closed.
  let vault = {};

  // Array of refuse rewards
  var refusedRewards = [];

  function Cart(options) {
    self = this;

    this.selectors = selectors;
    this.classes = classes;
    this.templatesSelectors = templatesSelectors;
    this.refusedRewards = refusedRewards;

    this.events = EVENTS;

    this.CART_REQUEST_TYPES = {
      ADD   : 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR : 'clear'
    }

    this.settings = null;

    var {shop, cart_proxy, configuration_url, configurations} = options;

    if (shop)
      __shop = shop;
    if (cart_proxy && typeof cart_proxy === 'string')
      __cart_proxy = cart_proxy;
    if (configurations && typeof configurations === 'object')
      this.settings = configurations;
    if (configuration_url)
      __configuration_url = configuration_url;
  }


  /**
  * Public fonctions
  */

  // init cart
  Cart.prototype.init = async function init() {
    // Fetch site configurations.
    if (!this.settings)
      this.settings = await getSettings();

    // Fetch Data // note really needed ?
    shopifyCart = await fetchCart();

    // Create the root element of the shopping cart (all generated blocks will be placed inside.)
    this.root_dom_id = toolBox.makeId(10, { prefix: "cart_root_" });
    document.querySelector("body").append(toolBox.htmlToElement(`
        <div id="${this.root_dom_id}"></div>
      `))

    this.root = document.getElementById(this.root_dom_id);

    // Detect cart interactions
    httpInterceptor.bind(this)(["/cart/add.js", "/cart/update.js", "/cart/change.js"], this.handleCartUpdates.bind(this));

    // Attach events
    this.handleEvents();

    this.cartVisibilityState = false;
    this.isUpdating = false;
    this.isPopupUpdating = false;

    // Default money format
    var shopifyCurrency = toolBox.getProp(Shopify, "currency.active", "EUR");

    ///// The problem this code is trying to solve :
    ///// We don't know where the currency is located for each local (before/after)

    // To avoid replacing it by liquid.
    var formatString = "{" + "{format}}";

    // Default format (currency last)
    var formatSeed = `${formatString}${shopifyCurrency}`;

    // Try to deduce format using Intl & Shopify.local.
    try {
      var locale = Shopify.locale + '-' + Shopify.locale.toUpperCase();
      // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
      var formatted = new Intl.NumberFormat(locale, { style: 'currency', currency: shopifyCurrency }).format(1);
      var currencySign = new Intl.NumberFormat(locale, { style: 'currency', currency: shopifyCurrency }).formatToParts().find(part => part.type == 'currency').value;
      formatSeed = formatted.split(currencySign).map(part => part != ""?formatString:currencySign).join(" ")
    } catch (e) {
      console.error("Couldn't get money format, reverting to default: ", formatSeed);
    }

    this.money_formats = {
      default: formatSeed.replace('format', 'default'),
      without_trailing_zeros: formatSeed.replace('format', 'without_trailing_zeros'),
      with_comma_separator: formatSeed.replace('format', 'with_comma_separator'),
      without_trailing_zeros_with_comma_separator: formatSeed.replace('format', 'without_trailing_zeros_with_comma_separator')
    }

    // Add plugins to the service.
    this.handlePlugins();

    // Dry runs blocks.
    this.dryBlockInit();

    dispatchEvent(EVENTS.CART_AFTER_INIT);
  }

  Cart.prototype.destroy = function () {
    // TODO - reset events
    // document.body.removeEventListener("click", self.handleEvents());

    // ATTENTION : DO NOT reset the shopify cart object. Why ?
    // Because it is used when updating cart on the website even when the cart is not yet init or destroyed.
    // shopifyCart = null;

    // reset blocks
    self.teardownBlocks();

    //remove styles
    self.teardownStyles();

    // clear cart content
    this.root.innerHTML = "";
  }

  Cart.prototype.teardownStyles = function () {
    var desktopStyles = document.getElementById(CSS_DOM_CONTAINERS.DESKTOP)
    if (desktopStyles) desktopStyles.remove();

    var mobileStyles = document.getElementById(CSS_DOM_CONTAINERS.MOBILE)
    if (mobileStyles) mobileStyles.remove();
  }

  Cart.prototype.teardownBlocks = function () {
    for (const block of blocks_list) {
      block.destroy();
    }
    blocks_list = [];
  }

  // Get events from cart
  Cart.prototype.handleEvents = function () {

    document.body.addEventListener("click", e => {
      if (!e.target || window.location.pathname.endsWith('/cart'))
        return;

      // if someone clicks on the cart link
      if (e.target.closest('a')) {
        var anchor = e.target.closest('a');
        var anchorPath = anchor.href && anchor.href != ""? new URL(anchor.href).pathname : "";
        if (anchorPath.endsWith("/cart") && !anchor.classList.contains('scz-cart-button-checkout')) {
          self.updateCartVisibilityState(true);

          e.stopPropagation();
          e.preventDefault();
        }
      }

      // for custom implementations, if someone clicks on an element tagged with our attribute.
      if (e.target.closest(selectors.cartTrigger)) {
        self.updateCartVisibilityState(true);

        e.stopPropagation();
        // e.preventDefault();
      }

      if (e.target.matches(selectors.popupClose)) {
        var popupManager = new PopupManager();
        document.querySelector(selectors.popupClose).addEventListener("click", popupManager.closePopup(), false);
        e.stopPropagation();
      }
    }, false)

    // Get duration to close
    const durationToClose = toolBox.getProp(self.settings, "animation.duration", {});
    const closeSideCart   = function (e) {
       if (!e.target || !e.target.matches(selectors.cartClose) && !e.target.matches(selectors.cartOverlay)) return;

      document.getElementById('scz-cart-container__js').classList.add("scz-cart-close");
      document.getElementById('scz-cart-overlay__js').classList.add("scz-cart-overlay__hide");

      setTimeout(function() {
        var popupManager = new PopupManager();
        popupManager.closePopup();
        self.updateCartVisibilityState(false);
      }, durationToClose);
    }

    // Close if clicking on the close icon.
    this.root.addEventListener("click", closeSideCart, false);

    // Close if clicking outside the cart
    const closeSettings = toolBox.getProp(self.settings, "section.close", {});
    if (closeSettings && closeSettings.on_outside_click) {
      document.body.addEventListener("click", closeSideCart, false);
    }

  }

  Cart.prototype.updateCartForCustomize = async function (cartVisibilityState) {

    // Get the last request & block this function.
    let requestedVisibility = cartVisibilityState; // this.cartVisibilityQueue.pop();

    if (requestedVisibility) {
      dispatchEvent(EVENTS.SIDE_CART_BEFORE_OPEN);

      /* Declare the style element */
      var styles = 'div[scz-cart] { opacity: 0 }';
             
      /* Create style element */
      var css = document.createElement('style');
      css.type = 'text/css';

      if (css.styleSheet)
          css.styleSheet.cssText = styles;
      else
          css.appendChild(document.createTextNode(styles));
        
      /* Append style to the head element */
      document.getElementsByTagName("head")[0].appendChild(css);

      await self.renderCart(self.settings.blocks);

      document.querySelector('[scz-cart]').classList.add("scz-animate-fade");
      document.querySelector('[scz-cart]').style.opacity = 1;
      document.querySelector('[scz-cart-overlay]').classList.add("scz-overlay-active");
      
      console.log("sidecart open");
      console.log(document.querySelector('[scz-cart]'));
      dispatchEvent(EVENTS.SIDE_CART_OPENED);
    } else {
      document.querySelector('[scz-cart]').remove();
      document.querySelector('[scz-cart-overlay]').remove();
    }
  }

  Cart.prototype.updateCartVisibilityState = async function (cartVisibilityState) {

    // Quit if the function is already being executed.
    if (this.cartVisibilityFunctionBlocked === true)
      return;


    // Get the last request & block this function.
    let requestedVisibility = cartVisibilityState; // this.cartVisibilityQueue.pop();
    this.cartVisibilityFunctionBlocked = true;



    if (self.cartVisibilityState == requestedVisibility) {
      shopifyCart = await fetchCart();
      this.notifyCartDependents();
    } else if (requestedVisibility) {
      dispatchEvent(EVENTS.SIDE_CART_BEFORE_OPEN);

      await self.renderCart(self.settings.blocks);

      $(selectors.cart).addClass(classes.cartTranslate);
      // $(selectors.cart).addClass(classes.cartOpen);
      setTimeout(() => {$(selectors.cart).addClass(classes.cartOpen);}, 21);
      $(selectors.cartOverlay).addClass(classes.overlayActive);

      dispatchEvent(EVENTS.SIDE_CART_OPENED);
    } else {
      dispatchEvent(EVENTS.SIDE_CART_BEFORE_CLOSE);

      $(selectors.cart).removeClass(classes.cartOpen);
      $(selectors.cartOverlay).removeClass(classes.overlayActive);
      setTimeout(() => self.destroy(), 400);

      dispatchEvent(EVENTS.SIDE_CART_CLOSED);
    }
    self.cartVisibilityState = requestedVisibility;

    this.cartVisibilityFunctionBlocked = false;

  }

  Cart.prototype.open = async function () {
    this.updateCartVisibilityState(true);
  }

  Cart.prototype.close = async function () {
    this.updateCartVisibilityState(false);
  }

  Cart.prototype.updateLoaderVisibilityState = function (isUpdating) {
    if (this.isUpdating == isUpdating) {
      return;
    } else if (isUpdating) {
      $(this.root).addClass(classes.loaderActive);
    } else {
      $(this.root).removeClass(classes.loaderActive);
    }
    this.isUpdating = isUpdating;
  }

  // Manage vault
  Cart.prototype.addToVault = function (key, value, persist) {
    vault[key] = value;

    if (persist) {
      // TODO: save to local storage avec key: vault_{{key}}
      let keyStorage = 'vault_' + key;
      localStorage.setItem(keyStorage, JSON.stringify(value));
    }
  }

  Cart.prototype.getFromVault = function (key) {
    // TODO: look in local storage for a corresponding key:vault_{{key}}
    let keyStorage = 'vault_' + key;
    if (localStorage.getItem(keyStorage)) {
      return JSON.parse(localStorage.getItem(keyStorage));
    } else {
      return vault[key];
    }
  }
  
   // Add or update note cart
  Cart.prototype.updateAttribute = async function (attribute, options) {
    const formData = {
      attributes:attribute
    };
    console.log("Update attributes function", formData);
    return this.postShopify(formData, this.CART_REQUEST_TYPES.UPDATE, {
      onSuccess: options && typeof options.onSuccess === 'function'?options.onSuccess:function () {},
      onFailure: options && typeof options.onFailure === 'function'? options.onFailure:function () {},
      always: options && typeof options.always === 'function'? options.always:function () {},
      disable_loader : true
    });
  }

  // Add or update note cart
  Cart.prototype.updateNote = async function (note, options) {
    const formData = {
      note: note
    };
    return this.postShopify(formData, this.CART_REQUEST_TYPES.UPDATE, {
      onSuccess: options && typeof options.onSuccess === 'function'?options.onSuccess:function () {},
      onFailure: options && typeof options.onFailure === 'function'? options.onFailure:function () {},
      always: options && typeof options.always === 'function'? options.always:function () {},
      disable_loader : true
    });
  }

  Cart.prototype.initBlocks = function () {
    this.teardownBlocks();

    const blocks = this.settings.blocks;
    for (let block of blocks) {
      try {
        let blockInstance = new block_type[block.block_type](self, block);

        blocks_list.push(blockInstance);
      } catch (e) {
        console.error(`Couldn't create an instance of block ${block.block_type}`, e)
      }
    }
  }

  // Dry runs over the blocks.
  Cart.prototype.dryBlockInit = function () {
    this.initBlocks();
    this.teardownBlocks();
  }

  Cart.prototype.initAssets = function () {
    //remove styles
    self.teardownStyles();

    // ajouter les variables CSS
    toolBox.loadStyles({
      id: CSS_DOM_CONTAINERS.DESKTOP, object: {
        ":root": toolBox.getProp(this, "settings.root_var", {})
      }
    });

    toolBox.loadStyles({
      id: CSS_DOM_CONTAINERS.MOBILE, max_width: "600px", object: {

      }
    });

    // executer les scripts de depart si besoin.
  }

  // render cart
  Cart.prototype.renderCart = async function () {
    self.initBlocks();
    self.initAssets();

    self.section_id = toolBox.makeId(5, { prefix: "side_cart_container_" });
    self.section_type = "side_cart";

    shopifyCart = await fetchCart();

    let containerData = {
      layout: self.settings.layout,
      spacings: self.settings.spacings
    };

    const container = toolBox.renderTemplate(self.templatesSelectors.container, containerData);
    self.template = `<section id="${self.section_id}" section-type="${self.section_type}">${container}</section>`;
    this.root.insertAdjacentHTML('beforeend', self.template);

    const overlaySettings = toolBox.getProp(self.settings, "section.overlay", {});

    if (overlaySettings && overlaySettings.enabled) {
      const overlayData = {
        opacity: overlaySettings.opacity
      };
      const overlay = toolBox.renderTemplate(self.templatesSelectors.overlay, overlayData);
      this.root.insertAdjacentHTML('beforeend', overlay);
    }

    await self.renderBlocks();
  }

  Cart.prototype.renderBlocks = async function () {
    dispatchEvent(EVENTS.SIDE_CART_BEFORE_RENDERING_BLOCKS);

    for (const block of blocks_list) {
      const blockEnabled = toolBox.getProp(block, "settings.configurations.enabled", false);
      if(!blockEnabled) continue;

      const blockScope = toolBox.getProp(block, "settings.configurations.scope", 1);
      if (blockScope == 1 && shopifyCart.item_count != 0) continue;
      if (blockScope == 2 && shopifyCart.item_count == 0) continue;

      let nodeTemplate = "";
      try {
        nodeTemplate = await block.getHtml();
      } catch (e) {
        console.error("Error rendering block", {block}, e);
        continue;
      }
      let node = toolBox.htmlToElement(nodeTemplate);

      // Fallback
      let target = document
        .getElementById(self.section_id);

      if (document.querySelector(self.selectors.cart_top_items_container)
       && document.querySelector(self.selectors.cart_bottom_items_container)
       && document.querySelector(self.selectors.cart_middle_items_container)) {
        if (block.pin_top)
          target = document.querySelector(self.selectors.cart_top_items_container)
        else if (block.pin_bottom)
          target = document.querySelector(self.selectors.cart_bottom_items_container)
        else
          target = document.querySelector(self.selectors.cart_middle_items_container)
      }

      let eventData = {
        block_type   : block.type,
        block_data   : block.settings,
        block_dom_id : block.block_id,
        cart         : shopifyCart
      };

      dispatchEvent(EVENTS.SIDE_CART_BLOCK_BEFORE_MOUNTED, eventData)

      target.append(node);

      dispatchEvent(EVENTS.SIDE_CART_BLOCK_MOUNTED, eventData)

      try {
        await block.markAsRendered();
      } catch (e) {
        console.error("Error marking block as rendered", {block}, e);
      }
    }

    dispatchEvent(EVENTS.SIDE_CART_AFTER_RENDERING_BLOCKS);
  }

  // When a major change occurs (e.g. clear cart), reload the entire content of the cart.
  Cart.prototype.reload = async function () {
    self.initBlocks();
    self.initAssets();

    document.querySelectorAll(`.scz-cart-container > *:not([scz-loader]`).forEach(item => item.innerHTML = "");
    var root = document.getElementById(self.section_id);
    var subItems = root
      .querySelectorAll(` .${self.templatesSelectors.container} > div:not([scz-loader])`)
    if (subItems.length)
      subItems.forEach(item => item.innerHTML = "");
    else if (root)
      root.innerHTML = "";

    await self.renderBlocks();
  }

  // Reload blocks which are affected by cart updates.
  Cart.prototype.notifyCartDependents = async function (shouldUpdateCart) {
    const updateBlocks = async function () {
      dispatchEvent(EVENTS.SIDE_CART_BEFORE_RENDERING_BLOCKS);

      // Loop over concerned blocks
      for (const block of blocks_list) {
        if (!block.cart_dependant)
          continue;
        await block.updateBlock();

        let eventData = {
          block_type   : block.type,
          block_data   : block.settings,
          block_dom_id : block.block_id,
          cart         : shopifyCart
        };

        dispatchEvent(EVENTS.SIDE_CART_BLOCK_UPDATED, eventData)
      }

      dispatchEvent(EVENTS.SIDE_CART_AFTER_RENDERING_BLOCKS);
    }

    if (shouldUpdateCart === true)
      fetchCart(true).then(async data => {
        shopifyCart = data;
        await updateBlocks();
      });
    else
      await updateBlocks();
  }

  // TODO: Test
  Cart.prototype.handlePlugins = () => {
    // Plugins management.
    if (toolBox.isEmpty(window.alfred_side_cart_plugins))
      return;

    let plugins = window.alfred_side_cart_plugins;

    // Get custom blocks.
    let customBlocks = toolBox.getProp(plugins, 'blocks', []);
    if (!Array.isArray(customBlocks) || !customBlocks.length)
      return;

    // Sort plugin blocks based on the custom property "order"
    // sort order is ascending
    customBlocks.sort((a, b) => {
      if ((isNaN(a.order) && isNaN(b.order)) || (a.order == b.order))
        return 0;
      else if ((!isNaN(a.order) && isNaN(b.order)) || (a.order > b.order))
        return 1
      else if ((!isNaN(b.order) && isNaN(a.order)) || (b.order > a.order))
        return -1
      return 0
    });

    let updatedBlocks = [];

    let header = {};
    let footer = {};

    for (const block of self.settings.blocks) {
      // There should only be one header & one footer .. if found in the custom blocks => replace default ones.
      if (block.block_type == "header")
        header = block;
      else if (block.block_type == "footer")
        footer = block;

      updatedBlocks.push(block);
    }

    for (const block of customBlocks) {
      // TODO - call a function to validate plugin block.

      var { order, _class, config } = block;
      if (toolBox.isEmpty(_class) || toolBox.isEmpty(config))
        continue;

      // Header & footer have a predefined positions (header at the top, footer at the bottom)
      if (config.block_type == "header")
        header = config;
      else if (config.block_type == "footer")
        footer = config;

      // Don't accept a new block of type items.
      else if (config.block_type == "items")
        continue;

      else if (order && order > 0 && order < updatedBlocks.length)
        // -1 because the header is not added yet.
        updatedBlocks.splice(order - 1, 0, config);
      else
        updatedBlocks.push(config);

      block_type[config.block_type] = _class
    }

    // header should be the first block.
    if (!toolBox.isEmpty(header))
      updatedBlocks.unshift(header);

    // Footer is always at the end
    if (!toolBox.isEmpty(footer))
      updatedBlocks.push(footer);


    // Get custom items.
    let customItems = toolBox.getProp(plugins, 'items', []);

    for (const block of customItems) {
      // TODO - call a function to validate plugin block.

      var { order, _class, config } = block;
      if (toolBox.isEmpty(_class) || toolBox.isEmpty(config))
        continue;

      // Don't accept a new block of type basic.
      if (config.block_type == "basic")
        continue;
      // TODO - validate item config & _class.

      item_types[config.block_type] = _class
    }
  }

  // Errors
  Cart.prototype.handleErrors = function (options) {
    console.log(options);
    const errorMessage = options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;

    // //A utiliser pour les erreur propre à nous sinon erreur shopify
    // if (error !== undefined) {
    //   console.log(error);
    // }
    //  const errorsMessages = this.settings.errorsMessages;
    //  const message = errorsMessages.action.message;
    //  return message;
  }

  /******************************************/
  /* CART HELPERS */
  /******************************************/

  // cart response.
  Cart.prototype.handleCartUpdates = async function (res, url) {
    let requiresFullUpdate = false;

    let cartBeforeUpdate   = this.getCopyOfCart();
    let newItemsAdded      = await this.updateLocalCartObject(res, url);
    let cartAfterUpdate    = this.getCopyOfCart();

    let shouldOpenCartOnUpdate = toolBox.getProp(this.settings, "section.open.on_cart_update", false);

    // TODO - check if the cart is augmented by any custom data (recharge subscriptions, metafields ... )

    /* VISUAL CART UPDATES */
    /***********************/

    // Open cart
    if (!this.cartVisibilityState // if cart is closed.
      && shouldOpenCartOnUpdate
      && cartAfterUpdate.item_count // not empty.
      && cartAfterUpdate.item_count > cartBeforeUpdate.item_count // make sure the update concerns adding NOT deleting items to the cart.
    )
      this.open();

    // Reload the entire cart
    else if (
      this.cartVisibilityState &&
      (
        (cartBeforeUpdate.item_count == 0 && cartAfterUpdate.item_count > 0)
        || (cartBeforeUpdate.item_count > 0 && cartAfterUpdate.item_count == 0)
      )
    )
      this.reload();

    // Only update cart-dependant blocks
    else if (this.cartVisibilityState)
      this.notifyCartDependents();

    // Do nothing.
    else  {}


    /* UPDATE ITEMS */
    /***********************/
    $(selectors.itemsCounter).each(item => item.textContent = cartAfterUpdate.item_count);

    /* EVENTS */
    /***********************/
    var requestVerb = (new URL(url)).pathname.replace(/(\/cart\/)([\D]*)(\.js)?/,function (match, p1,p2,p3) {
      return p2;
    });

    dispatchEvent(EVENTS.CART_UPDATE, {
      // Get the type of the request.
      response: res,
      request: requestVerb,
      item_count: cartAfterUpdate.item_count, // backward compatibility
      items_count: cartAfterUpdate.item_count,
      cart: cartAfterUpdate
    })
    var updateEventName = false;

    if (requestVerb.includes('add'))
      updateEventName = EVENTS.CART_UPDATE_ADD;
    if (requestVerb.includes('update'))
      updateEventName = EVENTS.CART_UPDATE_MODIFY;
    if (requestVerb.includes('clear'))
      updateEventName = EVENTS.CART_UPDATE_CLEAR;

    if (updateEventName)
      dispatchEvent(updateEventName, {
        // Get the type of the request.
        response: res,
        request: requestVerb,
        items_count: cartAfterUpdate.item_count,
        cart: cartAfterUpdate
      })

  }

  Cart.prototype.getCopyOfCart = function () {
    var cart = JSON.parse(JSON.stringify(shopifyCart));

    if (!cart.total_price_variations) {
      cart.total_price_variations = {

      }
    }

    return cart;
  }

  // ATTENTION:
  // res is Shopify's response after a post request.
  // if request is ADD => res contains only the added items.
  // otherwise (UPDATE/CHANGE/CLEAR) => the entire cart.
  // while updating cart we should make sure to update only updated properties.
  // @returns a bool indicating whether new items were added.
  Cart.prototype.updateLocalCartObject = async function (res, url) {
    try {
      console.log(shopifyCart.items);
      var newItemsAdded = false;

      // If items is not an array => convert it to array and continue execution.
      if (res && !Array.isArray(res.items) && typeof res == 'object' && res.key)
        res = {items: [res]};

      // If res is not provided, fetch cart & recall the function once fetched.
      if (!res || !Array.isArray(res.items) || typeof res.items != 'object') {
        res = await fetchCart();
      }

      else if (url.includes('/change'))
        res = await fetchCart();

      // If the operation is add and the local copy of the cart is empty => fetch the entire cart.
      // If the operation is update and the local copy of the cart is empty and the operation resulted in a non-empty cart => update the entire cart.
      else if (!shopifyCart.items.length && (url.includes('/add') || (res.items && res.items.length && url.includes('/update'))  )) {
        res = await fetchCart();
      }

      else if (res.items && res.items.length && url.includes('/update')) {
        resRelated = await fetchCart();
        if(resRelated.relatedProducts != undefined) {
          shopifyCart.relatedProducts = resRelated.relatedProducts
        }
      }

      const blacklistedCartProperties = ["items"]
      const blacklistedItemProperties = ["title", "subtitle", "featured_image", "image", "metafields", "tags"]

      // res is the entire cart object :
      // => update only first level cart properties
      // => remove deleted cart items from the local object.
      if (res.token || url.includes('/change')) {
        for (let prop in res) {
          if (blacklistedCartProperties.includes(prop))
            continue;

          let value = res[prop];
          shopifyCart[prop] = value;
        }

        let nonDeletedItems = [];
        for (let item of res.items) {
          var foundItem = shopifyCart.items.find(sci => sci.key == item.key);
          if (!foundItem) continue;

          nonDeletedItems.push(foundItem);
        }

        shopifyCart.items = nonDeletedItems;
      }

      // update items
      for (let i = 0; i < res.items.length; i++) {
        let item = res.items[i];
        let matchingCartItemIndex = shopifyCart.items.findIndex(currentItem => currentItem.key == item.key);

        // update existing item.
        if (matchingCartItemIndex > -1)
          for (let prop in item) {
            if (blacklistedItemProperties.includes(prop))
              continue;
              
            shopifyCart.items[matchingCartItemIndex][prop] = item[prop];
          }

        // add new item as is.
        else {
          shopifyCart.items.unshift(item);

          if(url.includes('/change')) {
            for (let index = 0; index < shopifyCart.items.length; index++) {
              if(shopifyCart.items[index].variant_id == item.variant_id && shopifyCart.items[index].key != item.key) {
                shopifyCart.items.splice(index, 1);
              }
            }
          }

          newItemsAdded = true;
        }
      }

      // Recalculate dynamic properties
      // Add 0 as initial value to the reducer as a work around when the cart contains only 1 element
      shopifyCart.original_total_price = shopifyCart.items.reduce((result, item) => parseInt(result.original_line_price  || result) + parseInt(item.original_line_price) , 0);
      shopifyCart.items_subtotal_price = shopifyCart.items.reduce((result, item) => parseInt(result.final_line_price     || result) + parseInt(item.final_line_price    ), 0);
      shopifyCart.total_discount       = shopifyCart.items.reduce((result, item) => parseInt(result.total_discount       || result) + parseInt(item.total_discount)      , 0);
      shopifyCart.total_weight         = shopifyCart.items.reduce((result, item) => parseInt(result.grams                || result) + parseInt(item.grams)               , 0);
      shopifyCart.item_count           = shopifyCart.items.reduce((result, item) => parseInt(result.quantity             || result) + parseInt(item.quantity)            , 0);
      shopifyCart.total_price          = shopifyCart.items_subtotal_price
      console.log(shopifyCart.items);

      return newItemsAdded;
    } catch (err){
      console.error("Error updating local cart object using the intercepted response", err)
    }
  }

  // TODO - update to allow adding multiple items at once & selling plans.
  Cart.prototype.addItem = async function (variant_id, quantity, properties, options) {
    const formData = {
      items: [{
        id: variant_id,
        quantity: quantity,
        properties: properties
      }]
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  // Find an item by key
  Cart.prototype.getItemByKey = function (key) {
    let cart = this.getCopyOfCart();
    return cart.items.find(item => item.key == key)
  }

  // Find an item by variant id
  Cart.prototype.getItemById = function (id) {
    let cart = this.getCopyOfCart();
    return cart.items.find(item => item.id == id)
  }

    /**
   * Replace a cart item with another (ex, upsell, convert one-off to subscription ...)
   *
   * @param {string} key                  The line_item key of the item currently in the cartManager
   * @param {string} id                   The variant id of the new item that should be added to the cartManager
   * @param {object} options              Replacement options.
   * @param {number} options.quantity     The new quantity to add, if a not set, the current quantity will be requested.
   * @param {object} options.properties   The new properties to add, if not set, the current properties will be added.
   * @param {object} options.selling_plan The new properties to add, if not set, the current properties will be added.
   */
  Cart.prototype.replaceItem = function (key, id, options, callback) {
    let currentItem = this.getItemByKey(key);
    let newItemInCart = this.getItemById(id);
    /* Build the new item to add. */
    /******************************/
    let itemToAdd = {
      id
    }
    itemToAdd.quantity     = options.quantity || currentItem.quantity;
    itemToAdd.properties   = options.properties || currentItem.properties || {};
    itemToAdd.selling_plan = options.selling_plan;
    /* Decide which operation(s): "update" or "update + add" */
    /*****************************************************/
    // if item has properties or selling plan, we can't use the UPDATE route.
    // if the variant is already in the cart, UPDATING quantity could override exiting item. (thus checking the newItemInCart)
    if (toolBox.isEmpty(itemToAdd.properties)
      && toolBox.isEmpty(itemToAdd.selling_plan)
      && !newItemInCart) {
      this.updateItems({
        type: this.CART_REQUEST_TYPES.UPDATE,
        items: [{key, quantity: 0}, itemToAdd]
      })
    } else {
      this.updateItems([
        {
          type: this.CART_REQUEST_TYPES.REMOVE,
          items: [{key}]
        },
        {
          type: this.CART_REQUEST_TYPES.ADD,
          items: [itemToAdd]
        }
      ], callback)
    }
  }
  /**
   * A list of requests that should be analysed for optimization before passing them to Shopify.
   *
   * @param {Object[]} requests                        The list of requests to be processed. (IF not array, it will be converted to an array with a single element)
   * @param {String}   requests[].type                 Enum of CART_REQUEST_TYPES
   * @param {Object[]} requests[].items                The list of items for which the action should be applied.
   * @param {String}   requests[].items[].id           Required only for CART_REQUEST_TYPES.ADD
   * @param {object}   requests[].items[].key          Required only for operations that updates existing line items i.e.  CART_REQUEST_TYPES.REMOVE or CART_REQUEST_TYPES.UPDATE
   * @param {object}   requests[].items[].quantity     Only required for CART_REQUEST_TYPES.ADD | Optional for CART_REQUEST_TYPES.UPDATE
   * @param {object}   requests[].items[].properties   Optional for CART_REQUEST_TYPES.ADD & CART_REQUEST_TYPES.Update | Not used for CART_REQUEST_TYPES.REMOVE
   * @param {object}   requests[].items[].selling_plan Optional for CART_REQUEST_TYPES.ADD & CART_REQUEST_TYPES.Update | Not used for CART_REQUEST_TYPES.REMOVE
   */
  Cart.prototype.updateItems = function (requests, onAllExecuted) {
    if (!Array.isArray(requests))
      requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {}
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: []
    };
    for (let request of requests) {
      let action = request.type;
      let items  = request.items;
      let attributes = request.attributes;
      if (action == this.CART_REQUEST_TYPES.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error("To add a new item both properties: ID & QUANTITY are required", item)
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity
          }
          if (typeof item.properties == 'object' && !toolBox.isEmpty(item.properties))
            cartItem.properties = item.properties;

          if (!toolBox.isEmpty(item.selling_plan))
            cartItem.selling_plan = item.selling_plan;
          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.CART_REQUEST_TYPES.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error("To update an existing item, both properties: KEY & QUANTITY are required", item)
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity
          }
          if (typeof item.properties == 'object' && !toolBox.isEmpty(item.properties))
            cartItem.properties = item.properties;

          // TODO: Test if a normal item can be converted to a subscription using the change request.
          if (!toolBox.isEmpty(item.selling_plan))
            cartItem.selling_plan = item.selling_plan;
          if (cartItem.properties || cartItem.selling_plan)
            shopifyRequestsList.push({
              type: this.CART_REQUEST_TYPES.CHANGE,
              body: cartItem
            });
          else
            shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
        if(attributes){
           for (i = 0; i < attributes.length; i++) {
              let attribute = attributes[i];
              console.log('Attribute : ', attribute);
              if(attribute.key && attribute.value){
                shopifyUpdateRequest.attributes[attribute.key] = attribute.value;
              }
        	}
        }
      } else if (action == this.CART_REQUEST_TYPES.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error("To remove an existing item KEY is required", item)
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
 
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.CART_REQUEST_TYPES.UPDATE,
        body: shopifyUpdateRequest
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.CART_REQUEST_TYPES.ADD,
        body: shopifyAddRequest
      });

    // Build a callback that will be executed at the end of each post call.
    // Attach a context that will be shared among all post requests.
    // Once all callbacks are executed, execute the main callback.
    // requestsCount is in an object so it could be updated as a reference not as a value.
    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = {requests_count: requestsCount};
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted()
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }
  }

  // Clear cart
  Cart.prototype.clearCart = function () {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  /**
   *
   * @param {Object}   formData                The body of the request. This function doesn't control the body, it is upon the user to make sure that the body corresponds with the action.
   * @param {Enum  }   action                  Based on this.CART_REQUEST_TYPES
   * @param {Object}   options
   * @param {Function} options.onSuccess       Called on success.
   * @param {Function} options.onFailure       Called on failure.
   * @param {Function} options.always          called always after success/failure
   * @param {bool}     options.disable_loader  Indicates whether the loader should be deactivated.
   */
  Cart.prototype.postShopify = function (formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue))
      self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData, action, options
    }
    self.requestsQueue.unshift(newRequest);

    // Quit if we're processing a request, the new request is added to the queue and should be handled at its turn.
    if (self.isUpdating)
      return;

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData  = currentRequest.formData;
    action    = currentRequest.action;
    options   = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {};
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {};
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {};


           if (action == this.CART_REQUEST_TYPES.ADD) {
      url = '/cart/add.js';
    } else if (action == this.CART_REQUEST_TYPES.UPDATE) {
      url = '/cart/update.js';
    } else if (action == this.CART_REQUEST_TYPES.CHANGE) {
      url = '/cart/change.js';
    } else if (action == this.CART_REQUEST_TYPES.CLEAR) {
      url = '/cart/clear.js';
    }
    // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(nextRequest.formData, nextRequest.action, nextRequest.options);
    }
    // Otherwise, end execution.
    else
      return console.error(`Can't post to Shopify. The action: ${action} is not valid`);

    var loaderEnabled = !!!options.disable_loader;

    // Activate loader.
    if (loaderEnabled)
      self.updateLoaderVisibilityState(true);

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    }).then(function (response) {
      if (response.ok)
        return response.json();
      throw Error(response.statusText);
    }).then(function (cart) {
      // logic moved to handleCartUpdates
      try {
        options.onSuccess();
      } catch (e) {
        console.error("Error executing onSuccess callback from postShopify", e);
      }

      return {cart}
    }).catch(function (error) {
      self.handleErrors(error);

      try {
        options.onFailure();
      } catch (e) {
        console.error("Error executing onFailure callback from postShopify", e);
      }

      return {err: error}
    }).finally(function () {
      try {
        options.always();
      } catch (e) {
        console.error("Error executing always callback from postShopify", e);
      }

      // Terminate loading.
      console.log(self.requestsQueue);
      if (loaderEnabled) {
        self.updateLoaderVisibilityState(false);
      }

      // Handle next request if there are any in the queue.
      if (self.requestsQueue.length) {
        const nextRequest = self.requestsQueue.pop();
        return self.postShopify(nextRequest.formData, nextRequest.action);
      }
    });
  }

  /**
   * Calculates shipping fee.
   * Ref: https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
   *
   * @param {Object} address       Address | Ref: Shopify address
   * @param {Bool}   saveAsAddress Indicates whether the entered address should be saved locally as the customer's address. (Helps in pre-filling checkout later.)
   *                               PS: why wouldn't we save any way ? because the entered address could be a fallback address that is not entered by the customer.
   * @param {Bool}   callback      TODO: REMOVE
   */
  Cart.prototype.calculateShipping = function (address, saveAsAddress, callback) {
    // TODO - each module should specifiy if it requires shipping calculation
    if (!shipping_data.enabled)
      return;

    // Save entered address in the browser's local storage (to avoid double netr)
    if (saveAsAddress) {
      // TODO chck if address is saved on INIT.
      this.addToVault(shipping_data.storage_key, address, true);
      //localStorage.setItem(shipping_data.storage_key, JSON.stringify(address));
      shipping_data.address = address;
    }

    // Build URL.
    let qa = [];
    for (let key in address) {
      qa.push(`shipping_address[${key}]=${address[key]}`)
    }

    let queryStringParams = qa.length? '?' + qa.join('&'):'';

    let path = "/cart/shipping_rates.json";

    var req = fetch(path + queryStringParams, {
      method: 'POST',
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(function (d) {
      // Save shipping options in memory.
      // TODO
      if(d.shipping_rates && d.shipping_rates.length) {
        shipping_data.rates = d.shipping_rates;
      } else {
        shipping_data.rates = null;
      }


      if (typeof callback === 'function')
        callback(d.shipping_rates, address)

      // TODO
      // Update dependents
    })
    .catch(err => {
      console.error("Opps, something worng happened.", err);

      if (typeof callback === 'function')
        callback("Couldn't fetch shipping rates.")
    })
  }

  /******************************************/
  /* PRIVATE FUNCTIONS */
  /******************************************/
  const getSettings = async function () {
    var res = await fetch(__configuration_url);
    return await res.json();
  }

  const fetchCart = async function (async) {
    var req = fetch(__cart_proxy);

    if (async) {
      return req.then(response => response.json())
    } else {
      var res = await req;
      return await res.json();
    }
  }

  const httpInterceptor = async function (urlmatchs, callback) {
    var responseMatchesAnyUrl = function (requestUrl, urls) {
      if (!Array.isArray(urls))
        urls = [urls];

      for (const url of urls) {
        if (!requestUrl.includes(url))
          continue;
        return true;
      }

      return false;
    }

    // Intercept fetch.
    const constantMock = window.fetch;
    window.fetch = function () {

      return new Promise((resolve, reject) => {
        constantMock.apply(this, arguments)
          .then(async (response) => {
            try {
              if (responseMatchesAnyUrl(response.url, urlmatchs) && response.type != "cors" && response.ok) {
                let json = await response.clone().json();
                if (typeof callback === "function")
                  await callback(json, response.url);
              }
            } catch (err) {
              console.error("Something went wrong while intercepting cart update", err);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      });
    }

    // Intercept Ajax.
    let send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('readystatechange', async function () {
        if (responseMatchesAnyUrl(this.responseURL, urlmatchs) && this.readyState === 4 && this.status == 200) {
          if (typeof callback === "function")
            await callback(JSON.parse(this.response), this.responseURL);
        }
      }, false);
      send.apply(this, arguments);
    };

    // TODO: Listen to HTML form submits.
    // Intercept HTML Forms.
    document.addEventListener("submit", function (e) {
      // Valid the target.
      if(!e.target || e.target.tagName.toLowerCase() !== "form" || e.target.matches('[sz-no-block]')) return;
      // Validate the URL.
      var form = e.target;
      var actionUrl = new URL(form.action);
      var actionPath = actionUrl.pathname;
      if (!actionPath.includes('/cart'))
        return;

      const XHR = new XMLHttpRequest();
      const FD = new FormData( form );
      const self = this;
      self.updateLoaderVisibilityState(true);
      // Define what happens on successful data submission
      XHR.addEventListener( "load", async function(event) {
        self.updateCartVisibilityState(true);
        self.updateLoaderVisibilityState(false);

        if (typeof callback === "function")
          await callback(undefined, form.action);
      } );
      // Define what happens in case of error
      XHR.addEventListener( "error", function( event ) {
        self.updateLoaderVisibilityState(false);
        console.log("Error submitting form", event);

        // Add a custom tag & resubmit the form in order to allow the site to handle the error.
        form.setAttribute('sz-no-block', "");
        form.submit();
      } );
      // Set up our request
      XHR.open( "POST", actionPath );
      // The data sent is what the user provided in the form
      XHR.send( FD );

      e.preventDefault();
    }.bind(this));
  }

  const dispatchEvent = function (event, data) {
    document.body.dispatchEvent(new CustomEvent(event, { bubbles: true, cancelable: true, detail: data }));
  }

  return Cart;

})();
